// SocialCheck — Jury-Demo i18n (DE / FR / IT / EN).
// Zentrale, sprachneutrale Quelle für ALLE Jury-Oberflächen (öffentliche
// Landing-Page + isoliertes Jury-Cockpit). Keine hartcodierten Benutzertexte
// in JSX. Backend liefert sprachneutrale Status-/Fehlercodes → hier übersetzt.

const de = {
  common: {
    loading: "Lädt…",
    retry: "Erneut versuchen",
    error: "Dieser Bereich konnte gerade nicht geladen werden. Bitte versuchen Sie es nochmals.",
    close: "Schliessen",
    cancel: "Abbrechen",
    all: "Alle",
    noTenant: "Kein Mandant ausgewählt.",
  },
  // Ampel (Kundenentscheidung) — rot | blau | orange | gruen | neutral
  ampel: {
    rot: { label: "Rot", sub: "Änderung/Blocker", full: "Rot · Änderung/Blocker" },
    blau: { label: "Blau", sub: "Offene Frage", full: "Blau · offene Frage" },
    orange: { label: "Orange", sub: "Wartet auf Freigabe", full: "Orange · wartet auf Freigabe" },
    gruen: { label: "Grün", sub: "Freigegeben", full: "Grün · freigegeben" },
    neutral: { label: "Neutral", sub: "Keine offene Freigabe", full: "Neutral · keine offene Freigabe" },
    unknown: "—",
  },
  // Kundensicherer Veröffentlichungsstatus
  cvs: {
    in_vorbereitung: "In Vorbereitung",
    zur_pruefung: "Zur Prüfung",
    in_bearbeitung: "In Bearbeitung",
    geplant: "Geplant",
    freigegeben: "Freigegeben",
    veroeffentlicht: "Veröffentlicht",
    kewag_pruefung: "KEWAG prüft",
    abgeschlossen: "Abgeschlossen",
    unknown: "—",
  },
  landing: {
    docTitle: "SocialCheck – Jury-Demo",
    kicker: "SocialCheck – Die Jury-Demo",
    heroTitle: "Social-Media-Freigaben für KMU in Deutschland, Österreich und der Schweiz –",
    heroAccent: "einfach wie eine Ampel.",
    subtitle: "KEWAG erstellt, plant und betreut die Social-Media-Inhalte. Der Kunde prüft, kommentiert, verlangt Änderungen oder gibt Beiträge über das einfache Ampel-Cockpit frei.",
    benefit: "SocialCheck macht Social Media für KMU in Deutschland, Österreich und der Schweiz einfacher, übersichtlicher und kontrollierbarer.",
    startBtn: "Jury-Demo starten",
    startGuided: "Jury-Demo starten",
    startSubline: "Geführter Rundgang · keine Anmeldung erforderlich · isolierter Demo-Mandant",
    viewControlOS: "KEWAG-Arbeitsbereich ansehen",
    viewCustomer: "Kundenansicht ansehen",
    starting: "Sitzung wird vorbereitet…",
    windowInfo: "Passwortlos · sofort startklar · endet automatisch nach 7 Tagen",
    inviteRequired: "Dieser Zugang ist abgesichert. Bitte öffnen Sie den offiziellen Einladungslink der KEWAG.",
    startedToast: "Isolierte Jury-Demo-Sitzung gestartet.",
    startFailed: "Demo konnte nicht gestartet werden.",
    endedNotice: "Ihre vorherige Sitzung wurde beendet (2h Inaktivität). Starten Sie einfach eine neue, isolierte Sitzung.",
    heroBadges: { days: "7 Tage verfügbar", isolated: "Isolierte Demo-Daten", noPublish: "Externe Veröffentlichung deaktiviert", devices: "Desktop & Mobile" },
    process: {
      title: "In drei Schritten erklärt",
      cards: [
        { n: "01", title: "KEWAG erstellt den Beitrag", desc: "Text, Bild, Plattform, Kunde und Veröffentlichungstermin werden zentral verwaltet." },
        { n: "02", title: "Der Kunde entscheidet per Ampel", desc: "Grün = freigegeben, Rot = Änderungswunsch, Blau = Frage/Kommentar, Orange = Entscheidung ausstehend." },
        { n: "03", title: "Alles bleibt synchron", desc: "Freigabestatus, Kalender, Kommentare, Verlauf und Reports nutzen denselben geprüften Datenstand." },
      ],
    },
    works: {
      title: "Was hier wirklich funktioniert",
      items: [
        "KEWAG Control OS & separates Kunden-Cockpit",
        "Echte Benutzerrollen & serverseitige Berechtigungen",
        "Geschützte Mandanten- und Kundentrennung",
        "Ampel-Freigaben mit Kommentaren & Verlauf",
        "Rote Änderungswünsche blockieren die weitere Freigabe",
        "Beiträge, Kalender, Medien & Reports",
        "Support-Prozess & Audit-Log",
        "Ehrliche Integrations- & Systemstatus-Anzeigen",
        "Desktop- & Mobile-Arbeitsabläufe",
        "Nur erlaubte Kundendaten in der Kundenansicht",
      ],
    },
    portals: {
      title: "Ein System – drei optimal verbundene Arbeitswelten",
      subtitle: "KEWAG Control OS, Kunden-Cockpit und SocialCheck Pocket – dieselben geprüften Daten, drei passende Ansichten.",
      kewag: { badge: "Intern", title: "KEWAG Control OS", desc: "So organisiert KEWAG Beiträge, Freigaben, Kalender und Reports.", cta: "KEWAG-Arbeitsbereich ansehen" },
      customer: { badge: "Kunde", title: "Kunden-Cockpit", desc: "So prüfen, kommentieren und entscheiden Kundinnen und Kunden per Ampel.", cta: "Kundenansicht ansehen" },
      pocket: { badge: "Mobil", title: "SocialCheck Pocket", desc: "So senden Kunden unterwegs Fotos und Informationen sicher direkt an KEWAG.", cta: "SocialCheck Pocket ansehen" },
    },
    why: {
      title: "Warum SocialCheck gebaut wurde",
      beforeTitle: "Vorher",
      beforeText: "Freigaben über verschiedene E-Mails, Nachrichten, Dateien und Rückfragen – schwer nachvollziehbar.",
      afterTitle: "Mit SocialCheck",
      afterText: "Ein zentraler Stand, klare Verantwortlichkeiten, einfache Kundenentscheidungen und ein nachvollziehbarer Verlauf.",
    },
    done: {
      title: "Vielen Dank – Sie haben SocialCheck vollständig erlebt.",
      subtitle: "Sie haben den geführten Jury-Rundgang durchlaufen. Hier ist Ihre Zusammenfassung.",
      checksTitle: "Das hat die Jury gesehen",
      checks: {
        start: "Sicherer, passwortloser Demo-Start",
        isolated: "Vollständig isolierte Jury-Sitzung",
        uebersicht: "SocialCheck Jury-Übersicht geöffnet",
        beitraege: "Beiträge & Vorschau geprüft",
        ampel: "Freigaben / Ampel (Grün, Rot, Blau) geöffnet",
        kalender: "Kalender, Monatsbericht & Integrationsstatus angesehen",
        pocket: "SocialCheck Pocket getestet",
        upload: "Foto sicher & isoliert übertragen",
        sync: "Synchronisierte, geprüfte Datenbasis erlebt",
        noPublish: "Keine externen Veröffentlichungen (serverseitig gesperrt)",
      },
      doneLabel: "erledigt",
      todoLabel: "nicht geöffnet",
      message: "SocialCheck ersetzt unübersichtliche Abstimmungen über E-Mail, WhatsApp und einzelne Dateien durch einen zentralen, sicheren und nachvollziehbaren Freigabeprozess.",
      restart: "Demo erneut starten",
      viewKewag: "KEWAG Control OS ansehen",
      viewCustomer: "Kunden-Cockpit ansehen",
      viewPocket: "SocialCheck Pocket ansehen",
      restartConfirmTitle: "Neue Demo-Sitzung starten?",
      restartConfirmText: "Es wird eine neue, isolierte Sitzung erstellt. Ihre bisherigen Demo-Daten (inkl. gesendeter Fotos) werden verworfen.",
      restartConfirmOk: "Neue Sitzung starten",
      cancel: "Abbrechen",
      shareTitle: "Teilen & mitnehmen",
      qrHint: "QR-Code zur Jury-Demo",
      copyLink: "Link kopieren",
      copiedToast: "Link kopiert.",
      downloadPdf: "Rundgang als PDF",
      endDemo: "Demo sicher beenden",
      endingToast: "Demo-Sitzung sicher beendet.",
      pdf: {
        title: "Jury-Demo · Zusammenfassung",
        checksTitle: "Das hat die Jury gesehen",
        aboutTitle: "Über SocialCheck",
        aboutText: "SocialCheck ist die zentrale, sichere Freigabe-Plattform für KMU in Deutschland, Österreich und der Schweiz: KEWAG erstellt und plant die Social-Media-Beiträge, Kundinnen und Kunden prüfen und entscheiden einfach per Ampel — Grün = freigeben, Rot = Änderungswunsch, Blau = Frage/Kommentar. Das ersetzt unübersichtliche Abstimmungen über E-Mail, WhatsApp und einzelne Dateien durch einen nachvollziehbaren, mandantengetrennten Prozess. Zusätzlich sendet SocialCheck Pocket Fotos unterwegs sicher direkt an KEWAG.",
        linkLabel: "Demo öffnen:",
        generatedOn: "Erstellt am",
        fileName: "SocialCheck-Jury-Demo.pdf",
      },
    },
    securityTitle: "Sicherheit & Transparenz",
    footerBadges: [
      "Ohne Passwort", "Nur Demo-Daten", "7 Tage verfügbar", "Sitzung nach 2h Inaktivität beendet",
      "Jederzeit neue Sitzung", "Keine externen Veröffentlichungen", "Kein Zugriff auf echte Kunden",
    ],
    closing: "Viel Spass beim Testen – wir sind überzeugt, Sie werden begeistert sein!",
    unavailableTitle: "Die SocialCheck Jury-Demo ist derzeit nicht verfügbar.",
    unavailableExpired: "Der Demo-Zeitraum ist abgelaufen.",
    unavailableDisabled: "Die Demo wurde vorübergehend deaktiviert.",
    unavailableInvite: "Gerne öffnen wir Ihnen den Zugang erneut.",
    demoPeriod: "Demo-Zeitraum",
    contactKewag: "KEWAG kontaktieren",
    backToWebsite: "Zur SocialCheck-Webseite",
    rd: {
      eyebrow: "SocialCheck · Social Media Made Simple",
      h1a: "Social Media erledigt.",
      h1b: "Freigabe so einfach wie eine Ampel.",
      heroSub: "KEWAG erstellt und betreut Ihre Social-Media-Inhalte. Sie prüfen, kommentieren und geben frei – in einem einfachen Cockpit für KMU in Deutschland, Österreich und der Schweiz.",
      trust: "Echte Funktionen · Isolierte Demo-Daten · Desktop & Mobile",
      ctaPrimary: "Jury-Demo starten",
      ctaSecondary: "Kundenansicht ansehen",
      shotFreigaben: "Ampel-Freigaben · Kunden-Cockpit",
      shotControlos: "KEWAG Control OS · Übersicht",
      shotCockpit: "Kunden-Cockpit · Übersicht",
      shotPocket: "SocialCheck Pocket",
      ampel: {
        title: "Ein Blick. Eine Entscheidung.",
        sub: "KEWAG bereitet den Beitrag vor. Der Kunde entscheidet. Alle Beteiligten sehen sofort den aktuellen Status.",
        green: { label: "Grün", state: "Freigegeben", desc: "Der Beitrag ist freigegeben und bereit zur Veröffentlichung." },
        orange: { label: "Orange", state: "Zur Prüfung", desc: "Wartet auf die Entscheidung des Kunden." },
        red: { label: "Rot", state: "Änderung gewünscht", desc: "Der Kunde wünscht eine Anpassung – KEWAG überarbeitet." },
        blue: { label: "Blau", state: "Frage / Kommentar", desc: "Eine offene Rückfrage oder ein Kommentar zum Beitrag." },
      },
      how: {
        title: "So funktioniert SocialCheck",
        sub: "Von der Idee bis zur Veröffentlichung – ein klarer, nachvollziehbarer Ablauf.",
        s1t: "KEWAG erstellt", s1d: "Content, Text, Bild, Plattform und Veröffentlichungszeit werden vorbereitet.",
        s2t: "Kunde prüft", s2d: "Ansehen, kommentieren, Änderungen verlangen oder direkt per Ampel freigeben.",
        s3t: "KEWAG veröffentlicht", s3d: "Freigaben, Kommentare, Kalender und Reports bleiben zentral nachvollziehbar.",
      },
      showcase: {
        title: "Ein System. Drei perfekt verbundene Arbeitswelten.",
        sub: "SocialCheck verbindet KEWAG, Kunde und mobile Nutzung in einem klaren Workflow.",
        controlosBadge: "KEWAG · Intern", controlosTitle: "KEWAG Control OS", controlosDesc: "KEWAG organisiert Kunden, Beiträge, Freigaben, Kalender und Reports zentral.", controlosCta: "KEWAG-Arbeitsbereich ansehen",
        cockpitBadge: "Kunde", cockpitTitle: "Kunden-Cockpit", cockpitDesc: "Der Kunde sieht nur das, was er wirklich braucht: prüfen, kommentieren und entscheiden.", cockpitCta: "Kundenansicht ansehen",
        pocketBadge: "Mobil", pocketTitle: "SocialCheck Pocket", pocketDesc: "Freigaben und Informationen jederzeit mobil im Blick.", pocketCta: "Mobile Ansicht ansehen",
      },
      platform: {
        eyebrow: "Plattform-Steuerung",
        title: "Eine zentrale Steuerung für Ihr Social-Media-Ökosystem.",
        sub: "Plattformen verbinden. Berechtigungen steuern. Integrationsstatus überwachen.",
        body: "SocialCheck bündelt Plattformverbindungen, Zugriffsrechte und Integrationsstatus an einem zentralen Ort. So kann KEWAG die technische Grundlage hinter jedem Kunden-Workflow zuverlässig verwalten.",
        shot: "KEWAG Control OS · Integrationen",
        cards: [
          { n: "01", t: "Plattform-Verbindungen", d: "Zentrale Verwaltung verbundener Plattformen und Dienste." },
          { n: "02", t: "Berechtigungen & Zugriff", d: "Klare Kontrolle darüber, wer welche Verbindung verwenden und verwalten darf." },
          { n: "03", t: "Integrationsstatus", d: "Verbindungsstatus erkennen und Probleme sehen, bevor sie den Workflow unterbrechen." },
        ],
        layersTitle: "Eine Plattform. Alle operativen Ebenen verbunden.",
        layers: [
          "KEWAG erledigt die Arbeit",
          "Kunden prüfen und geben frei",
          "SocialCheck steuert den Workflow",
          "Integrationen verbinden die operative Infrastruktur",
          "Berechtigungen halten den Zugriff unter Kontrolle",
          "Der Integrationsstatus hält den Betrieb zuverlässig",
        ],
      },
      why: {
        title: "Warum SocialCheck gebaut wurde",
        withoutTitle: "Ohne SocialCheck",
        withTitle: "Mit SocialCheck",
        without: ["E-Mails", "WhatsApp", "verstreute Dateien", "endlose Rückfragen", "unklare Freigaben", "verstreute Kommentare", "fehlende Übersicht"],
        with: ["Ein zentraler Status", "Klare Verantwortlichkeiten", "Nachvollziehbare Kommentare", "Ampel-Freigaben", "Kalender", "Reports", "Mobiler Zugriff"],
      },
      value: {
        title: "KEWAG macht die Arbeit. Der Kunde behält die Kontrolle.",
        p1t: "Weniger Aufwand", p1d: "Der Kunde muss Social Media nicht selbst organisieren.",
        p2t: "Klare Freigaben", p2d: "Jede Entscheidung ist sichtbar und nachvollziehbar.",
        p3t: "Skalierbarer Workflow", p3d: "Ein strukturierter Prozess für viele KMU, Beiträge und Plattformen.",
        sub: "Entwickelt für KMU in Deutschland, Österreich und der Schweiz. Konzipiert, um weiter zu skalieren.",
      },
      features: {
        title: "Alles, was die Zusammenarbeit einfach macht",
        items: [
          { t: "Getrennte KEWAG- und Kundenbereiche", d: "Interner Arbeitsbereich und Kundenansicht sauber getrennt." },
          { t: "Rollen & Berechtigungen", d: "Serverseitige Rechte für jede Person und jeden Mandanten." },
          { t: "Ampel-Freigaben", d: "Grün, Orange, Rot und Blau – Entscheidung auf einen Blick." },
          { t: "Kommentare & Änderungswünsche", d: "Rückmeldungen direkt am Beitrag, vollständig nachvollziehbar." },
          { t: "Kalender & Reports", d: "Geplante Beiträge und Monatsberichte aus einem Datenstand." },
          { t: "Desktop & Mobile", d: "Voller Zugriff am Schreibtisch und unterwegs." },
        ],
        disclaimer: "Demo-Daten isoliert · keine echten Kundendaten",
      },
      final: {
        title: "SocialCheck in Aktion.",
        sub: "Erleben Sie, wie einfach Social-Media-Freigaben sein können.",
        cta1: "Jury-Demo starten",
        cta2: "Kundenansicht öffnen",
        disclaimer: "Keine echten Kundendaten · sichere Demo-Umgebung",
      },
    },
  },
  banner: {
    title: "SocialCheck Jury-Demo",
    isolated: "Isolierte Sitzung",
    noPublish: "Keine externen Veröffentlichungen",
    timeout: "Sitzung endet nach 2h Inaktivität",
    until: "bis",
    restart: "Neue Demo starten",
    exit: "Demo beenden",
  },
  ticker: {
    title: "Live-Demo-Aktivität",
    sessionOne: "Sitzung aktiv",
    sessionMany: "Sitzungen aktiv",
    decisions: "Entscheidungen (48h)",
    caps: { gruen: "Freigeben", orange: "Zur Prüfung", rot: "Änderungswunsch", blau: "Frage / Kommentar" },
    events: { approved: "Beitrag freigegeben", change_requested: "Änderungswunsch gestellt", question: "Frage / Kommentar gestellt", reviewed: "Beitrag geprüft" },
    empty: "Seien Sie die erste Jury – jede Freigabe-Entscheidung erscheint hier live und anonymisiert.",
    footer: "Anonymisiert · keine echten Kundendaten · nur Jury-Demo-Aktivität",
    now: "gerade eben",
    minAgo: "vor {n} Min.",
    hrAgo: "vor {n} Std.",
  },
  nav: {
    section: "Jury-Demo",
    dashboard: "Übersicht",
    freigaben: "Freigaben / Ampel",
    beitraege: "Beiträge",
    kalender: "Kalender",
    report: "Monatsbericht",
    integrationen: "Integrationen",
    pocket: "SocialCheck Pocket",
  },
  tour: {
    progress: ["Übersicht", "Beiträge", "Ampel", "Kalender", "Pocket"],
    stationWord: "Station",
    ofWord: "von",
    next: "Weiter",
    back: "Zurück",
    finish: "Jury-Demo abschliessen",
    exit: "Demo beenden",
    safeBadge: "Jury-Demo · isolierter Demo-Mandant · sicher",
    stations: [
      { title: "SocialCheck Jury-Übersicht", desc: "Ihr Startpunkt: Stand aller Beiträge und die zentrale Ampel-Logik dieser isolierten Demo-Sitzung auf einen Blick." },
      { title: "Beiträge und Vorschau", desc: "Prüfen Sie die aufbereiteten Beiträge mit Live-Vorschau, Text, Bild, Kanälen und geplantem Termin – genau so, wie der Kunde sie sieht." },
      { title: "Freigaben / Ampel – Grün, Rot und Blau", desc: "Entscheiden Sie per Ampel: Grün = freigeben, Rot = Änderungswunsch, Blau = Frage/Kommentar. Testen Sie ruhig alle drei Reaktionen." },
      { title: "Kalender, Monatsbericht und Integrationsstatus", desc: "Sehen Sie, wie Kalender, Monatsbericht und der ehrliche Integrationsstatus denselben geprüften Datenstand nutzen (jederzeit über das Menü erreichbar)." },
      { title: "SocialCheck Pocket", desc: "Senden Sie unterwegs sicher ein Foto an KEWAG – als echter, aber vollständig isolierter Demo-Upload dieser Sitzung." },
    ],
  },
  pocketDemo: {
    badge: "Jury-Demo · isolierter Demo-Mandant · sicher",
    title: "SocialCheck Pocket",
    subtitle: "So senden Kundinnen und Kunden unterwegs Fotos sicher direkt an KEWAG.",
    securityNote: "Jury-Demo: Dieses Foto wird ausschliesslich in Ihrer isolierten Demo-Sitzung gespeichert und nach Ablauf automatisch gelöscht. Es wird nicht an echte Kunden oder externe Systeme übertragen.",
    take: "Foto aufnehmen",
    choose: "Aus Galerie wählen",
    dropTitle: "Foto hinzufügen",
    dropHint: "Aufnehmen oder aus der Galerie wählen",
    notePlaceholder: "Nachricht ergänzen (optional)…",
    send: "Sicher senden",
    uploading: "Wird sicher übertragen",
    change: "Anderes Foto",
    successToast: "Foto sicher in Ihrer Demo-Sitzung gespeichert.",
    errorType: "Bitte ein Bild auswählen (JPG, PNG, WEBP oder HEIC).",
    errorTooLarge: "Das Bild ist zu gross.",
    errorGeneric: "Upload fehlgeschlagen. Bitte erneut versuchen.",
    galleryTitle: "In dieser Demo-Sitzung gesendet",
    galleryEmpty: "Noch kein Foto gesendet.",
    isolatedBadge: "Nur in dieser Sitzung sichtbar",
    autoDelete: "Wird nach Sitzungsablauf automatisch gelöscht.",
  },
  mobile: {
    stationOf: "Station {n} von {t}",
    ofShort: "{n} von {t}",
    menuRestart: "Demo neu starten",
    menuEnd: "Demo sicher beenden",
    back: "Zurück",
    next: "Weiter",
    finish: "Demo abschliessen",
    langSheetTitle: "Sprache wählen",
    optionsAria: "Weitere Optionen",
    statusIsolated: "Isolierte Jury-Demo",
    pocketTitle: "Foto sicher an KEWAG senden",
    pocketText: "Foto aufnehmen oder auswählen – KEWAG erhält es sicher in dieser isolierten Demo.",
    securityToggle: "Sicherheit & Datenschutz",
    securityShort: "Das Foto wird nur in dieser isolierten Demo-Sitzung gespeichert und nach Ablauf automatisch gelöscht.",
    pwaTitle: "SocialCheck als App installieren",
    pwaIos: "Tippen Sie unten auf „Teilen“ und dann „Zum Home-Bildschirm“.",
    pwaAndroidCta: "Zur Startseite installieren",
    pwaGeneric: "Über das Browser-Menü „Zum Startbildschirm hinzufügen“.",
    pwaDismiss: "Später",
  },
  controlOS: {
    docTitle: "KEWAG Control OS – Jury-Demo",
    title: "KEWAG Control OS",
    subtitle: "Interner Arbeitsbereich – so verwaltet KEWAG die Beiträge dieses Mandanten.",
    badge: "Jury-Demo · isolierter Demo-Mandant · nur lesen",
    readOnlyNote: "Nur-Lese-Ansicht: In der Jury-Demo sind Bearbeiten, Freigeben und Veröffentlichen bewusst deaktiviert.",
    viewCustomerBtn: "So sieht es der Kunde",
    backBtn: "Zur Jury-Startseite",
    empty: "Keine Beiträge im Demo-Mandanten.",
    colPost: "Beitrag",
    colInternal: "Interner Produktionsstatus",
    colAmpel: "Ampel (Kundenentscheidung)",
    colCustomer: "Kundensichtbarer Status",
    colPlan: "Geplant",
    colChannels: "Kanäle",
    ownerKewag: "KEWAG",
    ownerCustomer: "Kunde",
    syncNote: "Interner Status und Kundensicht basieren auf demselben geprüften Datenstand.",
    psLabels: { entwurf: "Entwurf", in_arbeit: "In Arbeit", intern_in_pruefung: "Interne Prüfung", zur_freigabe: "Zur Freigabe", freigegeben: "Freigegeben", geplant: "Geplant", veroeffentlicht: "Veröffentlicht", fehlgeschlagen: "Fehlgeschlagen", pausiert: "Pausiert", archiviert: "Archiviert" },
    ampLabels: { rot: "Rot", blau: "Blau", orange: "Orange", gruen: "Grün", neutral: "Neutral" },
    cvsLabels: { in_vorbereitung: "In Vorbereitung", zur_pruefung: "Zur Prüfung", in_bearbeitung: "In Bearbeitung", geplant: "Geplant", freigegeben: "Freigegeben", veroeffentlicht: "Veröffentlicht", kewag_pruefung: "KEWAG prüft", abgeschlossen: "Abgeschlossen" },
  },
  integrations: {
    docTitle: "SocialCheck – KEWAG Social Gateway (Jury-Demo)",
    title: "KEWAG Social Gateway",
    subtitle: "Live-Status der zentralen Social-Anbindung – vollständig serverseitig geprüft, ehrlich und ohne externe Veröffentlichungen.",
    error: "Gateway-Status ist hier nicht verfügbar.",
    gatewayTitle: "KEWAG Social Gateway",
    gatewayLabel: "Zentrale Anbindung für alle sozialen Plattformen",
    statusBadge: { ready: "Betriebsbereit", checking: "Wird geprüft", action_required: "Aktion nötig", inactive: "Inaktiv" },
    readiness: "{passed}/{total} Systemprüfungen bestanden",
    lastChecked: "Zuletzt geprüft",
    refresh: "Aktualisieren",
    autoRefresh: "Aktualisiert automatisch alle 30 Sek.",
    publishOff: "Externe Veröffentlichung serverseitig deaktiviert",
    checksTitle: "Systemprüfungen (live, serverseitig)",
    checks: {
      approval_workflow: { title: "Freigabe-Workflow", desc: "Freigabe-Workflow serverseitig aktiv." },
      comments_history: { title: "Kommentare & Verlauf", desc: "Kommentare und Verlauf serverseitig verfügbar." },
      calendar_sync: { title: "Kalender-Synchronisation", desc: "Kalender-Synchronisation intern funktionsfähig." },
      report_sync: { title: "Report-Synchronisation", desc: "Monatsbericht intern funktionsfähig." },
      tenant_isolation: { title: "Mandantentrennung", desc: "Mandantentrennung serverseitig aktiv." },
      session_isolation: { title: "Sitzungstrennung", desc: "Sitzungstrennung serverseitig aktiv." },
      external_publishing_off: { title: "Externe Veröffentlichung", desc: "Externe Veröffentlichung serverseitig deaktiviert." },
      real_data_locked: { title: "Echtdaten gesperrt", desc: "Echtdaten für die Jury gesperrt." },
    },
    states: { functional: "Funktionsfähig", active: "Aktiv", disabled: "Deaktiviert", locked: "Gesperrt", checking: "Wird geprüft", action_required: "Handlungsbedarf" },
    providersTitle: "Plattform-Anbindungen (ehrlicher Status)",
    providerStates: {
      connected: "Verbunden",
      prepared: "Vorbereitet – noch nicht verbunden",
      credentials_missing: "Zugangsdaten fehlen – nicht verbunden",
      adapter_prepared: "Adapter vorbereitet",
    },
    actionsTitle: "Handlungsbedarf",
    noActions: "Keine offenen Handlungsbedarfe – alle notwendigen Prüfungen bestanden.",
    actions: {
      enable_gateway: "Gateway aktivieren.",
      disable_publishing: "Externe Veröffentlichung deaktivieren (in der Jury-Demo Pflicht).",
      fix_tenant_isolation: "Mandantentrennung wiederherstellen.",
      fix_session_isolation: "Sitzungstrennung wiederherstellen.",
      fix_real_data_locked: "Echtdaten-Sperre wiederherstellen.",
    },
    securityTitle: "Sicherheit & Transparenz",
    notes: {
      isolated_demo_only: "Es werden ausschliesslich isolierte Demo-Daten angezeigt.",
      tenant_isolation: "Mandantentrennung aktiv – kein Zugriff auf echte Kunden.",
      no_external_publishing: "Externe Veröffentlichungen sind serverseitig hart deaktiviert.",
      no_false_status: "Kein falscher „verbunden“-Status – maximale Transparenz.",
    },
  },
  kalender: {
    ampelOpts: { rot: "Rot — Änderungswunsch", blau: "Blau — Offene Frage", orange: "Orange — Wartet auf Freigabe", gruen: "Grün — Freigegeben", neutral: "Neutral" },
    prodOpts: { entwurf: "Entwurf", in_arbeit: "In Arbeit", intern_in_pruefung: "Intern in Prüfung", zur_freigabe: "Zur Freigabe", freigegeben: "Freigegeben", geplant: "Geplant", veroeffentlicht: "Veröffentlicht", fehlgeschlagen: "Fehlgeschlagen", pausiert: "Pausiert", archiviert: "Archiviert" },
    kundeAll: "Kunde: Alle", ampelAll: "Ampel: Alle", prodAll: "Produktionsstatus: Alle", verantwortlichAll: "Verantwortlich: Alle",
    ampelHeading: "Ampel — Kundenentscheidung", prodHeading: "Produktionsstatus — intern", noActiveDecision: "Keine aktive Kundenentscheidung", prodUnavailable: "Status nicht verfügbar",
    verValid: "Freigabe gilt für diese Version", verStale: "Inhalt wurde geändert – erneute Kundenfreigabe erforderlich", verNone: "Noch keine Freigabe für diese Version",
    customerViewTitle: "So sieht es der Kunde", customerPrep: "In Vorbereitung", customerViewHint: "Diese Anzeige wird im Kunden-Cockpit verwendet.", lastViewed: "Zuletzt vom Kunden angesehen:", notViewed: "Vom Kunden noch nicht angesehen",
    openCustomerPreview: "Kunden-Vorschau öffnen", previewLocked: "Für den Kunden noch nicht freigeschaltet — Vorschau verfügbar, sobald der Beitrag zur Freigabe bereitsteht.",
    internalNote: "Interne Notiz (nur KEWAG)", edit: "Bearbeiten", save: "Speichern", cancel: "Abbrechen", noInternalNote: "Keine interne Notiz.", duplicate: "Duplizieren", markOpen: "Als offen markieren", markDone: "Als erledigt markieren",
    title: "Social-Kalender",
    views: { monat: "Monat", woche: "Woche", liste: "Liste" },
    wochenplan: "Wochenplan",
    kpi: {
      zur_freigabe: { label: "Zur Freigabe", sub: "Wartet auf Ihre Freigabe" },
      freigegeben: { label: "Freigegeben", sub: "Bereit / geplant" },
      diese_woche_geplant: { label: "Diese Woche geplant", sub: "Geplante Beiträge" },
      veroeffentlicht: { label: "Veröffentlicht", sub: "Bereits live" },
      alle: "Alle Beiträge", inRange: "In diesem Zeitraum",
    },
    kpiInternal: {
      zur_freigabe: { label: "Zur Freigabe", sub: "Wartet auf Kunde" },
      aenderungen: { label: "Änderungen offen", sub: "Änderungswunsch" },
      diese_woche_geplant: { label: "Diese Woche geplant", sub: "Geplante Beiträge" },
      fragen: { label: "Fragen / Kommentare", sub: "Offene Rückfragen" },
    },
    probleme: "Probleme",
    newPost: "Neuer Beitrag",
    noProblems: "Keine offenen Probleme",
    resendForApproval: "Erneut zur Freigabe senden",
    onlyBooked: "Nur gebuchte Kanäle",
    notBooked: "nicht gebucht",
    notBookedTitle: "Nicht gebuchte Plattform(en): {labels}. Als Zusatzkanal buchbar.",
    wp: {
      title: "Wochenplan · Diese Woche",
      desc: "{name} · Vorschau der geplanten Veröffentlichungen (Mo–So). Teilbar als PDF.",
      thisWeek: "Diese Woche",
      posts: "Beiträge",
      approvedPlanned: "freigegeben/geplant",
      published: "veröffentlicht",
      awaitingApproval: "zur Freigabe",
      loading: "Lädt…",
      today: "Heute",
      noPosts: "— keine Beiträge —",
      liveNote: "Status entspricht 1:1 dem aktuellen Freigabe-Stand — echte Live-Daten.",
      creating: "Erstellt…",
      downloadPdf: "Als PDF herunterladen",
      postCountOne: "{n} Beitrag",
      postCountMany: "{n} Beiträge",
      weekdaysFull: ["Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag", "Sonntag"],
      locale: "de-CH",
    },
    search: "Suche in Titel, Text…",
    chooseRange: "Zeitraum wählen", thisWeek: "Diese Woche", nextWeek: "Nächste Woche",
    von: "Von", bis: "Bis", reset: "Zurücksetzen", apply: "Übernehmen",
    overdueOnly: "Nur überfällige", statusAll: "Status: Alle", platformAll: "Plattform: Alle", resetFilters: "Filter zurücksetzen",
    today: "Heute", loading: "Lädt…", emptyFilter: "Keine Beiträge im Filter.", more: "mehr", paginationUnit: "Beiträgen",
    autoPublished: "Auto veröffentlicht", lastUpdate: "Letzte Aktualisierung", refresh: "Aktualisieren", weekFrom: "Woche ab",
    state: { entwurf: "Entwurf", zur_freigabe: "Wartet auf Ihre Freigabe", freigegeben: "Freigegeben", aenderungswunsch: "Änderungswunsch", frage: "Frage / Kommentar", veroeffentlicht: "Veröffentlicht" },
    stateStaff: { entwurf: "Entwurf", zur_freigabe: "Zur Freigabe", freigegeben: "Freigegeben", aenderungswunsch: "Änderungswunsch", frage: "Frage / Kommentar", veroeffentlicht: "Veröffentlicht" },
    weekdays: ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"],
    detailEmpty: "Beitrag auswählen, um Details zu sehen.", plannedFor: "Geplant für:",
    customerComment: "Kundenkommentar", noCustomerComment: "Noch kein Kundenkommentar.", by: "von",
    decisionTitle: "Kundenentscheidung",
    dueOverdue: "Überfällig seit {d} — bitte zeitnah freigeben.",
    dueHint: "Bitte bis {d} freigeben, sonst verschiebt sich die Veröffentlichung.",
    approve: "Als freigegeben markieren", requestRed: "Änderungswunsch (Rot)", questionBlau: "Frage / Kommentar (Blau)",
    noApproval: "Keine Freigabe offen.", askAnytime: " — Sie können jederzeit eine Frage stellen.", question: "Frage / Kommentar",
    dlgRedTitle: "Änderungswunsch erfassen", dlgRedDesc: "Bitte den Änderungswunsch festhalten (Pflicht). Das KEWAG Team kümmert sich darum.", phRed: "Ihr Änderungswunsch…", submitRed: "Änderungswunsch senden",
    dlgBlauTitle: "Frage / Kommentar", dlgBlauDesc: "Stellen Sie eine Frage oder hinterlassen Sie einen Kommentar zu diesem Beitrag.", phBlau: "Ihre Frage oder Ihr Kommentar…", submitBlau: "Senden",
    historyTitle: "Ampel-Verlauf", noEvents: "Noch keine Ereignisse.", showLess: "Weniger anzeigen", showFull: "Vollständigen Verlauf anzeigen",
    noTenant: "Kein Mandant ausgewählt.",
    staff: {
      decGreen: "Als freigegeben markiert.", decRed: "Änderungswunsch erfasst.", decBlau: "Frage / Kommentar erfasst.", decAmber: "Erneut an Kunde gesendet.",
      reminderSent: "Erinnerung an Kunde gesendet.", noteSaved: "Notiz gespeichert.", duplicated: "Beitrag dupliziert (als Entwurf).", markedDone: "Als erledigt markiert.", markedOpen: "Als offen markiert.",
      noTenantForPreview: "Kein Mandant für die Kundensicht gefunden.", titleRequired: "Titel erforderlich", postCreated: "Beitrag erstellt (Status: Entwurf)",
      wpDownloaded: "Wochenplan als PDF heruntergeladen.", wpFailed: "PDF konnte nicht erstellt werden.",
      fAvgOrange: "Ø Antwortzeit Orange", fAvgRed: "Ø Antwortzeit Rot", fAvgBlau: "Ø Antwortzeit Blau", fAvgTotal: "Antwortzeit (Gesamt)",
      fApprovedToday: "Freigegeben heute", fPlanned: "Geplante Beiträge", fPublishedWeek: "Veröffentlicht diese Woche", unitDays: "Tage", unitHours: "Std.",
      createTitle: "Neuen Beitrag erstellen", fTitle: "Titel", fChannel: "Kanal", fSchedule: "Geplant am", fContent: "Inhalt", saving: "Speichert…", create: "Erstellen",
    },
  },
  beitraege: {
    colAmpel: "Ampel", colResponsible: "Verantwortlich", editAction: "Bearbeiten", submitReviewAction: "Zur Freigabe senden",
    submitReviewShort: "Zur Freigabe", markPublished: "Als veröffentlicht markieren", archiveAction: "Archivieren", unarchiveAction: "Wiederherstellen",
    newPost: "Beitrag erstellen", reminders: "Erinnerungen", reminderConfigTitle: "Freigabe-Erinnerungen konfigurieren", respAll: "Alle",
    internalNoteLabel: "Interne Notiz (nur KEWAG)", categoryLabel: "Kategorie",
    ws: { zur_freigabe: "Wartet auf Ihre Freigabe", freigegeben: "Freigegeben", veroeffentlicht: "Veröffentlicht", aenderungswunsch: "Änderungswunsch" },
    kpi: { alle: "Alle Beiträge", zur_freigabe: "Wartet auf Freigabe", freigegeben: "Freigegeben", veroeffentlicht: "Veröffentlicht", aenderungswunsch: "Änderungswunsch" },
    noTenant: "Kein Mandant zugeordnet.",
    pageSubtitle: "Alle Beiträge von {name} — prüfen, freigeben und Rückmeldung geben.",
    loadError: "Beiträge konnten nicht geladen werden",
    ampelPrefix: "Ampel: ",
    overdue: "Überfällig", dueUntil: "Freigabe bis",
    colTitle: "Titel", colChannel: "Kanal", colStatus: "Status", colPlanned: "Geplant für", colActions: "Aktionen",
    untitled: "Ohne Titel", notScheduled: "Nicht geplant", emptyList: "Keine Beiträge gefunden.", previewAction: "Vorschau",
    allChannels: "Alle Kanäle", search: "Beiträge suchen...", resetFilters: "Filter zurücksetzen",
    countOne: "Beitrag", countMany: "Beiträge",
    previewEmpty: "Keinen Beitrag ausgewählt.", previewTitle: "Beitrags-Vorschau",
    bodyLabel: "Beitragstext", showMore: "Mehr anzeigen", showLess: "Weniger anzeigen",
    platforms: "Plattformen", plannedTime: "Geplanter Veröffentlichungszeitpunkt", customerNote: "Kundenhinweis",
    decTitle: "Ihre Entscheidung", decWaiting: "Dieser Beitrag wartet auf Ihre Freigabe.",
    decNoAction: "Keine Aktion offen.", decAskAnytime: "Sie können jederzeit eine Frage stellen.",
    decOverdue: "Überfällig seit {d} — bitte zeitnah freigeben, damit die Veröffentlichung nicht weiter verschoben wird.",
    decDueHint: "Bitte bis {d} freigeben, sonst verschiebt sich die Veröffentlichung.",
    decApprove: "Freigeben", decRequest: "Änderung anfordern", decQuestion: "Frage / Kommentar",
    dlgRequestTitle: "Änderung anfordern", dlgRequestDesc: "Bitte beschreiben Sie kurz, was angepasst werden soll. Das KEWAG Team kümmert sich darum.",
    phRequest: "Ihr Änderungswunsch…", submitRequest: "Änderungswunsch senden",
    dlgQuestionTitle: "Frage / Kommentar", dlgQuestionDesc: "Stellen Sie eine Frage oder hinterlassen Sie einen Kommentar zu diesem Beitrag.",
    phQuestion: "Ihre Frage oder Ihr Kommentar…", submitQuestion: "Senden", actionFailed: "Aktion fehlgeschlagen",
    historyTitle: "Statusverlauf", noEvents: "Noch keine Ereignisse.", comments: "Kommentare", noComments: "Noch keine Kommentare.",
    you: "Sie", kewagTeam: "KEWAG Team",
    toastApproved: "Freigegeben — vielen Dank!", toastRequested: "Änderungswunsch gesendet", toastQuestion: "Ihre Nachricht wurde gesendet",
    bulkWaitingOne: "Beitrag wartet", bulkWaitingMany: "Beiträge warten", bulkOnYou: "auf Ihre Freigabe",
    selected: "ausgewählt", selectBtn: "Auswählen", approveAllN: "Alle {n} freigeben", markAll: "Alle markieren",
    approveN: "{n} freigeben", approveBtn: "Freigeben", requestChange: "Änderung anfordern",
    bulkConfirmTitle: "Beiträge freigeben",
    bulkConfirmDesc: "Prüfen Sie die Auswahl. Sie können einzelne Beiträge abwählen — nur die angehakten Beiträge werden zur Veröffentlichung durch das KEWAG Team freigegeben.",
    bulkSelectedOf: "{a} von {b} {unit} ausgewählt", selectAll: "Alle auswählen", deselectAll: "Alle abwählen",
    noWaiting: "Keine wartenden Beiträge.", cancel: "Abbrechen",
    approvePostOne: "1 Beitrag freigeben", approvePostN: "{n} Beiträge freigeben",
    bulkResultTitle: "Ergebnis der Sammel-Freigabe", bulkResultDesc: "Nicht alle Beiträge konnten freigegeben werden. Nachfolgend sehen Sie das Ergebnis pro Beitrag.",
    rSelected: "Ausgewählt", rApproved: "Freigegeben", rSkipped: "Übersprungen", rFailed: "Fehlgeschlagen",
    requestSkipped: "Übersprungene zur Überarbeitung anfragen", retry: "Erneut versuchen", close: "Schliessen",
    bulkRequestTitle: "Sammel-Änderungswunsch",
    bulkRequestDesc: "Ihr Hinweis wird auf alle {n} ausgewählten Beiträge angewendet. Das KEWAG Team überarbeitet sie entsprechend.",
    phBulkRequest: "Was soll bei diesen Beiträgen angepasst werden?", sendChangeRequest: "Änderungswunsch senden",
    toastBulkApprovedOne: "1 Beitrag erfolgreich freigegeben.", toastBulkApprovedMany: "{n} Beiträge erfolgreich freigegeben.",
    toastBulkNone: "Kein offener Beitrag zur Überarbeitung – die Beiträge sind bereits abgeschlossen.",
    toastBulkRequestedOne: "Änderungswunsch für 1 Beitrag gesendet", toastBulkRequestedMany: "Änderungswunsch für {n} Beiträge gesendet",
    bulkApproveFailed: "Sammel-Freigabe fehlgeschlagen", bulkRequestFailed: "Sammel-Änderungswunsch fehlgeschlagen",
    staff: {
      statusUpdated: "Status aktualisiert", statusChangeFailed: "Statusänderung fehlgeschlagen",
      archived: "Beitrag archiviert", archiveFailed: "Archivieren fehlgeschlagen", unarchived: "Beitrag wiederhergestellt", unarchiveFailed: "Wiederherstellen fehlgeschlagen",
      remindSentEmail: "Erinnerung für {posts} Beiträge an {recipients} Empfänger:innen gesendet", remindSentInApp: "In-App-Erinnerung für {posts} Beiträge gesendet (E-Mail-Versand nicht konfiguriert)", remindFailed: "Erinnerung fehlgeschlagen",
      settingsLoadFailed: "Einstellungen konnten nicht geladen werden", settingsSaved: "Erinnerungs-Einstellungen gespeichert", saveFailed: "Speichern fehlgeschlagen",
      waitingOne: "Beitrag wartet", waitingMany: "Beiträge warten", onCustomerApproval: "auf Kundenfreigabe", remindCustomers: "Kund:innen erinnern",
      reminderDialogTitle: "Freigabe-Erinnerungen", reminderDialogDesc: "Steuern Sie, wann und wie oft Kund:innen automatisch an offene Freigaben erinnert werden.",
      autoRemindActive: "Automatische Erinnerungen aktiv", daysToFirst: "Tage bis 1. Erinnerung", intervalDays: "Intervall (Tage)", maxCount: "Max. Anzahl",
      reminderExample: "Beispiel: erste Erinnerung nach {wait} Tag(en), danach alle {interval} Tag(e), höchstens {max}×.",
      dueLeadLabel: "Freigabe-Fälligkeit: Vorlauf vor Veröffentlichung (Tage)", dueLeadHint: "Kund:innen sehen „Bitte bis TT.MM. freigeben“ — {days} Tag(e) vor dem geplanten Veröffentlichungstermin.",
      cancel: "Abbrechen", save: "Speichern",
    },
  },
  freigaben: {
    title: "Ampel-Freigaben",
    subtitle: "Ihre Beiträge zur Freigabe – Sie entscheiden, KEWAG setzt um.",
    kpiWartet: "Wartet auf Freigabe",
    kpiAenderung: "Änderungswünsche",
    kpiHeute: "Heute fällig",
    kpiMonat: "Diesen Monat freigegeben",
    vsPrev: "vs Vormonat",
    emptyTitle: "Aktuell keine Beiträge zur Freigabe.",
    emptyDesc: "Sobald KEWAG einen Beitrag für Sie bereitstellt, erscheint er hier.",
    allDoneTitle: "Alles erledigt",
    allDoneDesc: "Sie haben alle offenen Freigaben entschieden. KEWAG setzt Ihre Entscheidungen um.",
    allDoneToast: "Alles erledigt – keine offenen Freigaben mehr.",
    progressLabel: "{done} von {total} erledigt",
    inboxTitle: "Freigabe-Eingang",
    previewTitle: "Live-Vorschau",
    versionsMany: "Frühere Fassungen ({n})",
    versionsOne: "Freigegebene Fassung ansehen",
    selectPost: "Bitte einen Beitrag auswählen.",
    planned: "Geplant",
    channels: "Kanäle",
    decisionTitle: "Entscheidung & Rückmeldung",
    yourFeedback: "Ihre Rückmeldung",
    nextStep: "Nächster Schritt",
    yourDecision: "Ihre Entscheidung",
    contactPerson: "Ansprechpartner",
    appointment: "Termin",
    approve: "Freigeben",
    approveDesc: "Inhalt ohne Änderungen freigeben.",
    conditions: "Freigabe mit Auflagen",
    conditionsDesc: "Mit Kommentar freigeben.",
    reject: "Nicht freigeben",
    rejectDesc: "Änderungswunsch senden.",
    readOnlyNote: "Nur-Lese-Modus (Kundensicht) – Aktionen sind deaktiviert.",
    cannotDecide: "Ihre Rolle kann Beiträge nicht freigeben (nur Ansicht).",
    doneApproved: "Sie haben diesen Beitrag freigegeben.",
    donePublished: "Dieser Beitrag wurde veröffentlicht.",
    doneChangeRequested: "Änderungswunsch gesendet – KEWAG überarbeitet den Beitrag.",
    historyTitle: "Freigabe-Verlauf",
    noHistory: "Noch kein Verlauf.",
    trustTitle: "Von KEWAG geprüft",
    trustDesc: "Jeder Beitrag wird vor Ihrer Freigabe von KEWAG auf Bild- & Videoqualität, Text, Branding, Links und Call-to-Action geprüft.",
    detailsTitle: "Details",
    createdBy: "Erstellt von",
    kewagTeam: "KEWAG Team",
    plannedOn: "Geplant am",
    attachment: "Anhang",
    oneImage: "1 Bild",
    versionHistoryTitle: "Freigabe-Historie",
    versionHistoryDesc: "Die Fassungen, die KEWAG Ihnen zur Freigabe bereitgestellt hat. So sehen Sie jederzeit, was Sie in jeder Runde erhalten haben.",
    noVersions: "Keine Fassungen vorhanden.",
    version: "Fassung",
    current: "aktuell",
    firstVersion: "Erste bereitgestellte Fassung",
    minorChanges: "Kleinere Anpassungen",
    adjusted: "{parts} angepasst",
    comparedTo: "Gegenüber Fassung {n}:",
    provided: "Bereitgestellt",
    scheduledShort: "Geplant",
    note: "Hinweis",
    changes: { text: "Text", image: "Bild", appointment: "Termin", channels: "Kanäle", category: "Kategorie", note: "Hinweis" },
    dlgRejectTitle: "Änderungswunsch senden",
    dlgConditionsTitle: "Freigabe mit Auflagen",
    dlgRejectDesc: "Was soll geändert werden? Ihr Hinweis geht direkt an KEWAG (Pflichtfeld).",
    dlgConditionsDesc: "Optionaler Hinweis / Auflage. Der Beitrag wird freigegeben und Ihr Kommentar an KEWAG übermittelt.",
    phReject: "Ihr Änderungswunsch…",
    phConditions: "Ihre Auflage / Ihr Hinweis…",
    submitReject: "Änderungswunsch senden",
    submitConditions: "Mit Auflagen freigeben",
    toastConditions: "Mit Auflagen freigegeben – KEWAG wurde informiert.",
    toastRejected: "Änderungswunsch gesendet.",
    toastApproved: "Beitrag freigegeben.",
    due: { none: "Kein Termin", overdue: "Überfällig", today: "Heute fällig" },
    events: { provided_for_approval: "Zur Freigabe bereitgestellt", approved: "Freigegeben", published: "Veröffentlicht", change_requested: "Änderungswunsch gesendet" },
  },
  medien: {
    docTitle: "SocialCheck – Medien (Jury-Demo)",
    title: "Medien-Demo",
    subtitle: "Beispielhafte Medienbibliothek der Demo. Uploads und Löschungen sind in der Jury-Demo deaktiviert.",
    badge: "Nur Anzeige · isolierte Demo-Daten",
    empty: "Keine Medien vorhanden.",
    kindImage: "Bild",
  },
  report: {
    empty: "Kein Mandant ausgewählt.",
    loading: "Lädt…",
    title: "Monatsreport",
    month: "Monat",
    downloadPdf: "PDF herunterladen",
    creating: "Erstellt…",
    emailSend: "Per E-Mail senden",
    sending: "Sendet…",
    emailNotConnected: "Per E-Mail (Brevo nicht verbunden)",
    emailSendTitle: "An {email} senden",
    noContactTitle: "Kein Kontakt hinterlegt",
    brevoNotConnectedTitle: "Brevo (E-Mail) noch nicht verbunden",
    goalTitle: "Monatsziel",
    reached: "erreicht",
    goalPlanned: "Beiträge geplant",
    goalPublished: "veröffentlicht",
    goalChangeReqOpen: "Änderungswunsch offen",
    goalQuestions: "Rückfragen",
    progress: "Fortschritt",
    waitOne: "Beitrag wartet",
    waitMany: "Beiträge warten",
    waitSuffix: "auf Ihre Freigabe",
    reportMonthBar: "Berichtsmonat {month} · nur offene (Orange) Beiträge dieses Monats",
    approveAllBtn: "Alle offenen Beiträge dieses Monats freigeben",
    kpiTotal: "Beiträge gesamt",
    kpiChangeReq: "Änderungswünsche",
    kpiForApproval: "Zur Freigabe",
    kpiApproved: "Freigegeben",
    kpiPublished: "Veröffentlicht",
    vs: "vs.",
    tabs: { uebersicht: "Übersicht", beitraege: "Beiträge", kanaele: "Kanäle", engagement: "Engagement", performance: "Performance", bestzeiten: "Bestzeiten", ziele: "Ziele", downloads: "Downloads" },
    allChannels: "Alle Kanäle",
    allPlatforms: "Alle Plattformen",
    allAmpel: "Alle Ampeln",
    ampelFilter: { rot: "Rot — Änderungswunsch / Blocker", blau: "Blau — Offene Frage / Klärung", orange: "Orange — Wartet auf Freigabe", gruen: "Grün — Freigegeben", neutral: "Neutral — Keine Entscheidung" },
    allStatus: "Alle Status",
    allResponsible: "Alle Verantwortlichen",
    searchTitles: "Suche in Titeln…",
    resetFilters: "Filter zurücksetzen",
    ampelStatusTitle: "Ampel & Status",
    shortOverview: "Kurzüberblick:",
    ofPosts: "Von {total} Beiträgen —",
    yourDecisions: "Ihre Entscheidungen:",
    publication: "Veröffentlichung:",
    ampelColTitle: "Ampel — Ihre Entscheidung",
    veroeffColTitle: "Veröffentlichungsstatus",
    noPostsMonth: "Keine Beiträge in diesem Monat.",
    ampelStatusNote: "Die Ampel zeigt Ihre Entscheidung, der Status zeigt, wo Ihr Beitrag im Prozess steht — beide sind unabhängig. „Veröffentlicht“ ist ein Status, keine Ampel.",
    ampelMeaning: { rot: "Änderungswunsch / Blocker", blau: "Offene Frage / Klärung", orange: "Wartet auf Ihre Freigabe", gruen: "Aktuelle Version freigegeben", neutral: "Keine aktive Entscheidung" },
    plainAmpel: { gruen: "von Ihnen freigegeben", orangeOne: "wartet auf Ihre Freigabe", orangeMany: "warten auf Ihre Freigabe", rot: "mit Änderungswunsch", blau: "mit offener Frage", neutral: "ohne offene Entscheidung", empty: "keine offenen Entscheidungen" },
    plainStatus: { veroeffentlicht: "veröffentlicht", geplant: "geplant", freigegeben: "freigegeben (bereit)", zur_pruefung: "zur Prüfung", in_bearbeitung: "in Bearbeitung", in_vorbereitung: "in Vorbereitung", kewag_pruefung: "in KEWAG-Prüfung", abgeschlossen: "abgeschlossen", empty: "keine Beiträge" },
    postsInPrefix: "Beiträge im",
    viewTable: "Tabelle",
    viewCalendar: "Kalender",
    noPostsFound: "Keine Beiträge gefunden.",
    colTitlePreview: "Titel / Vorschau",
    colChannels: "Kanäle",
    colAmpelDecision: "Ampel – Ihre Entscheidung",
    colStatus: "Status",
    colResponsible: "Verantwortlich",
    colPlanned: "Geplant",
    colReach: "Reichweite",
    colActions: "Aktionen",
    detailsTitle: "Beitrag-Details",
    detailsAria: "Details ansehen",
    detailsClose: "Schliessen",
    goApprove: "Zur Freigabe",
    openCalendar: "Im Kalender öffnen",
    detailExcerpt: "Vorschau",
    reachLabel: "Reichweite",
    interactionsLabel: "Interaktionen",
    paginationUnit: "Beiträgen",
    scheduledShort: "geplant",
    untitled: "Ohne Titel",
    postsCenter: "Beiträge",
    reachTotal: "Reichweite gesamt",
    interactionsTotal: "Interaktionen gesamt",
    avgEngagement: "Ø Engagement-Rate",
    bestTimeLabel: "Beste Tageszeit",
    plannedNext7: "Geplant nächste 7 Tage",
    openTasks: "Offene Aufgaben",
    openTasksLabel: "Zur Freigabe / Feedback",
    statNotCaptured: "Noch nicht erfasst — Analytics nicht verbunden.",
    notConnectedNote: "Analytics (Meta/Instagram) noch nicht verbunden — Werte werden live angezeigt, sobald verbunden.",
    planned: "Geplant",
    published: "Veröffentlicht",
    changeReqOpen: "Änderungswunsch offen",
    questionsOpen: "Offene Rückfragen",
    downloadsTitle: "Downloads & Export",
    dlPdfBtn: "PDF-Report herunterladen",
    dlCsvBtn: "Beiträge als CSV",
    downloadsNote: "Der PDF-Report enthält Kennzahlen, Ziel und die Beitragsliste für {month}.",
    distTitle: "Beitragsverteilung nach Status",
    distLabels: { freigegeben: "Freigegeben", frage_kommentar: "Frage / Kommentar", zur_freigabe: "Zur Freigabe", aenderungswunsch: "Änderungswunsch" },
    platformTitle: "Veröffentlichungen nach Plattform",
    notBooked: "nicht gebucht",
    notBookedTitle: "Kanal aktuell nicht gebucht — als Zusatzkanal buchbar.",
    bookedChannels: "Gebuchte Kanäle:",
    topPostTitle: "Top Beitrag nach Reichweite",
    topPostEmpty: "Noch nicht erfasst — Analytics (Meta/Instagram) nicht verbunden.",
    reach: "Reichweite",
    interactions: "Interaktionen",
    publishedOn: "Veröffentlicht am",
    hintsTitle: "Hinweise & Empfehlungen",
    hints: { engagement: "Engagement-Rate: {pct} % im Zeitraum.", feedback_waiting: "{n} Beitrag(e) warten auf Kundenfeedback.", best_time: "Beste Zeit: {time} Uhr.", analytics_off: "Reichweite/Engagement werden angezeigt, sobald Meta/Instagram verbunden ist.", none: "Keine besonderen Auffälligkeiten in diesem Monat." },
    emailToCustomer: "Report per E-Mail an Kunden",
    recipient: "Empfänger:",
    lastSent: "zuletzt gesendet",
    noContactEmail: "Kein Kunden-Kontakt mit E-Mail hinterlegt.",
    brevoNotConnectedFull: "Brevo (E-Mail) noch nicht verbunden — Versand wird aktiv, sobald verbunden.",
    autoMonthly: "Automatischer Monatsversand am Monatsende",
    lastUpdate: "Letzte Aktualisierung:",
    refresh: "Aktualisieren",
    dlgDoneTitle: "Freigabe abgeschlossen",
    dlgApproveTitleOne: "{n} Beitrag dieses Monats freigeben?",
    dlgApproveTitleMany: "{n} Beiträge dieses Monats freigeben?",
    customerLabel: "Kunde:",
    reportMonthLabel: "Berichtsmonat:",
    dlgIntro: "Sie geben die ausgewählten Beitragsversionen zur Planung bzw. Veröffentlichung frei. Werden Inhalte später geändert, ist erneut Ihre Freigabe erforderlich.",
    selectedOf: "{a} von {b} ausgewählt",
    selAll: "Alle",
    selNone: "Keine",
    versionBinding: "Versionsbindung: Freigegeben wird genau die aktuell angezeigte Version. Wurde ein Beitrag zwischenzeitlich geändert, wird er übersprungen und muss erneut geprüft werden.",
    resApproved: "freigegeben",
    resSkipped: "übersprungen",
    resFailed: "fehlgeschlagen",
    resApprovedItem: "Freigegeben",
    cancel: "Abbrechen",
    confirmOne: "{n} Beitrag verbindlich freigeben",
    confirmMany: "{n} Beiträge verbindlich freigeben",
    approving: "Wird freigegeben…",
    close: "Schliessen",
    tReportLoadFail: "Report konnte nicht geladen werden.",
    tPdfCreated: "PDF erstellt",
    tPdfFail: "PDF-Erstellung fehlgeschlagen",
    tCsvExported: "CSV exportiert",
    tNoContact: "Kein Kunden-Kontakt mit E-Mail hinterlegt.",
    tReportSent: "Report versendet.",
    tSendFail: "Versand fehlgeschlagen",
    tAutoOn: "Automatischer Monatsversand aktiviert.",
    tAutoOff: "Automatischer Versand deaktiviert.",
    tSaveFail: "Konnte nicht speichern",
    tApprovedOne: "1 Beitrag freigegeben",
    tApprovedMany: "{n} Beiträge freigegeben",
    tApproveNone: "Keine Beiträge freigegeben — Details siehe Dialog.",
    tApproveFail: "Freigabe fehlgeschlagen.",
    csvHeaders: ["Titel", "Kanäle", "Ampel (Ihre Entscheidung)", "Status", "Verantwortlich", "Geplant", "Reichweite", "Interaktionen"],
    months: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
    locale: "de-CH",
  },
};

const fr = {
  common: {
    loading: "Chargement…",
    retry: "Réessayer",
    error: "Cette section n'a pas pu être chargée. Veuillez réessayer.",
    close: "Fermer",
    cancel: "Annuler",
    all: "Tous",
    noTenant: "Aucun mandant sélectionné.",
  },
  ampel: {
    rot: { label: "Rouge", sub: "Modification/Blocage", full: "Rouge · modification/blocage" },
    blau: { label: "Bleu", sub: "Question ouverte", full: "Bleu · question ouverte" },
    orange: { label: "Orange", sub: "En attente de validation", full: "Orange · en attente de validation" },
    gruen: { label: "Vert", sub: "Validé", full: "Vert · validé" },
    neutral: { label: "Neutre", sub: "Aucune validation en attente", full: "Neutre · aucune validation en attente" },
    unknown: "—",
  },
  cvs: {
    in_vorbereitung: "En préparation",
    zur_pruefung: "À vérifier",
    in_bearbeitung: "En cours",
    geplant: "Planifié",
    freigegeben: "Validé",
    veroeffentlicht: "Publié",
    kewag_pruefung: "KEWAG vérifie",
    abgeschlossen: "Terminé",
    unknown: "—",
  },
  landing: {
    docTitle: "SocialCheck – Démo Jury",
    kicker: "SocialCheck – La démo Jury",
    heroTitle: "La validation des contenus sur les réseaux sociaux pour les PME en Allemagne, en Autriche et en Suisse –",
    heroAccent: "aussi simple qu'un feu de signalisation.",
    subtitle: "KEWAG crée, planifie et gère les contenus pour les réseaux sociaux. Les clients peuvent vérifier, commenter, demander des modifications ou approuver les publications via un cockpit simple basé sur un système de feux de signalisation.",
    benefit: "SocialCheck simplifie la gestion des réseaux sociaux pour les PME en Allemagne, en Autriche et en Suisse tout en leur donnant un contrôle clair sur chaque validation.",
    startBtn: "Démarrer la démo Jury guidée",
    startGuided: "Démarrer la démo Jury guidée",
    startSubline: "Visite guidée · aucune inscription requise · mandant de démo isolé",
    viewControlOS: "Voir l'espace de travail KEWAG",
    viewCustomer: "Voir la vue client",
    starting: "Préparation de la session…",
    windowInfo: "Sans mot de passe · prêt immédiatement · se termine automatiquement après 7 jours",
    inviteRequired: "Cet accès est sécurisé. Veuillez utiliser le lien d'invitation officiel de KEWAG.",
    startedToast: "Session de démo Jury isolée démarrée.",
    startFailed: "Impossible de démarrer la démo.",
    endedNotice: "Votre session précédente a été fermée (2 h d'inactivité). Démarrez simplement une nouvelle session isolée.",
    heroBadges: { days: "Disponible 7 jours", isolated: "Données de démo isolées", noPublish: "Publication externe désactivée", devices: "Ordinateur & mobile" },
    process: {
      title: "Expliqué en trois étapes",
      cards: [
        { n: "01", title: "KEWAG crée la publication", desc: "Texte, image, plateforme, client et date de publication sont gérés de manière centralisée." },
        { n: "02", title: "Le client décide via le feu", desc: "Vert = validé, Rouge = modification, Bleu = question/commentaire, Orange = décision en attente." },
        { n: "03", title: "Tout reste synchronisé", desc: "Statut de validation, calendrier, commentaires, historique et rapports utilisent les mêmes données vérifiées." },
      ],
    },
    works: {
      title: "Ce qui fonctionne réellement ici",
      items: [
        "KEWAG Control OS & cockpit client séparé",
        "Rôles utilisateurs réels & permissions côté serveur",
        "Séparation protégée des mandants et des clients",
        "Validations par feu avec commentaires & historique",
        "Les demandes rouges bloquent la suite de la validation",
        "Publications, calendrier, médias & rapports",
        "Processus de support & journal d'audit",
        "Affichage honnête des statuts d'intégration & système",
        "Flux de travail bureau & mobile",
        "Seules les données autorisées dans la vue client",
      ],
    },
    portals: {
      title: "Un système – trois univers de travail parfaitement connectés",
      subtitle: "KEWAG Control OS, cockpit client et SocialCheck Pocket – les mêmes données vérifiées, trois vues adaptées.",
      kewag: { badge: "Interne", title: "KEWAG Control OS", desc: "Ainsi KEWAG organise les publications, validations, calendrier et rapports.", cta: "Voir l'espace de travail KEWAG" },
      customer: { badge: "Client", title: "Cockpit client", desc: "Ainsi les clientes et clients vérifient, commentent et décident via le feu tricolore.", cta: "Voir la vue client" },
      pocket: { badge: "Mobile", title: "SocialCheck Pocket", desc: "Ainsi les clients envoient en déplacement des photos et informations en toute sécurité directement à KEWAG.", cta: "Voir SocialCheck Pocket" },
    },
    why: {
      title: "Pourquoi SocialCheck a été créé",
      beforeTitle: "Avant",
      beforeText: "Validations dispersées entre e-mails, messages, fichiers et questions – difficiles à suivre.",
      afterTitle: "Avec SocialCheck",
      afterText: "Un état central, des responsabilités claires, des décisions client simples et un historique traçable.",
    },
    done: {
      title: "Merci – vous avez découvert SocialCheck dans son intégralité.",
      subtitle: "Vous avez suivi le parcours guidé du jury. Voici votre récapitulatif.",
      checksTitle: "Ce que le jury a vu",
      checks: {
        start: "Démarrage de démo sécurisé, sans mot de passe",
        isolated: "Session jury entièrement isolée",
        uebersicht: "Aperçu jury SocialCheck ouvert",
        beitraege: "Publications & aperçu vérifiés",
        ampel: "Validations / feu (vert, rouge, bleu) ouverts",
        kalender: "Calendrier, rapport mensuel & statut des intégrations consultés",
        pocket: "SocialCheck Pocket testé",
        upload: "Photo transmise en toute sécurité et de façon isolée",
        sync: "Base de données synchronisée et vérifiée",
        noPublish: "Aucune publication externe (bloquée côté serveur)",
      },
      doneLabel: "effectué",
      todoLabel: "non ouvert",
      message: "SocialCheck remplace les validations dispersées par e-mail, WhatsApp et fichiers isolés par un processus central, sécurisé et traçable.",
      restart: "Redémarrer la démo",
      viewKewag: "Voir KEWAG Control OS",
      viewCustomer: "Voir le cockpit client",
      viewPocket: "Voir SocialCheck Pocket",
      restartConfirmTitle: "Démarrer une nouvelle session de démo ?",
      restartConfirmText: "Une nouvelle session isolée sera créée. Vos données de démo actuelles (y compris les photos envoyées) seront supprimées.",
      restartConfirmOk: "Démarrer une nouvelle session",
      cancel: "Annuler",
      shareTitle: "Partager & emporter",
      qrHint: "QR-Code vers la démo jury",
      copyLink: "Copier le lien",
      copiedToast: "Lien copié.",
      downloadPdf: "Parcours en PDF",
      endDemo: "Terminer la démo en toute sécurité",
      endingToast: "Session de démo terminée en toute sécurité.",
      pdf: {
        title: "Démo jury · Récapitulatif",
        checksTitle: "Ce que le jury a vu",
        aboutTitle: "À propos de SocialCheck",
        aboutText: "SocialCheck est la plateforme de validation centrale et sécurisée pour les PME en Allemagne, en Autriche et en Suisse : KEWAG crée et planifie les publications, les clientes et clients vérifient et décident simplement via le feu tricolore — Vert = valider, Rouge = demande de modification, Bleu = question/commentaire. Cela remplace les validations dispersées par e-mail, WhatsApp et fichiers isolés par un processus traçable et cloisonné par client. SocialCheck Pocket permet en plus d'envoyer des photos en déplacement, en toute sécurité, directement à KEWAG.",
        linkLabel: "Ouvrir la démo :",
        generatedOn: "Créé le",
        fileName: "SocialCheck-Demo-Jury.pdf",
      },
    },
    securityTitle: "Sécurité & transparence",
    footerBadges: [
      "Sans mot de passe", "Uniquement des données de démo", "Disponible 7 jours", "Session fermée après 2 h d'inactivité",
      "Nouvelle session à tout moment", "Aucune publication externe", "Aucun accès aux clients réels",
    ],
    closing: "Bon test – nous sommes convaincus que vous serez enthousiasmés !",
    unavailableTitle: "La démo Jury SocialCheck n'est actuellement pas disponible.",
    unavailableExpired: "La période de démo est terminée.",
    unavailableDisabled: "La démo a été temporairement désactivée.",
    unavailableInvite: "Nous vous rouvrons volontiers l'accès.",
    demoPeriod: "Période de démo",
    contactKewag: "Contacter KEWAG",
    backToWebsite: "Vers le site SocialCheck",
    rd: {
      eyebrow: "SocialCheck · Social Media Made Simple",
      h1a: "Les réseaux sociaux, gérés.",
      h1b: "Validation aussi simple qu'un feu de signalisation.",
      heroSub: "KEWAG crée et gère vos contenus pour les réseaux sociaux. Vous vérifiez, commentez et validez – dans un cockpit simple pour les PME en Allemagne, en Autriche et en Suisse.",
      trust: "Fonctions réelles · Données de démo isolées · Ordinateur & mobile",
      ctaPrimary: "Démarrer la démo Jury",
      ctaSecondary: "Voir la vue client",
      shotFreigaben: "Validations par feu · Cockpit client",
      shotControlos: "KEWAG Control OS · Aperçu",
      shotCockpit: "Cockpit client · Aperçu",
      shotPocket: "SocialCheck Pocket",
      ampel: {
        title: "Un coup d'œil. Une décision.",
        sub: "KEWAG prépare la publication. Le client décide. Tout le monde voit le statut actuel immédiatement.",
        green: { label: "Vert", state: "Validé", desc: "La publication est validée et prête à être publiée." },
        orange: { label: "Orange", state: "À vérifier", desc: "En attente de la décision du client." },
        red: { label: "Rouge", state: "Modification souhaitée", desc: "Le client demande une modification – KEWAG la retravaille." },
        blue: { label: "Bleu", state: "Question / commentaire", desc: "Une question ouverte ou un commentaire sur la publication." },
      },
      how: {
        title: "Comment fonctionne SocialCheck",
        sub: "De l'idée à la publication – un déroulement clair et traçable.",
        s1t: "KEWAG crée", s1d: "Contenu, texte, image, plateforme et heure de publication sont préparés.",
        s2t: "Le client vérifie", s2d: "Consulter, commenter, demander des modifications ou valider directement via le feu.",
        s3t: "KEWAG publie", s3d: "Validations, commentaires, calendrier et rapports restent centralisés et traçables.",
      },
      showcase: {
        title: "Un système. Trois univers de travail parfaitement connectés.",
        sub: "SocialCheck relie KEWAG, le client et l'usage mobile dans un flux clair.",
        controlosBadge: "KEWAG · Interne", controlosTitle: "KEWAG Control OS", controlosDesc: "KEWAG gère les clients, les publications, les validations, le calendrier et les rapports de manière centralisée.", controlosCta: "Voir l'espace de travail KEWAG",
        cockpitBadge: "Client", cockpitTitle: "Cockpit client", cockpitDesc: "Le client ne voit que ce dont il a réellement besoin : vérifier, commenter et décider.", cockpitCta: "Voir la vue client",
        pocketBadge: "Mobile", pocketTitle: "SocialCheck Pocket", pocketDesc: "Validations et informations accessibles sur mobile à tout moment.", pocketCta: "Voir la vue mobile",
      },
      platform: {
        eyebrow: "Contrôle de la plateforme",
        title: "Une couche de contrôle centrale pour votre écosystème social.",
        sub: "Connecter les plateformes. Gérer les autorisations. Surveiller l'état des intégrations.",
        body: "SocialCheck centralise les connexions aux plateformes, les droits d'accès et l'état des intégrations — offrant à KEWAG un endroit fiable pour gérer la base technique derrière chaque workflow client.",
        shot: "KEWAG Control OS · Intégrations",
        cards: [
          { n: "01", t: "Connexions aux plateformes", d: "Gestion centralisée des plateformes et services connectés." },
          { n: "02", t: "Autorisations & accès", d: "Contrôle clair de qui peut accéder, gérer et utiliser chaque connexion." },
          { n: "03", t: "État des intégrations", d: "Voir l'état des connexions et repérer les problèmes avant qu'ils n'interrompent le workflow." },
        ],
        layersTitle: "Une plateforme. Toutes les couches opérationnelles connectées.",
        layers: [
          "KEWAG réalise le travail",
          "Les clients vérifient et valident",
          "SocialCheck pilote le workflow",
          "Les intégrations connectent l'infrastructure opérationnelle",
          "Les autorisations gardent les accès sous contrôle",
          "L'état des intégrations garde les opérations fiables",
        ],
      },
      why: {
        title: "Pourquoi SocialCheck a été créé",
        withoutTitle: "Sans SocialCheck",
        withTitle: "Avec SocialCheck",
        without: ["E-mails", "WhatsApp", "fichiers dispersés", "questions sans fin", "validations floues", "commentaires éparpillés", "aucune vue d'ensemble"],
        with: ["Un statut central", "Des responsabilités claires", "Des commentaires traçables", "Validations par feu", "Calendrier", "Rapports", "Accès mobile"],
      },
      value: {
        title: "KEWAG fait le travail. Le client garde le contrôle.",
        p1t: "Moins d'efforts", p1d: "Le client n'a pas à organiser lui-même les réseaux sociaux.",
        p2t: "Validations claires", p2d: "Chaque décision est visible et traçable.",
        p3t: "Flux évolutif", p3d: "Un processus structuré pour de nombreuses PME, publications et plateformes.",
        sub: "Conçu pour les PME en Allemagne, en Autriche et en Suisse. Pensé pour évoluer davantage.",
      },
      features: {
        title: "Tout ce qui simplifie la collaboration",
        items: [
          { t: "Espaces KEWAG et client séparés", d: "Espace de travail interne et vue client clairement séparés." },
          { t: "Rôles & autorisations", d: "Droits côté serveur pour chaque personne et chaque mandant." },
          { t: "Validations par feu", d: "Vert, orange, rouge et bleu – la décision en un coup d'œil." },
          { t: "Commentaires & demandes de modification", d: "Retours directement sur la publication, entièrement traçables." },
          { t: "Calendrier & rapports", d: "Publications planifiées et rapports mensuels à partir d'une seule source." },
          { t: "Ordinateur & mobile", d: "Accès complet au bureau et en déplacement." },
        ],
        disclaimer: "Données de démo isolées · aucune donnée client réelle",
      },
      final: {
        title: "SocialCheck en action.",
        sub: "Découvrez à quel point la validation sur les réseaux sociaux peut être simple.",
        cta1: "Démarrer la démo Jury",
        cta2: "Ouvrir la vue client",
        disclaimer: "Aucune donnée client réelle · environnement de démo sécurisé",
      },
    },
  },
  banner: {
    title: "Démo Jury SocialCheck",
    isolated: "Session isolée",
    noPublish: "Aucune publication externe",
    timeout: "La session se termine après 2 h d'inactivité",
    until: "jusqu'au",
    restart: "Démarrer une nouvelle démo",
    exit: "Terminer la démo",
  },
  ticker: {
    title: "Activité de démo en direct",
    sessionOne: "session active",
    sessionMany: "sessions actives",
    decisions: "décisions (48 h)",
    caps: { gruen: "Valider", orange: "À vérifier", rot: "Demande de modification", blau: "Question / commentaire" },
    events: { approved: "Publication validée", change_requested: "Demande de modification envoyée", question: "Question / commentaire posé", reviewed: "Publication vérifiée" },
    empty: "Soyez le premier jury – chaque décision de validation apparaît ici en direct et anonymisée.",
    footer: "Anonymisé · aucune donnée client réelle · uniquement l'activité de la démo Jury",
    now: "à l'instant",
    minAgo: "il y a {n} min",
    hrAgo: "il y a {n} h",
  },
  nav: {
    section: "Démo Jury",
    dashboard: "Aperçu",
    freigaben: "Validations / Feu",
    beitraege: "Publications",
    kalender: "Calendrier",
    report: "Rapport mensuel",
    integrationen: "Intégrations",
    pocket: "SocialCheck Pocket",
  },
  tour: {
    progress: ["Aperçu", "Publications", "Feu", "Calendrier", "Pocket"],
    stationWord: "Étape",
    ofWord: "sur",
    next: "Suivant",
    back: "Retour",
    finish: "Terminer la démo Jury",
    exit: "Quitter la démo",
    safeBadge: "Démo Jury · mandant de démo isolé · sécurisé",
    stations: [
      { title: "Aperçu jury SocialCheck", desc: "Votre point de départ : l'état de toutes les publications et la logique centrale du feu tricolore de cette session isolée, d'un coup d'œil." },
      { title: "Publications et aperçu", desc: "Vérifiez les publications préparées avec aperçu en direct, texte, image, canaux et date planifiée – exactement comme le client les voit." },
      { title: "Validations / Feu – vert, rouge et bleu", desc: "Décidez via le feu : Vert = valider, Rouge = demande de modification, Bleu = question/commentaire. Testez librement les trois réactions." },
      { title: "Calendrier, rapport mensuel et statut des intégrations", desc: "Voyez comment le calendrier, le rapport mensuel et le statut honnête des intégrations utilisent les mêmes données vérifiées (accessibles à tout moment via le menu)." },
      { title: "SocialCheck Pocket", desc: "Envoyez en déplacement une photo à KEWAG en toute sécurité – un vrai téléversement de démo, mais entièrement isolé à cette session." },
    ],
  },
  pocketDemo: {
    badge: "Démo Jury · mandant de démo isolé · sécurisé",
    title: "SocialCheck Pocket",
    subtitle: "Ainsi les clientes et clients envoient en déplacement des photos en toute sécurité directement à KEWAG.",
    securityNote: "Démo Jury : cette photo est enregistrée exclusivement dans votre session de démo isolée et supprimée automatiquement à son expiration. Elle n'est transmise ni à des clients réels ni à des systèmes externes.",
    take: "Prendre une photo",
    choose: "Choisir dans la galerie",
    dropTitle: "Ajouter une photo",
    dropHint: "Prendre ou choisir dans la galerie",
    notePlaceholder: "Ajouter un message (facultatif)…",
    send: "Envoyer en sécurité",
    uploading: "Transmission sécurisée en cours",
    change: "Autre photo",
    successToast: "Photo enregistrée en toute sécurité dans votre session de démo.",
    errorType: "Veuillez choisir une image (JPG, PNG, WEBP ou HEIC).",
    errorTooLarge: "L'image est trop grande.",
    errorGeneric: "Échec du téléversement. Veuillez réessayer.",
    galleryTitle: "Envoyé dans cette session de démo",
    galleryEmpty: "Aucune photo envoyée pour l'instant.",
    isolatedBadge: "Visible uniquement dans cette session",
    autoDelete: "Supprimé automatiquement à l'expiration de la session.",
  },
  mobile: {
    stationOf: "Étape {n} sur {t}",
    ofShort: "{n} sur {t}",
    menuRestart: "Redémarrer la démo",
    menuEnd: "Quitter la démo en sécurité",
    back: "Retour",
    next: "Suivant",
    finish: "Terminer la démo",
    langSheetTitle: "Choisir la langue",
    optionsAria: "Plus d'options",
    statusIsolated: "Démo jury isolée",
    pocketTitle: "Envoyer une photo en sécurité à KEWAG",
    pocketText: "Prenez ou choisissez une photo – KEWAG la reçoit en sécurité dans cette démo isolée.",
    securityToggle: "Sécurité et confidentialité",
    securityShort: "La photo est enregistrée uniquement dans cette session de démo isolée et supprimée automatiquement à l'expiration.",
    pwaTitle: "Installer SocialCheck comme application",
    pwaIos: "Touchez « Partager » puis « Sur l'écran d'accueil ».",
    pwaAndroidCta: "Installer sur l'écran d'accueil",
    pwaGeneric: "Via le menu du navigateur « Ajouter à l'écran d'accueil ».",
    pwaDismiss: "Plus tard",
  },
  controlOS: {
    docTitle: "KEWAG Control OS – Démo Jury",
    title: "KEWAG Control OS",
    subtitle: "Espace de travail interne – voici comment KEWAG gère les publications de ce mandant.",
    badge: "Démo Jury · mandant de démo isolé · lecture seule",
    readOnlyNote: "Vue en lecture seule : dans la démo Jury, l'édition, la validation et la publication sont volontairement désactivées.",
    viewCustomerBtn: "Ce que voit le client",
    backBtn: "Vers la page d'accueil Jury",
    empty: "Aucune publication dans le mandant de démo.",
    colPost: "Publication",
    colInternal: "Statut de production interne",
    colAmpel: "Feu (décision client)",
    colCustomer: "Statut visible par le client",
    colPlan: "Planifié",
    colChannels: "Canaux",
    ownerKewag: "KEWAG",
    ownerCustomer: "Client",
    syncNote: "Le statut interne et la vue client reposent sur les mêmes données vérifiées.",
    psLabels: { entwurf: "Brouillon", in_arbeit: "En cours", intern_in_pruefung: "Vérification interne", zur_freigabe: "À valider", freigegeben: "Validé", geplant: "Planifié", veroeffentlicht: "Publié", fehlgeschlagen: "Échoué", pausiert: "En pause", archiviert: "Archivé" },
    ampLabels: { rot: "Rouge", blau: "Bleu", orange: "Orange", gruen: "Vert", neutral: "Neutre" },
    cvsLabels: { in_vorbereitung: "En préparation", zur_pruefung: "À vérifier", in_bearbeitung: "En cours", geplant: "Planifié", freigegeben: "Validé", veroeffentlicht: "Publié", kewag_pruefung: "KEWAG vérifie", abgeschlossen: "Terminé" },
  },
  integrations: {
    docTitle: "SocialCheck – KEWAG Social Gateway (démo Jury)",
    title: "KEWAG Social Gateway",
    subtitle: "Statut en direct de la connexion sociale centrale – entièrement vérifié côté serveur, honnête et sans publications externes.",
    error: "Le statut du gateway n'est pas disponible ici.",
    gatewayTitle: "KEWAG Social Gateway",
    gatewayLabel: "Connexion centrale pour toutes les plateformes sociales",
    statusBadge: { ready: "Opérationnel", checking: "Vérification en cours", action_required: "Action requise", inactive: "Inactif" },
    readiness: "{passed}/{total} vérifications système réussies",
    lastChecked: "Dernière vérification",
    refresh: "Actualiser",
    autoRefresh: "Actualisation automatique toutes les 30 s.",
    publishOff: "Publication externe désactivée côté serveur",
    checksTitle: "Vérifications système (en direct, côté serveur)",
    checks: {
      approval_workflow: { title: "Flux de validation", desc: "Flux de validation actif côté serveur." },
      comments_history: { title: "Commentaires & historique", desc: "Commentaires et historique disponibles côté serveur." },
      calendar_sync: { title: "Synchronisation du calendrier", desc: "Synchronisation du calendrier fonctionnelle en interne." },
      report_sync: { title: "Synchronisation du rapport", desc: "Rapport mensuel fonctionnel en interne." },
      tenant_isolation: { title: "Isolation des mandants", desc: "Isolation des mandants active côté serveur." },
      session_isolation: { title: "Isolation de session", desc: "Isolation de session active côté serveur." },
      external_publishing_off: { title: "Publication externe", desc: "Publication externe désactivée côté serveur." },
      real_data_locked: { title: "Données réelles verrouillées", desc: "Données réelles verrouillées pour le jury." },
    },
    states: { functional: "Fonctionnel", active: "Actif", disabled: "Désactivé", locked: "Verrouillé", checking: "Vérification", action_required: "Action requise" },
    providersTitle: "Connexions aux plateformes (statut honnête)",
    providerStates: {
      connected: "Connecté",
      prepared: "Préparé – pas encore connecté",
      credentials_missing: "Identifiants manquants – non connecté",
      adapter_prepared: "Adaptateur préparé",
    },
    actionsTitle: "Action requise",
    noActions: "Aucune action en attente – toutes les vérifications nécessaires ont réussi.",
    actions: {
      enable_gateway: "Activer le gateway.",
      disable_publishing: "Désactiver la publication externe (obligatoire dans la démo Jury).",
      fix_tenant_isolation: "Rétablir l'isolation des mandants.",
      fix_session_isolation: "Rétablir l'isolation de session.",
      fix_real_data_locked: "Rétablir le verrouillage des données réelles.",
    },
    securityTitle: "Sécurité & transparence",
    notes: {
      isolated_demo_only: "Seules des données de démo isolées sont affichées.",
      tenant_isolation: "Isolation des mandants active – aucun accès aux clients réels.",
      no_external_publishing: "Les publications externes sont strictement désactivées côté serveur.",
      no_false_status: "Aucun faux statut « connecté » – transparence maximale.",
    },
  },
  kalender: {
    ampelOpts: { rot: "Rouge — demande de modification", blau: "Bleu — question ouverte", orange: "Orange — en attente de validation", gruen: "Vert — validé", neutral: "Neutre" },
    prodOpts: { entwurf: "Brouillon", in_arbeit: "En cours", intern_in_pruefung: "En contrôle interne", zur_freigabe: "À valider", freigegeben: "Validé", geplant: "Planifié", veroeffentlicht: "Publié", fehlgeschlagen: "Échoué", pausiert: "En pause", archiviert: "Archivé" },
    kundeAll: "Client : tous", ampelAll: "Feu : tous", prodAll: "Statut de production : tous", verantwortlichAll: "Responsable : tous",
    ampelHeading: "Feu — décision du client", prodHeading: "Statut de production — interne", noActiveDecision: "Aucune décision client active", prodUnavailable: "Statut non disponible",
    verValid: "La validation s'applique à cette version", verStale: "Le contenu a été modifié – nouvelle validation du client requise", verNone: "Pas encore de validation pour cette version",
    customerViewTitle: "Vue côté client", customerPrep: "En préparation", customerViewHint: "Cet affichage est utilisé dans le cockpit client.", lastViewed: "Dernière consultation par le client :", notViewed: "Pas encore consulté par le client",
    openCustomerPreview: "Ouvrir l'aperçu client", previewLocked: "Pas encore débloqué pour le client — aperçu disponible dès que la publication est prête pour validation.",
    internalNote: "Note interne (KEWAG uniquement)", edit: "Modifier", save: "Enregistrer", cancel: "Annuler", noInternalNote: "Aucune note interne.", duplicate: "Dupliquer", markOpen: "Marquer comme ouvert", markDone: "Marquer comme terminé",
    title: "Calendrier social",
    views: { monat: "Mois", woche: "Semaine", liste: "Liste" },
    wochenplan: "Plan hebdomadaire",
    kpi: {
      zur_freigabe: { label: "À valider", sub: "En attente de votre validation" },
      freigegeben: { label: "Validé", sub: "Prêt / planifié" },
      diese_woche_geplant: { label: "Planifié cette semaine", sub: "Publications planifiées" },
      veroeffentlicht: { label: "Publié", sub: "Déjà en ligne" },
      alle: "Toutes les publications", inRange: "Sur cette période",
    },
    kpiInternal: {
      zur_freigabe: { label: "À valider", sub: "En attente du client" },
      aenderungen: { label: "Modifications ouvertes", sub: "Demande de modification" },
      diese_woche_geplant: { label: "Planifié cette semaine", sub: "Publications planifiées" },
      fragen: { label: "Questions / commentaires", sub: "Questions ouvertes" },
    },
    probleme: "Problèmes",
    newPost: "Nouvelle publication",
    noProblems: "Aucun problème ouvert",
    resendForApproval: "Renvoyer pour validation",
    onlyBooked: "Uniquement les canaux réservés",
    notBooked: "non réservé",
    notBookedTitle: "Plateforme(s) non réservée(s) : {labels}. Disponible comme canal supplémentaire.",
    wp: {
      title: "Plan hebdomadaire · Cette semaine",
      desc: "{name} · Aperçu des publications planifiées (lun–dim). Partageable en PDF.",
      thisWeek: "Cette semaine",
      posts: "publications",
      approvedPlanned: "validé/planifié",
      published: "publié",
      awaitingApproval: "à valider",
      loading: "Chargement…",
      today: "Aujourd'hui",
      noPosts: "— aucune publication —",
      liveNote: "Le statut correspond exactement à l'état de validation actuel — données réelles en direct.",
      creating: "Création…",
      downloadPdf: "Télécharger en PDF",
      postCountOne: "{n} publication",
      postCountMany: "{n} publications",
      weekdaysFull: ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"],
      locale: "fr-CH",
    },
    search: "Rechercher dans le titre, le texte…",
    chooseRange: "Choisir une période", thisWeek: "Cette semaine", nextWeek: "Semaine prochaine",
    von: "Du", bis: "Au", reset: "Réinitialiser", apply: "Appliquer",
    overdueOnly: "En retard uniquement", statusAll: "Statut : tous", platformAll: "Plateforme : toutes", resetFilters: "Réinitialiser les filtres",
    today: "Aujourd'hui", loading: "Chargement…", emptyFilter: "Aucune publication dans le filtre.", more: "de plus", paginationUnit: "publications",
    autoPublished: "Publié automatiquement", lastUpdate: "Dernière mise à jour", refresh: "Actualiser", weekFrom: "Semaine du",
    state: { entwurf: "Brouillon", zur_freigabe: "En attente de votre validation", freigegeben: "Validé", aenderungswunsch: "Demande de modification", frage: "Question / commentaire", veroeffentlicht: "Publié" },
    stateStaff: { entwurf: "Brouillon", zur_freigabe: "À valider", freigegeben: "Validé", aenderungswunsch: "Demande de modification", frage: "Question / commentaire", veroeffentlicht: "Publié" },
    weekdays: ["Lu", "Ma", "Me", "Je", "Ve", "Sa", "Di"],
    detailEmpty: "Sélectionnez une publication pour voir les détails.", plannedFor: "Planifié pour :",
    customerComment: "Commentaire du client", noCustomerComment: "Pas encore de commentaire du client.", by: "par",
    decisionTitle: "Décision du client",
    dueOverdue: "En retard depuis le {d} — veuillez valider rapidement.",
    dueHint: "Veuillez valider avant le {d}, sinon la publication sera reportée.",
    approve: "Marquer comme validé", requestRed: "Demande de modification (rouge)", questionBlau: "Question / commentaire (bleu)",
    noApproval: "Aucune validation en attente.", askAnytime: " — vous pouvez poser une question à tout moment.", question: "Question / commentaire",
    dlgRedTitle: "Saisir la demande de modification", dlgRedDesc: "Veuillez consigner la demande de modification (obligatoire). L'équipe KEWAG s'en occupe.", phRed: "Votre demande de modification…", submitRed: "Envoyer la demande de modification",
    dlgBlauTitle: "Question / commentaire", dlgBlauDesc: "Posez une question ou laissez un commentaire sur cette publication.", phBlau: "Votre question ou votre commentaire…", submitBlau: "Envoyer",
    historyTitle: "Historique du feu", noEvents: "Aucun événement pour l'instant.", showLess: "Afficher moins", showFull: "Afficher l'historique complet",
    noTenant: "Aucun mandant sélectionné.",
    staff: {
      decGreen: "Marqué comme validé.", decRed: "Demande de modification enregistrée.", decBlau: "Question / commentaire enregistré.", decAmber: "Renvoyé au client.",
      reminderSent: "Rappel envoyé au client.", noteSaved: "Note enregistrée.", duplicated: "Publication dupliquée (en brouillon).", markedDone: "Marqué comme terminé.", markedOpen: "Marqué comme ouvert.",
      noTenantForPreview: "Aucun mandant trouvé pour la vue client.", titleRequired: "Titre requis", postCreated: "Publication créée (statut : brouillon)",
      wpDownloaded: "Plan hebdomadaire téléchargé en PDF.", wpFailed: "Impossible de créer le PDF.",
      fAvgOrange: "Ø temps de réponse Orange", fAvgRed: "Ø temps de réponse Rouge", fAvgBlau: "Ø temps de réponse Bleu", fAvgTotal: "Temps de réponse (total)",
      fApprovedToday: "Validé aujourd'hui", fPlanned: "Publications planifiées", fPublishedWeek: "Publié cette semaine", unitDays: "jours", unitHours: "h",
      createTitle: "Créer une nouvelle publication", fTitle: "Titre", fChannel: "Canal", fSchedule: "Planifié le", fContent: "Contenu", saving: "Enregistrement…", create: "Créer",
    },
  },
  beitraege: {
    colAmpel: "Feu", colResponsible: "Responsable", editAction: "Modifier", submitReviewAction: "Envoyer en validation",
    submitReviewShort: "En validation", markPublished: "Marquer comme publié", archiveAction: "Archiver", unarchiveAction: "Restaurer",
    newPost: "Créer une publication", reminders: "Rappels", reminderConfigTitle: "Configurer les rappels de validation", respAll: "Tous",
    internalNoteLabel: "Note interne (KEWAG uniquement)", categoryLabel: "Catégorie",
    ws: { zur_freigabe: "En attente de votre validation", freigegeben: "Validé", veroeffentlicht: "Publié", aenderungswunsch: "Demande de modification" },
    kpi: { alle: "Toutes les publications", zur_freigabe: "En attente de validation", freigegeben: "Validé", veroeffentlicht: "Publié", aenderungswunsch: "Demande de modification" },
    noTenant: "Aucun mandant attribué.",
    pageSubtitle: "Toutes les publications de {name} — vérifier, valider et donner un retour.",
    loadError: "Impossible de charger les publications",
    ampelPrefix: "Feu : ",
    overdue: "En retard", dueUntil: "À valider avant",
    colTitle: "Titre", colChannel: "Canal", colStatus: "Statut", colPlanned: "Planifié pour", colActions: "Actions",
    untitled: "Sans titre", notScheduled: "Non planifié", emptyList: "Aucune publication trouvée.", previewAction: "Aperçu",
    allChannels: "Tous les canaux", search: "Rechercher des publications...", resetFilters: "Réinitialiser les filtres",
    countOne: "publication", countMany: "publications",
    previewEmpty: "Aucune publication sélectionnée.", previewTitle: "Aperçu de la publication",
    bodyLabel: "Texte de la publication", showMore: "Afficher plus", showLess: "Afficher moins",
    platforms: "Plateformes", plannedTime: "Moment de publication prévu", customerNote: "Remarque client",
    decTitle: "Votre décision", decWaiting: "Cette publication attend votre validation.",
    decNoAction: "Aucune action en attente.", decAskAnytime: "Vous pouvez poser une question à tout moment.",
    decOverdue: "En retard depuis le {d} — veuillez valider rapidement pour ne pas retarder davantage la publication.",
    decDueHint: "Veuillez valider avant le {d}, sinon la publication sera reportée.",
    decApprove: "Valider", decRequest: "Demander une modification", decQuestion: "Question / commentaire",
    dlgRequestTitle: "Demander une modification", dlgRequestDesc: "Décrivez brièvement ce qui doit être ajusté. L'équipe KEWAG s'en occupe.",
    phRequest: "Votre demande de modification…", submitRequest: "Envoyer la demande de modification",
    dlgQuestionTitle: "Question / commentaire", dlgQuestionDesc: "Posez une question ou laissez un commentaire sur cette publication.",
    phQuestion: "Votre question ou votre commentaire…", submitQuestion: "Envoyer", actionFailed: "Échec de l'action",
    historyTitle: "Historique des statuts", noEvents: "Aucun événement pour l'instant.", comments: "Commentaires", noComments: "Aucun commentaire pour l'instant.",
    you: "Vous", kewagTeam: "Équipe KEWAG",
    toastApproved: "Validé — merci !", toastRequested: "Demande de modification envoyée", toastQuestion: "Votre message a été envoyé",
    bulkWaitingOne: "publication attend", bulkWaitingMany: "publications attendent", bulkOnYou: "votre validation",
    selected: "sélectionné(s)", selectBtn: "Sélectionner", approveAllN: "Valider les {n}", markAll: "Tout marquer",
    approveN: "Valider {n}", approveBtn: "Valider", requestChange: "Demander une modification",
    bulkConfirmTitle: "Valider les publications",
    bulkConfirmDesc: "Vérifiez la sélection. Vous pouvez décocher certaines publications — seules les publications cochées seront validées pour publication par l'équipe KEWAG.",
    bulkSelectedOf: "{a} sur {b} {unit} sélectionné(s)", selectAll: "Tout sélectionner", deselectAll: "Tout décocher",
    noWaiting: "Aucune publication en attente.", cancel: "Annuler",
    approvePostOne: "Valider 1 publication", approvePostN: "Valider {n} publications",
    bulkResultTitle: "Résultat de la validation groupée", bulkResultDesc: "Toutes les publications n'ont pas pu être validées. Voici le résultat par publication.",
    rSelected: "Sélectionné", rApproved: "Validé", rSkipped: "Ignoré", rFailed: "Échoué",
    requestSkipped: "Demander une révision des publications ignorées", retry: "Réessayer", close: "Fermer",
    bulkRequestTitle: "Demande de modification groupée",
    bulkRequestDesc: "Votre remarque s'applique aux {n} publications sélectionnées. L'équipe KEWAG les révise en conséquence.",
    phBulkRequest: "Que faut-il ajuster sur ces publications ?", sendChangeRequest: "Envoyer la demande de modification",
    toastBulkApprovedOne: "1 publication validée avec succès.", toastBulkApprovedMany: "{n} publications validées avec succès.",
    toastBulkNone: "Aucune publication ouverte à réviser – les publications sont déjà terminées.",
    toastBulkRequestedOne: "Demande de modification envoyée pour 1 publication", toastBulkRequestedMany: "Demande de modification envoyée pour {n} publications",
    bulkApproveFailed: "Échec de la validation groupée", bulkRequestFailed: "Échec de la demande de modification groupée",
    staff: {
      statusUpdated: "Statut mis à jour", statusChangeFailed: "Échec du changement de statut",
      archived: "Publication archivée", archiveFailed: "Échec de l'archivage", unarchived: "Publication restaurée", unarchiveFailed: "Échec de la restauration",
      remindSentEmail: "Rappel envoyé pour {posts} publications à {recipients} destinataires", remindSentInApp: "Rappel in-app envoyé pour {posts} publications (envoi d'e-mail non configuré)", remindFailed: "Échec du rappel",
      settingsLoadFailed: "Impossible de charger les paramètres", settingsSaved: "Paramètres de rappel enregistrés", saveFailed: "Échec de l'enregistrement",
      waitingOne: "publication en attente", waitingMany: "publications en attente", onCustomerApproval: "de validation du client", remindCustomers: "Rappeler aux clients",
      reminderDialogTitle: "Rappels de validation", reminderDialogDesc: "Définissez quand et à quelle fréquence les clients sont automatiquement rappelés pour les validations en attente.",
      autoRemindActive: "Rappels automatiques actifs", daysToFirst: "Jours avant le 1er rappel", intervalDays: "Intervalle (jours)", maxCount: "Nombre max.",
      reminderExample: "Exemple : premier rappel après {wait} jour(s), puis tous les {interval} jour(s), au maximum {max}×.",
      dueLeadLabel: "Échéance de validation : délai avant publication (jours)", dueLeadHint: "Les clients voient « À valider avant le JJ.MM. » — {days} jour(s) avant la date de publication prévue.",
      cancel: "Annuler", save: "Enregistrer",
    },
  },
  freigaben: {
    title: "Validations au feu tricolore",
    subtitle: "Vos publications à valider – vous décidez, KEWAG met en œuvre.",
    kpiWartet: "En attente de validation",
    kpiAenderung: "Demandes de modification",
    kpiHeute: "À traiter aujourd'hui",
    kpiMonat: "Validé ce mois-ci",
    vsPrev: "vs mois préc.",
    emptyTitle: "Aucune publication à valider pour l'instant.",
    emptyDesc: "Dès que KEWAG prépare une publication pour vous, elle apparaît ici.",
    allDoneTitle: "Tout est fait",
    allDoneDesc: "Vous avez traité toutes les validations en attente. KEWAG met en œuvre vos décisions.",
    allDoneToast: "Tout est fait – plus aucune validation en attente.",
    progressLabel: "{done} sur {total} traités",
    inboxTitle: "Boîte de validation",
    previewTitle: "Aperçu en direct",
    versionsMany: "Versions précédentes ({n})",
    versionsOne: "Voir la version validée",
    selectPost: "Veuillez sélectionner une publication.",
    planned: "Planifié",
    channels: "Canaux",
    decisionTitle: "Décision & retour",
    yourFeedback: "Votre retour",
    nextStep: "Prochaine étape",
    yourDecision: "Votre décision",
    contactPerson: "Interlocuteur",
    appointment: "Échéance",
    approve: "Valider",
    approveDesc: "Valider le contenu sans modification.",
    conditions: "Valider avec conditions",
    conditionsDesc: "Valider avec un commentaire.",
    reject: "Ne pas valider",
    rejectDesc: "Envoyer une demande de modification.",
    readOnlyNote: "Mode lecture seule (vue client) – actions désactivées.",
    cannotDecide: "Votre rôle ne peut pas valider les publications (lecture seule).",
    doneApproved: "Vous avez validé cette publication.",
    donePublished: "Cette publication a été publiée.",
    doneChangeRequested: "Demande de modification envoyée – KEWAG révise la publication.",
    historyTitle: "Historique de validation",
    noHistory: "Pas encore d'historique.",
    trustTitle: "Vérifié par KEWAG",
    trustDesc: "Avant votre validation, chaque publication est vérifiée par KEWAG : qualité image & vidéo, texte, branding, liens et call-to-action.",
    detailsTitle: "Détails",
    createdBy: "Créé par",
    kewagTeam: "Équipe KEWAG",
    plannedOn: "Planifié le",
    attachment: "Pièce jointe",
    oneImage: "1 image",
    versionHistoryTitle: "Historique de validation",
    versionHistoryDesc: "Les versions que KEWAG vous a soumises pour validation. Vous voyez ainsi à tout moment ce que vous avez reçu à chaque tour.",
    noVersions: "Aucune version disponible.",
    version: "Version",
    current: "actuelle",
    firstVersion: "Première version soumise",
    minorChanges: "Ajustements mineurs",
    adjusted: "{parts} ajusté(s)",
    comparedTo: "Par rapport à la version {n} :",
    provided: "Soumis",
    scheduledShort: "Planifié",
    note: "Remarque",
    changes: { text: "Texte", image: "Image", appointment: "Échéance", channels: "Canaux", category: "Catégorie", note: "Remarque" },
    dlgRejectTitle: "Envoyer une demande de modification",
    dlgConditionsTitle: "Valider avec conditions",
    dlgRejectDesc: "Que faut-il modifier ? Votre remarque est transmise directement à KEWAG (champ obligatoire).",
    dlgConditionsDesc: "Remarque / condition facultative. La publication est validée et votre commentaire transmis à KEWAG.",
    phReject: "Votre demande de modification…",
    phConditions: "Votre condition / remarque…",
    submitReject: "Envoyer la demande de modification",
    submitConditions: "Valider avec conditions",
    toastConditions: "Validé avec conditions – KEWAG a été informé.",
    toastRejected: "Demande de modification envoyée.",
    toastApproved: "Publication validée.",
    due: { none: "Aucune échéance", overdue: "En retard", today: "À traiter aujourd'hui" },
    events: { provided_for_approval: "Soumis pour validation", approved: "Validé", published: "Publié", change_requested: "Demande de modification envoyée" },
  },
  medien: {
    docTitle: "SocialCheck – Médias (démo Jury)",
    title: "Démo médias",
    subtitle: "Bibliothèque de médias exemplaire de la démo. Les téléversements et suppressions sont désactivés dans la démo Jury.",
    badge: "Affichage uniquement · données de démo isolées",
    empty: "Aucun média disponible.",
    kindImage: "Image",
  },
  report: {
    empty: "Aucun mandant sélectionné.",
    loading: "Chargement…",
    title: "Rapport mensuel",
    month: "Mois",
    downloadPdf: "Télécharger le PDF",
    creating: "Création…",
    emailSend: "Envoyer par e-mail",
    sending: "Envoi…",
    emailNotConnected: "Par e-mail (Brevo non connecté)",
    emailSendTitle: "Envoyer à {email}",
    noContactTitle: "Aucun contact enregistré",
    brevoNotConnectedTitle: "Brevo (e-mail) pas encore connecté",
    goalTitle: "Objectif mensuel",
    reached: "atteint",
    goalPlanned: "publications planifiées",
    goalPublished: "publiées",
    goalChangeReqOpen: "demande de modification ouverte",
    goalQuestions: "questions",
    progress: "Progression",
    waitOne: "publication attend",
    waitMany: "publications attendent",
    waitSuffix: "votre validation",
    reportMonthBar: "Mois de rapport {month} · uniquement les publications ouvertes (orange) de ce mois",
    approveAllBtn: "Valider toutes les publications ouvertes de ce mois",
    kpiTotal: "Publications au total",
    kpiChangeReq: "Demandes de modification",
    kpiForApproval: "À valider",
    kpiApproved: "Validées",
    kpiPublished: "Publiées",
    vs: "vs",
    tabs: { uebersicht: "Aperçu", beitraege: "Publications", kanaele: "Canaux", engagement: "Engagement", performance: "Performance", bestzeiten: "Meilleurs moments", ziele: "Objectifs", downloads: "Téléchargements" },
    allChannels: "Tous les canaux",
    allPlatforms: "Toutes les plateformes",
    allAmpel: "Tous les feux",
    ampelFilter: { rot: "Rouge — demande de modification / blocage", blau: "Bleu — question ouverte / clarification", orange: "Orange — en attente de validation", gruen: "Vert — validé", neutral: "Neutre — aucune décision" },
    allStatus: "Tous les statuts",
    allResponsible: "Tous les responsables",
    searchTitles: "Rechercher dans les titres…",
    resetFilters: "Réinitialiser les filtres",
    ampelStatusTitle: "Feu & statut",
    shortOverview: "Aperçu rapide :",
    ofPosts: "Sur {total} publications —",
    yourDecisions: "Vos décisions :",
    publication: "Publication :",
    ampelColTitle: "Feu — votre décision",
    veroeffColTitle: "Statut de publication",
    noPostsMonth: "Aucune publication ce mois-ci.",
    ampelStatusNote: "Le feu indique votre décision, le statut indique où en est votre publication dans le processus — les deux sont indépendants. « Publié » est un statut, pas un feu.",
    ampelMeaning: { rot: "Demande de modification / blocage", blau: "Question ouverte / clarification", orange: "En attente de votre validation", gruen: "Version actuelle validée", neutral: "Aucune décision active" },
    plainAmpel: { gruen: "validée(s) par vous", orangeOne: "en attente de votre validation", orangeMany: "en attente de votre validation", rot: "avec demande de modification", blau: "avec question ouverte", neutral: "sans décision ouverte", empty: "aucune décision ouverte" },
    plainStatus: { veroeffentlicht: "publiée(s)", geplant: "planifiée(s)", freigegeben: "validée(s) (prêtes)", zur_pruefung: "à vérifier", in_bearbeitung: "en cours", in_vorbereitung: "en préparation", kewag_pruefung: "en vérification KEWAG", abgeschlossen: "terminée(s)", empty: "aucune publication" },
    postsInPrefix: "Publications en",
    viewTable: "Tableau",
    viewCalendar: "Calendrier",
    noPostsFound: "Aucune publication trouvée.",
    colTitlePreview: "Titre / aperçu",
    colChannels: "Canaux",
    colAmpelDecision: "Feu – votre décision",
    colStatus: "Statut",
    colResponsible: "Responsable",
    colPlanned: "Planifié",
    colReach: "Portée",
    colActions: "Actions",
    detailsTitle: "Détails de la publication",
    detailsAria: "Voir les détails",
    detailsClose: "Fermer",
    goApprove: "Vers la validation",
    openCalendar: "Ouvrir dans le calendrier",
    detailExcerpt: "Aperçu",
    reachLabel: "Portée",
    interactionsLabel: "Interactions",
    paginationUnit: "publications",
    scheduledShort: "planifié",
    untitled: "Sans titre",
    postsCenter: "publications",
    reachTotal: "Portée totale",
    interactionsTotal: "Interactions totales",
    avgEngagement: "Taux d'engagement moyen",
    bestTimeLabel: "Meilleur moment de la journée",
    plannedNext7: "Planifié dans les 7 prochains jours",
    openTasks: "Tâches ouvertes",
    openTasksLabel: "À valider / retour",
    statNotCaptured: "Pas encore enregistré — analytics non connecté.",
    notConnectedNote: "Analytics (Meta/Instagram) pas encore connecté — les valeurs s'affichent en direct une fois connecté.",
    planned: "Planifié",
    published: "Publié",
    changeReqOpen: "Demande de modification ouverte",
    questionsOpen: "Questions ouvertes",
    downloadsTitle: "Téléchargements & export",
    dlPdfBtn: "Télécharger le rapport PDF",
    dlCsvBtn: "Publications en CSV",
    downloadsNote: "Le rapport PDF contient les indicateurs, l'objectif et la liste des publications de {month}.",
    distTitle: "Répartition des publications par statut",
    distLabels: { freigegeben: "Validé", frage_kommentar: "Question / commentaire", zur_freigabe: "À valider", aenderungswunsch: "Demande de modification" },
    platformTitle: "Publications par plateforme",
    notBooked: "non réservé",
    notBookedTitle: "Canal actuellement non réservé — disponible en canal supplémentaire.",
    bookedChannels: "Canaux réservés :",
    topPostTitle: "Meilleure publication par portée",
    topPostEmpty: "Pas encore enregistré — analytics (Meta/Instagram) non connecté.",
    reach: "Portée",
    interactions: "Interactions",
    publishedOn: "Publié le",
    hintsTitle: "Remarques & recommandations",
    hints: { engagement: "Taux d'engagement : {pct} % sur la période.", feedback_waiting: "{n} publication(s) attendent un retour du client.", best_time: "Meilleur moment : {time} h.", analytics_off: "La portée/l'engagement s'affichent dès que Meta/Instagram est connecté.", none: "Aucune particularité ce mois-ci." },
    emailToCustomer: "Rapport par e-mail au client",
    recipient: "Destinataire :",
    lastSent: "dernier envoi",
    noContactEmail: "Aucun contact client avec e-mail enregistré.",
    brevoNotConnectedFull: "Brevo (e-mail) pas encore connecté — l'envoi sera actif une fois connecté.",
    autoMonthly: "Envoi mensuel automatique en fin de mois",
    lastUpdate: "Dernière mise à jour :",
    refresh: "Actualiser",
    dlgDoneTitle: "Validation terminée",
    dlgApproveTitleOne: "Valider {n} publication de ce mois ?",
    dlgApproveTitleMany: "Valider {n} publications de ce mois ?",
    customerLabel: "Client :",
    reportMonthLabel: "Mois de rapport :",
    dlgIntro: "Vous validez les versions de publication sélectionnées pour la planification ou la publication. Si le contenu est modifié ultérieurement, votre validation sera de nouveau requise.",
    selectedOf: "{a} sur {b} sélectionné(s)",
    selAll: "Tous",
    selNone: "Aucun",
    versionBinding: "Liaison de version : c'est exactement la version affichée qui est validée. Si une publication a été modifiée entre-temps, elle est ignorée et doit être revérifiée.",
    resApproved: "validées",
    resSkipped: "ignorées",
    resFailed: "échouées",
    resApprovedItem: "Validé",
    cancel: "Annuler",
    confirmOne: "Valider {n} publication de manière contraignante",
    confirmMany: "Valider {n} publications de manière contraignante",
    approving: "Validation en cours…",
    close: "Fermer",
    tReportLoadFail: "Impossible de charger le rapport.",
    tPdfCreated: "PDF créé",
    tPdfFail: "Échec de la création du PDF",
    tCsvExported: "CSV exporté",
    tNoContact: "Aucun contact client avec e-mail enregistré.",
    tReportSent: "Rapport envoyé.",
    tSendFail: "Échec de l'envoi",
    tAutoOn: "Envoi mensuel automatique activé.",
    tAutoOff: "Envoi automatique désactivé.",
    tSaveFail: "Impossible d'enregistrer",
    tApprovedOne: "1 publication validée",
    tApprovedMany: "{n} publications validées",
    tApproveNone: "Aucune publication validée — détails dans la fenêtre.",
    tApproveFail: "Échec de la validation.",
    csvHeaders: ["Titre", "Canaux", "Feu (votre décision)", "Statut", "Responsable", "Planifié", "Portée", "Interactions"],
    months: ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"],
    locale: "fr-CH",
  },
};

const it = {
  common: {
    loading: "Caricamento…",
    retry: "Riprova",
    error: "Impossibile caricare questa sezione. Riprovi.",
    close: "Chiudi",
    cancel: "Annulla",
    all: "Tutti",
    noTenant: "Nessun mandante selezionato.",
  },
  ampel: {
    rot: { label: "Rosso", sub: "Modifica/Blocco", full: "Rosso · modifica/blocco" },
    blau: { label: "Blu", sub: "Domanda aperta", full: "Blu · domanda aperta" },
    orange: { label: "Arancione", sub: "In attesa di approvazione", full: "Arancione · in attesa di approvazione" },
    gruen: { label: "Verde", sub: "Approvato", full: "Verde · approvato" },
    neutral: { label: "Neutro", sub: "Nessuna approvazione in sospeso", full: "Neutro · nessuna approvazione in sospeso" },
    unknown: "—",
  },
  cvs: {
    in_vorbereitung: "In preparazione",
    zur_pruefung: "Da verificare",
    in_bearbeitung: "In corso",
    geplant: "Pianificato",
    freigegeben: "Approvato",
    veroeffentlicht: "Pubblicato",
    kewag_pruefung: "KEWAG verifica",
    abgeschlossen: "Concluso",
    unknown: "—",
  },
  landing: {
    docTitle: "SocialCheck – Demo giuria",
    kicker: "SocialCheck – La demo per la giuria",
    heroTitle: "Approvazioni dei contenuti social per le PMI in Germania, Austria e Svizzera –",
    heroAccent: "semplici come un semaforo.",
    subtitle: "KEWAG crea, pianifica e gestisce i contenuti social. I clienti possono controllare, commentare, richiedere modifiche oppure approvare i post tramite un semplice cockpit a semaforo.",
    benefit: "SocialCheck semplifica la gestione dei social media per le PMI in Germania, Austria e Svizzera, offrendo ai clienti un controllo chiaro su ogni approvazione.",
    startBtn: "Avvia la demo giuria guidata",
    startGuided: "Avvia la demo giuria guidata",
    startSubline: "Tour guidato · nessuna registrazione richiesta · mandante demo isolato",
    viewControlOS: "Vedi l'area di lavoro KEWAG",
    viewCustomer: "Vedi la vista cliente",
    starting: "Preparazione della sessione…",
    windowInfo: "Senza password · pronta subito · termina automaticamente dopo 7 giorni",
    inviteRequired: "Questo accesso è protetto. Utilizzi il link d'invito ufficiale di KEWAG.",
    startedToast: "Sessione demo giuria isolata avviata.",
    startFailed: "Impossibile avviare la demo.",
    endedNotice: "La sua sessione precedente è stata chiusa (2 h di inattività). Avvii semplicemente una nuova sessione isolata.",
    heroBadges: { days: "Disponibile 7 giorni", isolated: "Dati demo isolati", noPublish: "Pubblicazione esterna disattivata", devices: "Desktop & mobile" },
    process: {
      title: "Spiegato in tre passi",
      cards: [
        { n: "01", title: "KEWAG crea il post", desc: "Testo, immagine, piattaforma, cliente e data di pubblicazione sono gestiti centralmente." },
        { n: "02", title: "Il cliente decide col semaforo", desc: "Verde = approvato, Rosso = modifica, Blu = domanda/commento, Arancione = decisione in attesa." },
        { n: "03", title: "Tutto resta sincronizzato", desc: "Stato di approvazione, calendario, commenti, cronologia e report usano gli stessi dati verificati." },
      ],
    },
    works: {
      title: "Cosa funziona davvero qui",
      items: [
        "KEWAG Control OS & cockpit cliente separato",
        "Ruoli utente reali & permessi lato server",
        "Separazione protetta di mandanti e clienti",
        "Approvazioni a semaforo con commenti & cronologia",
        "Le richieste rosse bloccano l'ulteriore approvazione",
        "Post, calendario, media & report",
        "Processo di supporto & registro di audit",
        "Indicazioni oneste di stato integrazioni & sistema",
        "Flussi di lavoro desktop & mobile",
        "Solo dati autorizzati nella vista cliente",
      ],
    },
    portals: {
      title: "Un sistema – tre mondi di lavoro perfettamente connessi",
      subtitle: "KEWAG Control OS, cockpit cliente e SocialCheck Pocket – gli stessi dati verificati, tre viste adatte.",
      kewag: { badge: "Interno", title: "KEWAG Control OS", desc: "Così KEWAG organizza post, approvazioni, calendario e report.", cta: "Vedi l'area di lavoro KEWAG" },
      customer: { badge: "Cliente", title: "Cockpit cliente", desc: "Così le clienti e i clienti verificano, commentano e decidono col semaforo.", cta: "Vedi la vista cliente" },
      pocket: { badge: "Mobile", title: "SocialCheck Pocket", desc: "Così i clienti inviano in mobilità foto e informazioni in modo sicuro direttamente a KEWAG.", cta: "Vedi SocialCheck Pocket" },
    },
    why: {
      title: "Perché è stato creato SocialCheck",
      beforeTitle: "Prima",
      beforeText: "Approvazioni sparse tra e-mail, messaggi, file e domande – difficili da tracciare.",
      afterTitle: "Con SocialCheck",
      afterText: "Uno stato centrale, responsabilità chiare, decisioni cliente semplici e una cronologia tracciabile.",
    },
    done: {
      title: "Grazie – ha vissuto SocialCheck nella sua interezza.",
      subtitle: "Ha completato il percorso guidato della giuria. Ecco il suo riepilogo.",
      checksTitle: "Cosa ha visto la giuria",
      checks: {
        start: "Avvio demo sicuro, senza password",
        isolated: "Sessione giuria completamente isolata",
        uebersicht: "Panoramica giuria SocialCheck aperta",
        beitraege: "Post e anteprima verificati",
        ampel: "Approvazioni / semaforo (verde, rosso, blu) aperti",
        kalender: "Calendario, report mensile e stato integrazioni consultati",
        pocket: "SocialCheck Pocket testato",
        upload: "Foto trasmessa in modo sicuro e isolato",
        sync: "Base dati sincronizzata e verificata",
        noPublish: "Nessuna pubblicazione esterna (bloccata lato server)",
      },
      doneLabel: "completato",
      todoLabel: "non aperto",
      message: "SocialCheck sostituisce le approvazioni disordinate via e-mail, WhatsApp e singoli file con un processo centrale, sicuro e tracciabile.",
      restart: "Riavvia la demo",
      viewKewag: "Vedi KEWAG Control OS",
      viewCustomer: "Vedi il cockpit cliente",
      viewPocket: "Vedi SocialCheck Pocket",
      restartConfirmTitle: "Avviare una nuova sessione demo?",
      restartConfirmText: "Verrà creata una nuova sessione isolata. I suoi dati demo attuali (comprese le foto inviate) verranno eliminati.",
      restartConfirmOk: "Avvia nuova sessione",
      cancel: "Annulla",
      shareTitle: "Condividi & porta con te",
      qrHint: "Codice QR alla demo giuria",
      copyLink: "Copia link",
      copiedToast: "Link copiato.",
      downloadPdf: "Percorso in PDF",
      endDemo: "Termina la demo in sicurezza",
      endingToast: "Sessione demo terminata in sicurezza.",
      pdf: {
        title: "Demo giuria · Riepilogo",
        checksTitle: "Cosa ha visto la giuria",
        aboutTitle: "Informazioni su SocialCheck",
        aboutText: "SocialCheck è la piattaforma di approvazione centrale e sicura per le PMI in Germania, Austria e Svizzera: KEWAG crea e pianifica i post, le clienti e i clienti verificano e decidono semplicemente con il semaforo — Verde = approvare, Rosso = richiesta di modifica, Blu = domanda/commento. Sostituisce le approvazioni disordinate via e-mail, WhatsApp e singoli file con un processo tracciabile e separato per cliente. Inoltre, SocialCheck Pocket consente di inviare foto in mobilità, in modo sicuro, direttamente a KEWAG.",
        linkLabel: "Apri la demo:",
        generatedOn: "Creato il",
        fileName: "SocialCheck-Demo-Giuria.pdf",
      },
    },
    securityTitle: "Sicurezza & trasparenza",
    footerBadges: [
      "Senza password", "Solo dati demo", "Disponibile 7 giorni", "Sessione chiusa dopo 2 h di inattività",
      "Nuova sessione in qualsiasi momento", "Nessuna pubblicazione esterna", "Nessun accesso ai clienti reali",
    ],
    closing: "Buon test – siamo convinti che ne rimarrà entusiasta!",
    unavailableTitle: "La demo giuria SocialCheck non è attualmente disponibile.",
    unavailableExpired: "Il periodo di demo è terminato.",
    unavailableDisabled: "La demo è stata temporaneamente disattivata.",
    unavailableInvite: "Le riapriamo volentieri l'accesso.",
    demoPeriod: "Periodo di demo",
    contactKewag: "Contatta KEWAG",
    backToWebsite: "Al sito SocialCheck",
    rd: {
      eyebrow: "SocialCheck · Social Media Made Simple",
      h1a: "I social media, gestiti.",
      h1b: "Approvazioni semplici come un semaforo.",
      heroSub: "KEWAG crea e gestisce i tuoi contenuti social. Tu verifichi, commenti e approvi – in un cockpit semplice per le PMI in Germania, Austria e Svizzera.",
      trust: "Funzioni reali · Dati demo isolati · Desktop & mobile",
      ctaPrimary: "Avvia la demo giuria",
      ctaSecondary: "Vedi la vista cliente",
      shotFreigaben: "Approvazioni a semaforo · Cockpit cliente",
      shotControlos: "KEWAG Control OS · Panoramica",
      shotCockpit: "Cockpit cliente · Panoramica",
      shotPocket: "SocialCheck Pocket",
      ampel: {
        title: "Un colpo d'occhio. Una decisione.",
        sub: "KEWAG prepara il post. Il cliente decide. Tutti vedono subito lo stato attuale.",
        green: { label: "Verde", state: "Approvato", desc: "Il post è approvato e pronto per la pubblicazione." },
        orange: { label: "Arancione", state: "Da verificare", desc: "In attesa della decisione del cliente." },
        red: { label: "Rosso", state: "Modifica richiesta", desc: "Il cliente richiede una modifica – KEWAG la rielabora." },
        blue: { label: "Blu", state: "Domanda / commento", desc: "Una domanda aperta o un commento sul post." },
      },
      how: {
        title: "Come funziona SocialCheck",
        sub: "Dall'idea alla pubblicazione – un flusso chiaro e tracciabile.",
        s1t: "KEWAG crea", s1d: "Contenuto, testo, immagine, piattaforma e orario di pubblicazione vengono preparati.",
        s2t: "Il cliente verifica", s2d: "Visualizzare, commentare, richiedere modifiche o approvare direttamente con il semaforo.",
        s3t: "KEWAG pubblica", s3d: "Approvazioni, commenti, calendario e report restano centralizzati e tracciabili.",
      },
      showcase: {
        title: "Un sistema. Tre ambienti di lavoro perfettamente collegati.",
        sub: "SocialCheck collega KEWAG, il cliente e l'uso mobile in un flusso chiaro.",
        controlosBadge: "KEWAG · Interno", controlosTitle: "KEWAG Control OS", controlosDesc: "KEWAG gestisce clienti, post, approvazioni, calendario e report in modo centralizzato.", controlosCta: "Vedi l'area di lavoro KEWAG",
        cockpitBadge: "Cliente", cockpitTitle: "Cockpit cliente", cockpitDesc: "Il cliente vede solo ciò di cui ha davvero bisogno: verificare, commentare e decidere.", cockpitCta: "Vedi la vista cliente",
        pocketBadge: "Mobile", pocketTitle: "SocialCheck Pocket", pocketDesc: "Approvazioni e informazioni sempre disponibili su mobile.", pocketCta: "Vedi la vista mobile",
      },
      platform: {
        eyebrow: "Controllo della piattaforma",
        title: "Un livello di controllo centrale per il tuo ecosistema social.",
        sub: "Collegare le piattaforme. Gestire le autorizzazioni. Monitorare lo stato delle integrazioni.",
        body: "SocialCheck centralizza le connessioni alle piattaforme, i diritti di accesso e lo stato delle integrazioni — offrendo a KEWAG un unico luogo affidabile per gestire la base tecnica dietro ogni workflow del cliente.",
        shot: "KEWAG Control OS · Integrazioni",
        cards: [
          { n: "01", t: "Connessioni alle piattaforme", d: "Gestione centralizzata di piattaforme e servizi collegati." },
          { n: "02", t: "Autorizzazioni & accesso", d: "Controllo chiaro su chi può accedere, gestire e usare ogni connessione." },
          { n: "03", t: "Stato delle integrazioni", d: "Vedere lo stato delle connessioni e individuare i problemi prima che interrompano il workflow." },
        ],
        layersTitle: "Una piattaforma. Tutti i livelli operativi collegati.",
        layers: [
          "KEWAG svolge il lavoro",
          "I clienti verificano e approvano",
          "SocialCheck controlla il workflow",
          "Le integrazioni collegano l'infrastruttura operativa",
          "Le autorizzazioni tengono gli accessi sotto controllo",
          "Lo stato delle integrazioni mantiene le operazioni affidabili",
        ],
      },
      why: {
        title: "Perché è nato SocialCheck",
        withoutTitle: "Senza SocialCheck",
        withTitle: "Con SocialCheck",
        without: ["E-mail", "WhatsApp", "file sparsi", "domande infinite", "approvazioni poco chiare", "commenti dispersi", "nessuna panoramica"],
        with: ["Uno stato centrale", "Responsabilità chiare", "Commenti tracciabili", "Approvazioni a semaforo", "Calendario", "Report", "Accesso mobile"],
      },
      value: {
        title: "KEWAG fa il lavoro. Il cliente mantiene il controllo.",
        p1t: "Meno lavoro", p1d: "Il cliente non deve organizzare i social media da solo.",
        p2t: "Approvazioni chiare", p2d: "Ogni decisione è visibile e tracciabile.",
        p3t: "Flusso scalabile", p3d: "Un processo strutturato per molte PMI, post e piattaforme.",
        sub: "Realizzato per le PMI in Germania, Austria e Svizzera. Progettato per crescere ulteriormente.",
      },
      features: {
        title: "Tutto ciò che rende semplice la collaborazione",
        items: [
          { t: "Aree KEWAG e cliente separate", d: "Area di lavoro interna e vista cliente nettamente separate." },
          { t: "Ruoli & autorizzazioni", d: "Diritti lato server per ogni persona e ogni mandante." },
          { t: "Approvazioni a semaforo", d: "Verde, arancione, rosso e blu – la decisione a colpo d'occhio." },
          { t: "Commenti & richieste di modifica", d: "Feedback direttamente sul post, completamente tracciabili." },
          { t: "Calendario & report", d: "Post pianificati e report mensili da un'unica fonte." },
          { t: "Desktop & mobile", d: "Accesso completo alla scrivania e in mobilità." },
        ],
        disclaimer: "Dati demo isolati · nessun dato reale dei clienti",
      },
      final: {
        title: "SocialCheck in azione.",
        sub: "Scopri quanto possono essere semplici le approvazioni sui social media.",
        cta1: "Avvia la demo giuria",
        cta2: "Apri la vista cliente",
        disclaimer: "Nessun dato reale dei clienti · ambiente demo sicuro",
      },
    },
  },
  banner: {
    title: "Demo giuria SocialCheck",
    isolated: "Sessione isolata",
    noPublish: "Nessuna pubblicazione esterna",
    timeout: "La sessione termina dopo 2 h di inattività",
    until: "fino al",
    restart: "Avvia una nuova demo",
    exit: "Termina la demo",
  },
  ticker: {
    title: "Attività demo in tempo reale",
    sessionOne: "sessione attiva",
    sessionMany: "sessioni attive",
    decisions: "decisioni (48 h)",
    caps: { gruen: "Approvare", orange: "Da verificare", rot: "Richiesta di modifica", blau: "Domanda / commento" },
    events: { approved: "Contenuto approvato", change_requested: "Richiesta di modifica inviata", question: "Domanda / commento inviato", reviewed: "Contenuto verificato" },
    empty: "Sia la prima giuria – ogni decisione di approvazione appare qui in tempo reale e anonimizzata.",
    footer: "Anonimizzato · nessun dato reale dei clienti · solo attività della demo giuria",
    now: "proprio ora",
    minAgo: "{n} min fa",
    hrAgo: "{n} h fa",
  },
  nav: {
    section: "Demo giuria",
    dashboard: "Panoramica",
    freigaben: "Approvazioni / Semaforo",
    beitraege: "Contenuti",
    kalender: "Calendario",
    report: "Report mensile",
    integrationen: "Integrazioni",
    pocket: "SocialCheck Pocket",
  },
  tour: {
    progress: ["Panoramica", "Contenuti", "Semaforo", "Calendario", "Pocket"],
    stationWord: "Tappa",
    ofWord: "di",
    next: "Avanti",
    back: "Indietro",
    finish: "Concludi la demo giuria",
    exit: "Esci dalla demo",
    safeBadge: "Demo giuria · mandante di demo isolato · sicuro",
    stations: [
      { title: "Panoramica giuria SocialCheck", desc: "Il suo punto di partenza: lo stato di tutti i post e la logica centrale del semaforo di questa sessione demo isolata, a colpo d'occhio." },
      { title: "Contenuti e anteprima", desc: "Verifichi i post preparati con anteprima live, testo, immagine, canali e data pianificata – esattamente come li vede il cliente." },
      { title: "Approvazioni / Semaforo – verde, rosso e blu", desc: "Decida col semaforo: Verde = approvare, Rosso = richiesta di modifica, Blu = domanda/commento. Provi pure tutte e tre le reazioni." },
      { title: "Calendario, report mensile e stato integrazioni", desc: "Veda come calendario, report mensile e stato onesto delle integrazioni usano gli stessi dati verificati (raggiungibili in ogni momento dal menu)." },
      { title: "SocialCheck Pocket", desc: "Invii in mobilità una foto a KEWAG in modo sicuro – un vero caricamento demo, ma completamente isolato a questa sessione." },
    ],
  },
  pocketDemo: {
    badge: "Demo giuria · mandante di demo isolato · sicuro",
    title: "SocialCheck Pocket",
    subtitle: "Così le clienti e i clienti inviano in mobilità foto in modo sicuro direttamente a KEWAG.",
    securityNote: "Demo giuria: questa foto viene salvata esclusivamente nella sua sessione demo isolata ed eliminata automaticamente alla scadenza. Non viene trasmessa a clienti reali né a sistemi esterni.",
    take: "Scatta una foto",
    choose: "Scegli dalla galleria",
    dropTitle: "Aggiungi una foto",
    dropHint: "Scatta o scegli dalla galleria",
    notePlaceholder: "Aggiungi un messaggio (facoltativo)…",
    send: "Invia in sicurezza",
    uploading: "Trasmissione sicura in corso",
    change: "Altra foto",
    successToast: "Foto salvata in modo sicuro nella sua sessione demo.",
    errorType: "Selezioni un'immagine (JPG, PNG, WEBP o HEIC).",
    errorTooLarge: "L'immagine è troppo grande.",
    errorGeneric: "Caricamento non riuscito. Riprovi.",
    galleryTitle: "Inviato in questa sessione demo",
    galleryEmpty: "Nessuna foto inviata finora.",
    isolatedBadge: "Visibile solo in questa sessione",
    autoDelete: "Eliminato automaticamente alla scadenza della sessione.",
  },
  mobile: {
    stationOf: "Tappa {n} di {t}",
    ofShort: "{n} di {t}",
    menuRestart: "Riavvia la demo",
    menuEnd: "Termina la demo in sicurezza",
    back: "Indietro",
    next: "Avanti",
    finish: "Concludi la demo",
    langSheetTitle: "Scegli la lingua",
    optionsAria: "Altre opzioni",
    statusIsolated: "Demo giuria isolata",
    pocketTitle: "Invia una foto in sicurezza a KEWAG",
    pocketText: "Scatta o scegli una foto – KEWAG la riceve in sicurezza in questa demo isolata.",
    securityToggle: "Sicurezza e privacy",
    securityShort: "La foto viene salvata solo in questa sessione demo isolata ed eliminata automaticamente alla scadenza.",
    pwaTitle: "Installa SocialCheck come app",
    pwaIos: "Tocca « Condividi » e poi « Aggiungi a Home ».",
    pwaAndroidCta: "Installa nella schermata Home",
    pwaGeneric: "Dal menu del browser « Aggiungi a schermata Home ».",
    pwaDismiss: "Più tardi",
  },
  controlOS: {
    docTitle: "KEWAG Control OS – Demo giuria",
    title: "KEWAG Control OS",
    subtitle: "Area di lavoro interna – ecco come KEWAG gestisce i post di questo mandante.",
    badge: "Demo giuria · mandante demo isolato · sola lettura",
    readOnlyNote: "Vista in sola lettura: nella demo giuria modifica, approvazione e pubblicazione sono volutamente disattivate.",
    viewCustomerBtn: "Cosa vede il cliente",
    backBtn: "Alla pagina iniziale della giuria",
    empty: "Nessun post nel mandante demo.",
    colPost: "Post",
    colInternal: "Stato di produzione interno",
    colAmpel: "Semaforo (decisione cliente)",
    colCustomer: "Stato visibile al cliente",
    colPlan: "Pianificato",
    colChannels: "Canali",
    ownerKewag: "KEWAG",
    ownerCustomer: "Cliente",
    syncNote: "Lo stato interno e la vista cliente si basano sugli stessi dati verificati.",
    psLabels: { entwurf: "Bozza", in_arbeit: "In lavorazione", intern_in_pruefung: "Verifica interna", zur_freigabe: "Da approvare", freigegeben: "Approvato", geplant: "Pianificato", veroeffentlicht: "Pubblicato", fehlgeschlagen: "Fallito", pausiert: "In pausa", archiviert: "Archiviato" },
    ampLabels: { rot: "Rosso", blau: "Blu", orange: "Arancione", gruen: "Verde", neutral: "Neutro" },
    cvsLabels: { in_vorbereitung: "In preparazione", zur_pruefung: "Da verificare", in_bearbeitung: "In lavorazione", geplant: "Pianificato", freigegeben: "Approvato", veroeffentlicht: "Pubblicato", kewag_pruefung: "KEWAG verifica", abgeschlossen: "Completato" },
  },
  integrations: {
    docTitle: "SocialCheck – KEWAG Social Gateway (demo giuria)",
    title: "KEWAG Social Gateway",
    subtitle: "Stato in tempo reale della connessione social centrale – verificato interamente lato server, onesto e senza pubblicazioni esterne.",
    error: "Lo stato del gateway non è disponibile qui.",
    gatewayTitle: "KEWAG Social Gateway",
    gatewayLabel: "Connessione centrale per tutte le piattaforme social",
    statusBadge: { ready: "Operativo", checking: "Verifica in corso", action_required: "Azione necessaria", inactive: "Inattivo" },
    readiness: "{passed}/{total} verifiche di sistema superate",
    lastChecked: "Ultima verifica",
    refresh: "Aggiorna",
    autoRefresh: "Aggiornamento automatico ogni 30 sec.",
    publishOff: "Pubblicazione esterna disattivata lato server",
    checksTitle: "Verifiche di sistema (in tempo reale, lato server)",
    checks: {
      approval_workflow: { title: "Flusso di approvazione", desc: "Flusso di approvazione attivo lato server." },
      comments_history: { title: "Commenti e cronologia", desc: "Commenti e cronologia disponibili lato server." },
      calendar_sync: { title: "Sincronizzazione calendario", desc: "Sincronizzazione del calendario funzionante internamente." },
      report_sync: { title: "Sincronizzazione report", desc: "Report mensile funzionante internamente." },
      tenant_isolation: { title: "Isolamento dei mandanti", desc: "Isolamento dei mandanti attivo lato server." },
      session_isolation: { title: "Isolamento della sessione", desc: "Isolamento della sessione attivo lato server." },
      external_publishing_off: { title: "Pubblicazione esterna", desc: "Pubblicazione esterna disattivata lato server." },
      real_data_locked: { title: "Dati reali bloccati", desc: "Dati reali bloccati per la giuria." },
    },
    states: { functional: "Funzionante", active: "Attivo", disabled: "Disattivato", locked: "Bloccato", checking: "Verifica", action_required: "Azione necessaria" },
    providersTitle: "Connessioni alle piattaforme (stato onesto)",
    providerStates: {
      connected: "Connesso",
      prepared: "Preparato – non ancora connesso",
      credentials_missing: "Credenziali mancanti – non connesso",
      adapter_prepared: "Adattatore preparato",
    },
    actionsTitle: "Azione necessaria",
    noActions: "Nessuna azione in sospeso – tutte le verifiche necessarie superate.",
    actions: {
      enable_gateway: "Attivare il gateway.",
      disable_publishing: "Disattivare la pubblicazione esterna (obbligatorio nella demo giuria).",
      fix_tenant_isolation: "Ripristinare l'isolamento dei mandanti.",
      fix_session_isolation: "Ripristinare l'isolamento della sessione.",
      fix_real_data_locked: "Ripristinare il blocco dei dati reali.",
    },
    securityTitle: "Sicurezza & trasparenza",
    notes: {
      isolated_demo_only: "Vengono mostrati esclusivamente dati demo isolati.",
      tenant_isolation: "Isolamento dei mandanti attivo – nessun accesso ai clienti reali.",
      no_external_publishing: "Le pubblicazioni esterne sono disattivate lato server.",
      no_false_status: "Nessuno stato « connesso » falso – massima trasparenza.",
    },
  },
  kalender: {
    ampelOpts: { rot: "Rosso — richiesta di modifica", blau: "Blu — domanda aperta", orange: "Arancione — in attesa di approvazione", gruen: "Verde — approvato", neutral: "Neutro" },
    prodOpts: { entwurf: "Bozza", in_arbeit: "In lavorazione", intern_in_pruefung: "In verifica interna", zur_freigabe: "Da approvare", freigegeben: "Approvato", geplant: "Pianificato", veroeffentlicht: "Pubblicato", fehlgeschlagen: "Fallito", pausiert: "In pausa", archiviert: "Archiviato" },
    kundeAll: "Cliente: tutti", ampelAll: "Semaforo: tutti", prodAll: "Stato di produzione: tutti", verantwortlichAll: "Responsabile: tutti",
    ampelHeading: "Semaforo — decisione del cliente", prodHeading: "Stato di produzione — interno", noActiveDecision: "Nessuna decisione cliente attiva", prodUnavailable: "Stato non disponibile",
    verValid: "L'approvazione vale per questa versione", verStale: "Il contenuto è stato modificato – nuova approvazione del cliente richiesta", verNone: "Ancora nessuna approvazione per questa versione",
    customerViewTitle: "Vista del cliente", customerPrep: "In preparazione", customerViewHint: "Questa visualizzazione è usata nel cockpit del cliente.", lastViewed: "Ultima visualizzazione del cliente:", notViewed: "Non ancora visualizzato dal cliente",
    openCustomerPreview: "Apri anteprima cliente", previewLocked: "Non ancora sbloccato per il cliente — anteprima disponibile appena il post è pronto per l'approvazione.",
    internalNote: "Nota interna (solo KEWAG)", edit: "Modifica", save: "Salva", cancel: "Annulla", noInternalNote: "Nessuna nota interna.", duplicate: "Duplica", markOpen: "Segna come aperto", markDone: "Segna come completato",
    title: "Calendario social",
    views: { monat: "Mese", woche: "Settimana", liste: "Elenco" },
    wochenplan: "Piano settimanale",
    kpi: {
      zur_freigabe: { label: "Da approvare", sub: "In attesa della sua approvazione" },
      freigegeben: { label: "Approvato", sub: "Pronto / pianificato" },
      diese_woche_geplant: { label: "Pianificato questa settimana", sub: "Contenuti pianificati" },
      veroeffentlicht: { label: "Pubblicato", sub: "Già online" },
      alle: "Tutti i contenuti", inRange: "In questo periodo",
    },
    kpiInternal: {
      zur_freigabe: { label: "Da approvare", sub: "In attesa del cliente" },
      aenderungen: { label: "Modifiche aperte", sub: "Richiesta di modifica" },
      diese_woche_geplant: { label: "Pianificato questa settimana", sub: "Contenuti pianificati" },
      fragen: { label: "Domande / commenti", sub: "Domande aperte" },
    },
    probleme: "Problemi",
    newPost: "Nuovo post",
    noProblems: "Nessun problema aperto",
    resendForApproval: "Invia di nuovo per approvazione",
    onlyBooked: "Solo i canali prenotati",
    notBooked: "non prenotato",
    notBookedTitle: "Piattaforma/e non prenotata/e: {labels}. Disponibile come canale aggiuntivo.",
    wp: {
      title: "Piano settimanale · Questa settimana",
      desc: "{name} · Anteprima delle pubblicazioni pianificate (lun–dom). Condivisibile in PDF.",
      thisWeek: "Questa settimana",
      posts: "post",
      approvedPlanned: "approvato/pianificato",
      published: "pubblicato",
      awaitingApproval: "da approvare",
      loading: "Caricamento…",
      today: "Oggi",
      noPosts: "— nessun post —",
      liveNote: "Lo stato corrisponde esattamente allo stato di approvazione attuale — dati reali in tempo reale.",
      creating: "Creazione…",
      downloadPdf: "Scarica in PDF",
      postCountOne: "{n} post",
      postCountMany: "{n} post",
      weekdaysFull: ["Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato", "Domenica"],
      locale: "it-CH",
    },
    search: "Cerca nel titolo, nel testo…",
    chooseRange: "Scegli un periodo", thisWeek: "Questa settimana", nextWeek: "Prossima settimana",
    von: "Dal", bis: "Al", reset: "Reimposta", apply: "Applica",
    overdueOnly: "Solo in ritardo", statusAll: "Stato: tutti", platformAll: "Piattaforma: tutte", resetFilters: "Reimposta i filtri",
    today: "Oggi", loading: "Caricamento…", emptyFilter: "Nessun contenuto nel filtro.", more: "in più", paginationUnit: "contenuti",
    autoPublished: "Pubblicato automaticamente", lastUpdate: "Ultimo aggiornamento", refresh: "Aggiorna", weekFrom: "Settimana dal",
    state: { entwurf: "Bozza", zur_freigabe: "In attesa della sua approvazione", freigegeben: "Approvato", aenderungswunsch: "Richiesta di modifica", frage: "Domanda / commento", veroeffentlicht: "Pubblicato" },
    stateStaff: { entwurf: "Bozza", zur_freigabe: "Da approvare", freigegeben: "Approvato", aenderungswunsch: "Richiesta di modifica", frage: "Domanda / commento", veroeffentlicht: "Pubblicato" },
    weekdays: ["Lu", "Ma", "Me", "Gi", "Ve", "Sa", "Do"],
    detailEmpty: "Selezioni un contenuto per vedere i dettagli.", plannedFor: "Pianificato per:",
    customerComment: "Commento del cliente", noCustomerComment: "Ancora nessun commento del cliente.", by: "di",
    decisionTitle: "Decisione del cliente",
    dueOverdue: "In ritardo dal {d} — approvi al più presto.",
    dueHint: "Approvi entro il {d}, altrimenti la pubblicazione slitterà.",
    approve: "Contrassegna come approvato", requestRed: "Richiesta di modifica (rosso)", questionBlau: "Domanda / commento (blu)",
    noApproval: "Nessuna approvazione in sospeso.", askAnytime: " — può porre una domanda in qualsiasi momento.", question: "Domanda / commento",
    dlgRedTitle: "Registra la richiesta di modifica", dlgRedDesc: "Registri la richiesta di modifica (obbligatorio). Il team KEWAG se ne occupa.", phRed: "La sua richiesta di modifica…", submitRed: "Invia la richiesta di modifica",
    dlgBlauTitle: "Domanda / commento", dlgBlauDesc: "Ponga una domanda o lasci un commento su questo contenuto.", phBlau: "La sua domanda o il suo commento…", submitBlau: "Invia",
    historyTitle: "Cronologia semaforo", noEvents: "Ancora nessun evento.", showLess: "Mostra di meno", showFull: "Mostra la cronologia completa",
    noTenant: "Nessun mandante selezionato.",
    staff: {
      decGreen: "Contrassegnato come approvato.", decRed: "Richiesta di modifica registrata.", decBlau: "Domanda / commento registrato.", decAmber: "Rinviato al cliente.",
      reminderSent: "Promemoria inviato al cliente.", noteSaved: "Nota salvata.", duplicated: "Post duplicato (come bozza).", markedDone: "Contrassegnato come completato.", markedOpen: "Contrassegnato come aperto.",
      noTenantForPreview: "Nessun mandante trovato per la vista cliente.", titleRequired: "Titolo obbligatorio", postCreated: "Post creato (stato: bozza)",
      wpDownloaded: "Piano settimanale scaricato in PDF.", wpFailed: "Impossibile generare il PDF.",
      fAvgOrange: "Tempo di risposta medio Arancione", fAvgRed: "Tempo di risposta medio Rosso", fAvgBlau: "Tempo di risposta medio Blu", fAvgTotal: "Tempo di risposta (totale)",
      fApprovedToday: "Approvati oggi", fPlanned: "Post pianificati", fPublishedWeek: "Pubblicati questa settimana", unitDays: "giorni", unitHours: "h",
      createTitle: "Crea un nuovo post", fTitle: "Titolo", fChannel: "Canale", fSchedule: "Pianificato il", fContent: "Contenuto", saving: "Salvataggio…", create: "Crea",
    },
  },
  beitraege: {
    colAmpel: "Semaforo", colResponsible: "Responsabile", editAction: "Modifica", submitReviewAction: "Invia per approvazione",
    submitReviewShort: "Per approvazione", markPublished: "Segna come pubblicato", archiveAction: "Archivia", unarchiveAction: "Ripristina",
    newPost: "Crea post", reminders: "Promemoria", reminderConfigTitle: "Configura i promemoria di approvazione", respAll: "Tutti",
    internalNoteLabel: "Nota interna (solo KEWAG)", categoryLabel: "Categoria",
    ws: { zur_freigabe: "In attesa della sua approvazione", freigegeben: "Approvato", veroeffentlicht: "Pubblicato", aenderungswunsch: "Richiesta di modifica" },
    kpi: { alle: "Tutti i contenuti", zur_freigabe: "In attesa di approvazione", freigegeben: "Approvato", veroeffentlicht: "Pubblicato", aenderungswunsch: "Richiesta di modifica" },
    noTenant: "Nessun mandante assegnato.",
    pageSubtitle: "Tutti i contenuti di {name} — verificare, approvare e dare un riscontro.",
    loadError: "Impossibile caricare i contenuti",
    ampelPrefix: "Semaforo: ",
    overdue: "In ritardo", dueUntil: "Da approvare entro",
    colTitle: "Titolo", colChannel: "Canale", colStatus: "Stato", colPlanned: "Pianificato per", colActions: "Azioni",
    untitled: "Senza titolo", notScheduled: "Non pianificato", emptyList: "Nessun contenuto trovato.", previewAction: "Anteprima",
    allChannels: "Tutti i canali", search: "Cerca contenuti...", resetFilters: "Reimposta i filtri",
    countOne: "contenuto", countMany: "contenuti",
    previewEmpty: "Nessun contenuto selezionato.", previewTitle: "Anteprima del contenuto",
    bodyLabel: "Testo del contenuto", showMore: "Mostra di più", showLess: "Mostra di meno",
    platforms: "Piattaforme", plannedTime: "Momento di pubblicazione previsto", customerNote: "Nota del cliente",
    decTitle: "La sua decisione", decWaiting: "Questo contenuto è in attesa della sua approvazione.",
    decNoAction: "Nessuna azione in sospeso.", decAskAnytime: "Può porre una domanda in qualsiasi momento.",
    decOverdue: "In ritardo dal {d} — approvi al più presto per non ritardare ulteriormente la pubblicazione.",
    decDueHint: "Approvi entro il {d}, altrimenti la pubblicazione slitterà.",
    decApprove: "Approvare", decRequest: "Richiedi una modifica", decQuestion: "Domanda / commento",
    dlgRequestTitle: "Richiedi una modifica", dlgRequestDesc: "Descriva brevemente cosa va modificato. Il team KEWAG se ne occupa.",
    phRequest: "La sua richiesta di modifica…", submitRequest: "Invia la richiesta di modifica",
    dlgQuestionTitle: "Domanda / commento", dlgQuestionDesc: "Ponga una domanda o lasci un commento su questo contenuto.",
    phQuestion: "La sua domanda o il suo commento…", submitQuestion: "Invia", actionFailed: "Azione non riuscita",
    historyTitle: "Cronologia stati", noEvents: "Ancora nessun evento.", comments: "Commenti", noComments: "Ancora nessun commento.",
    you: "Lei", kewagTeam: "Team KEWAG",
    toastApproved: "Approvato — grazie mille!", toastRequested: "Richiesta di modifica inviata", toastQuestion: "Il suo messaggio è stato inviato",
    bulkWaitingOne: "contenuto in attesa", bulkWaitingMany: "contenuti in attesa", bulkOnYou: "della sua approvazione",
    selected: "selezionato/i", selectBtn: "Seleziona", approveAllN: "Approva tutti ({n})", markAll: "Contrassegna tutti",
    approveN: "Approva {n}", approveBtn: "Approva", requestChange: "Richiedi una modifica",
    bulkConfirmTitle: "Approva i contenuti",
    bulkConfirmDesc: "Verifichi la selezione. Può deselezionare singoli contenuti — solo quelli spuntati verranno approvati per la pubblicazione dal team KEWAG.",
    bulkSelectedOf: "{a} di {b} {unit} selezionato/i", selectAll: "Seleziona tutti", deselectAll: "Deseleziona tutti",
    noWaiting: "Nessun contenuto in attesa.", cancel: "Annulla",
    approvePostOne: "Approva 1 contenuto", approvePostN: "Approva {n} contenuti",
    bulkResultTitle: "Esito dell'approvazione multipla", bulkResultDesc: "Non tutti i contenuti sono stati approvati. Di seguito l'esito per ogni contenuto.",
    rSelected: "Selezionati", rApproved: "Approvati", rSkipped: "Saltati", rFailed: "Non riusciti",
    requestSkipped: "Richiedi la revisione dei contenuti saltati", retry: "Riprova", close: "Chiudi",
    bulkRequestTitle: "Richiesta di modifica multipla",
    bulkRequestDesc: "La sua nota si applica a tutti i {n} contenuti selezionati. Il team KEWAG li rielabora di conseguenza.",
    phBulkRequest: "Cosa va modificato in questi contenuti?", sendChangeRequest: "Invia la richiesta di modifica",
    toastBulkApprovedOne: "1 contenuto approvato con successo.", toastBulkApprovedMany: "{n} contenuti approvati con successo.",
    toastBulkNone: "Nessun contenuto aperto da rielaborare – i contenuti sono già conclusi.",
    toastBulkRequestedOne: "Richiesta di modifica inviata per 1 contenuto", toastBulkRequestedMany: "Richiesta di modifica inviata per {n} contenuti",
    bulkApproveFailed: "Approvazione multipla non riuscita", bulkRequestFailed: "Richiesta di modifica multipla non riuscita",
    staff: {
      statusUpdated: "Stato aggiornato", statusChangeFailed: "Modifica dello stato non riuscita",
      archived: "Post archiviato", archiveFailed: "Archiviazione non riuscita", unarchived: "Post ripristinato", unarchiveFailed: "Ripristino non riuscito",
      remindSentEmail: "Promemoria inviato per {posts} post a {recipients} destinatari", remindSentInApp: "Promemoria in-app inviato per {posts} post (invio e-mail non configurato)", remindFailed: "Promemoria non riuscito",
      settingsLoadFailed: "Impossibile caricare le impostazioni", settingsSaved: "Impostazioni promemoria salvate", saveFailed: "Salvataggio non riuscito",
      waitingOne: "post in attesa", waitingMany: "post in attesa", onCustomerApproval: "di approvazione del cliente", remindCustomers: "Ricorda ai clienti",
      reminderDialogTitle: "Promemoria di approvazione", reminderDialogDesc: "Definisci quando e con quale frequenza i clienti ricevono un promemoria automatico per le approvazioni in sospeso.",
      autoRemindActive: "Promemoria automatici attivi", daysToFirst: "Giorni al 1° promemoria", intervalDays: "Intervallo (giorni)", maxCount: "Numero max.",
      reminderExample: "Esempio: primo promemoria dopo {wait} giorno/i, poi ogni {interval} giorno/i, al massimo {max}×.",
      dueLeadLabel: "Scadenza approvazione: anticipo prima della pubblicazione (giorni)", dueLeadHint: "I clienti vedono «Approvare entro il GG.MM.» — {days} giorno/i prima della data di pubblicazione prevista.",
      cancel: "Annulla", save: "Salva",
    },
  },
  freigaben: {
    title: "Approvazioni semaforo",
    subtitle: "I suoi contenuti da approvare – lei decide, KEWAG realizza.",
    kpiWartet: "In attesa di approvazione",
    kpiAenderung: "Richieste di modifica",
    kpiHeute: "In scadenza oggi",
    kpiMonat: "Approvati questo mese",
    vsPrev: "vs mese prec.",
    emptyTitle: "Al momento nessun contenuto da approvare.",
    emptyDesc: "Non appena KEWAG prepara un contenuto per lei, apparirà qui.",
    allDoneTitle: "Tutto fatto",
    allDoneDesc: "Hai deciso tutte le approvazioni in sospeso. KEWAG attua le tue decisioni.",
    allDoneToast: "Tutto fatto – nessuna approvazione in sospeso.",
    progressLabel: "{done} su {total} completati",
    inboxTitle: "Coda di approvazione",
    previewTitle: "Anteprima dal vivo",
    versionsMany: "Versioni precedenti ({n})",
    versionsOne: "Vedi la versione approvata",
    selectPost: "Selezioni un contenuto.",
    planned: "Pianificato",
    channels: "Canali",
    decisionTitle: "Decisione & riscontro",
    yourFeedback: "Il suo riscontro",
    nextStep: "Prossimo passo",
    yourDecision: "La sua decisione",
    contactPerson: "Referente",
    appointment: "Scadenza",
    approve: "Approvare",
    approveDesc: "Approva il contenuto senza modifiche.",
    conditions: "Approvare con condizioni",
    conditionsDesc: "Approva con un commento.",
    reject: "Non approvare",
    rejectDesc: "Invia una richiesta di modifica.",
    readOnlyNote: "Modalità sola lettura (vista cliente) – azioni disattivate.",
    cannotDecide: "Il suo ruolo non può approvare i contenuti (sola visualizzazione).",
    doneApproved: "Ha approvato questo contenuto.",
    donePublished: "Questo contenuto è stato pubblicato.",
    doneChangeRequested: "Richiesta di modifica inviata – KEWAG rielabora il contenuto.",
    historyTitle: "Cronologia approvazioni",
    noHistory: "Ancora nessuna cronologia.",
    trustTitle: "Verificato da KEWAG",
    trustDesc: "Prima della sua approvazione, ogni contenuto viene verificato da KEWAG: qualità di immagini e video, testo, branding, link e call-to-action.",
    detailsTitle: "Dettagli",
    createdBy: "Creato da",
    kewagTeam: "Team KEWAG",
    plannedOn: "Pianificato il",
    attachment: "Allegato",
    oneImage: "1 immagine",
    versionHistoryTitle: "Cronologia approvazioni",
    versionHistoryDesc: "Le versioni che KEWAG le ha sottoposto per l'approvazione. Così vede in ogni momento cosa ha ricevuto a ogni tornata.",
    noVersions: "Nessuna versione disponibile.",
    version: "Versione",
    current: "attuale",
    firstVersion: "Prima versione sottoposta",
    minorChanges: "Piccoli aggiustamenti",
    adjusted: "{parts} adattato/i",
    comparedTo: "Rispetto alla versione {n}:",
    provided: "Sottoposto",
    scheduledShort: "Pianificato",
    note: "Nota",
    changes: { text: "Testo", image: "Immagine", appointment: "Scadenza", channels: "Canali", category: "Categoria", note: "Nota" },
    dlgRejectTitle: "Invia una richiesta di modifica",
    dlgConditionsTitle: "Approvare con condizioni",
    dlgRejectDesc: "Cosa va modificato? La sua nota va direttamente a KEWAG (campo obbligatorio).",
    dlgConditionsDesc: "Nota / condizione facoltativa. Il contenuto viene approvato e il suo commento trasmesso a KEWAG.",
    phReject: "La sua richiesta di modifica…",
    phConditions: "La sua condizione / nota…",
    submitReject: "Invia la richiesta di modifica",
    submitConditions: "Approva con condizioni",
    toastConditions: "Approvato con condizioni – KEWAG è stato informato.",
    toastRejected: "Richiesta di modifica inviata.",
    toastApproved: "Contenuto approvato.",
    due: { none: "Nessuna scadenza", overdue: "In ritardo", today: "In scadenza oggi" },
    events: { provided_for_approval: "Sottoposto per l'approvazione", approved: "Approvato", published: "Pubblicato", change_requested: "Richiesta di modifica inviata" },
  },
  medien: {
    docTitle: "SocialCheck – Media (demo giuria)",
    title: "Demo media",
    subtitle: "Libreria multimediale esemplificativa della demo. Caricamenti ed eliminazioni sono disattivati nella demo giuria.",
    badge: "Solo visualizzazione · dati demo isolati",
    empty: "Nessun media disponibile.",
    kindImage: "Immagine",
  },
  report: {
    empty: "Nessun mandante selezionato.",
    loading: "Caricamento…",
    title: "Report mensile",
    month: "Mese",
    downloadPdf: "Scarica il PDF",
    creating: "Creazione…",
    emailSend: "Invia per e-mail",
    sending: "Invio…",
    emailNotConnected: "Per e-mail (Brevo non connesso)",
    emailSendTitle: "Invia a {email}",
    noContactTitle: "Nessun contatto registrato",
    brevoNotConnectedTitle: "Brevo (e-mail) non ancora connesso",
    goalTitle: "Obiettivo mensile",
    reached: "raggiunto",
    goalPlanned: "contenuti pianificati",
    goalPublished: "pubblicati",
    goalChangeReqOpen: "richiesta di modifica aperta",
    goalQuestions: "domande",
    progress: "Avanzamento",
    waitOne: "contenuto in attesa",
    waitMany: "contenuti in attesa",
    waitSuffix: "della sua approvazione",
    reportMonthBar: "Mese di riferimento {month} · solo i contenuti aperti (arancione) di questo mese",
    approveAllBtn: "Approva tutti i contenuti aperti di questo mese",
    kpiTotal: "Contenuti totali",
    kpiChangeReq: "Richieste di modifica",
    kpiForApproval: "Da approvare",
    kpiApproved: "Approvati",
    kpiPublished: "Pubblicati",
    vs: "vs",
    tabs: { uebersicht: "Panoramica", beitraege: "Contenuti", kanaele: "Canali", engagement: "Engagement", performance: "Performance", bestzeiten: "Orari migliori", ziele: "Obiettivi", downloads: "Download" },
    allChannels: "Tutti i canali",
    allPlatforms: "Tutte le piattaforme",
    allAmpel: "Tutti i semafori",
    ampelFilter: { rot: "Rosso — richiesta di modifica / blocco", blau: "Blu — domanda aperta / chiarimento", orange: "Arancione — in attesa di approvazione", gruen: "Verde — approvato", neutral: "Neutro — nessuna decisione" },
    allStatus: "Tutti gli stati",
    allResponsible: "Tutti i responsabili",
    searchTitles: "Cerca nei titoli…",
    resetFilters: "Reimposta i filtri",
    ampelStatusTitle: "Semaforo & stato",
    shortOverview: "Panoramica rapida:",
    ofPosts: "Su {total} contenuti —",
    yourDecisions: "Le sue decisioni:",
    publication: "Pubblicazione:",
    ampelColTitle: "Semaforo — la sua decisione",
    veroeffColTitle: "Stato di pubblicazione",
    noPostsMonth: "Nessun contenuto in questo mese.",
    ampelStatusNote: "Il semaforo mostra la sua decisione, lo stato mostra a che punto è il contenuto nel processo — i due sono indipendenti. « Pubblicato » è uno stato, non un semaforo.",
    ampelMeaning: { rot: "Richiesta di modifica / blocco", blau: "Domanda aperta / chiarimento", orange: "In attesa della sua approvazione", gruen: "Versione attuale approvata", neutral: "Nessuna decisione attiva" },
    plainAmpel: { gruen: "approvati da lei", orangeOne: "in attesa della sua approvazione", orangeMany: "in attesa della sua approvazione", rot: "con richiesta di modifica", blau: "con domanda aperta", neutral: "senza decisione aperta", empty: "nessuna decisione aperta" },
    plainStatus: { veroeffentlicht: "pubblicati", geplant: "pianificati", freigegeben: "approvati (pronti)", zur_pruefung: "da verificare", in_bearbeitung: "in corso", in_vorbereitung: "in preparazione", kewag_pruefung: "in verifica KEWAG", abgeschlossen: "conclusi", empty: "nessun contenuto" },
    postsInPrefix: "Contenuti in",
    viewTable: "Tabella",
    viewCalendar: "Calendario",
    noPostsFound: "Nessun contenuto trovato.",
    colTitlePreview: "Titolo / anteprima",
    colChannels: "Canali",
    colAmpelDecision: "Semaforo – la sua decisione",
    colStatus: "Stato",
    colResponsible: "Responsabile",
    colPlanned: "Pianificato",
    colReach: "Copertura",
    colActions: "Azioni",
    detailsTitle: "Dettagli del post",
    detailsAria: "Vedi dettagli",
    detailsClose: "Chiudi",
    goApprove: "Vai all’approvazione",
    openCalendar: "Apri nel calendario",
    detailExcerpt: "Anteprima",
    reachLabel: "Copertura",
    interactionsLabel: "Interazioni",
    paginationUnit: "contenuti",
    scheduledShort: "pianificato",
    untitled: "Senza titolo",
    postsCenter: "contenuti",
    reachTotal: "Copertura totale",
    interactionsTotal: "Interazioni totali",
    avgEngagement: "Tasso di engagement medio",
    bestTimeLabel: "Miglior orario del giorno",
    plannedNext7: "Pianificato nei prossimi 7 giorni",
    openTasks: "Attività aperte",
    openTasksLabel: "Da approvare / riscontro",
    statNotCaptured: "Non ancora rilevato — analytics non connesso.",
    notConnectedNote: "Analytics (Meta/Instagram) non ancora connesso — i valori vengono mostrati in tempo reale una volta connesso.",
    planned: "Pianificato",
    published: "Pubblicato",
    changeReqOpen: "Richiesta di modifica aperta",
    questionsOpen: "Domande aperte",
    downloadsTitle: "Download & esportazione",
    dlPdfBtn: "Scarica il report PDF",
    dlCsvBtn: "Contenuti in CSV",
    downloadsNote: "Il report PDF contiene gli indicatori, l'obiettivo e l'elenco dei contenuti di {month}.",
    distTitle: "Distribuzione dei contenuti per stato",
    distLabels: { freigegeben: "Approvato", frage_kommentar: "Domanda / commento", zur_freigabe: "Da approvare", aenderungswunsch: "Richiesta di modifica" },
    platformTitle: "Pubblicazioni per piattaforma",
    notBooked: "non prenotato",
    notBookedTitle: "Canale attualmente non prenotato — disponibile come canale aggiuntivo.",
    bookedChannels: "Canali prenotati:",
    topPostTitle: "Miglior contenuto per copertura",
    topPostEmpty: "Non ancora rilevato — analytics (Meta/Instagram) non connesso.",
    reach: "Copertura",
    interactions: "Interazioni",
    publishedOn: "Pubblicato il",
    hintsTitle: "Note & raccomandazioni",
    hints: { engagement: "Tasso di engagement: {pct} % nel periodo.", feedback_waiting: "{n} contenuto/i in attesa di riscontro del cliente.", best_time: "Orario migliore: ore {time}.", analytics_off: "Copertura/engagement vengono mostrati non appena Meta/Instagram è connesso.", none: "Nessuna particolarità in questo mese." },
    emailToCustomer: "Report via e-mail al cliente",
    recipient: "Destinatario:",
    lastSent: "ultimo invio",
    noContactEmail: "Nessun contatto cliente con e-mail registrato.",
    brevoNotConnectedFull: "Brevo (e-mail) non ancora connesso — l'invio sarà attivo una volta connesso.",
    autoMonthly: "Invio mensile automatico a fine mese",
    lastUpdate: "Ultimo aggiornamento:",
    refresh: "Aggiorna",
    dlgDoneTitle: "Approvazione completata",
    dlgApproveTitleOne: "Approvare {n} contenuto di questo mese?",
    dlgApproveTitleMany: "Approvare {n} contenuti di questo mese?",
    customerLabel: "Cliente:",
    reportMonthLabel: "Mese di riferimento:",
    dlgIntro: "Approva le versioni dei contenuti selezionati per la pianificazione o la pubblicazione. Se i contenuti verranno modificati in seguito, sarà nuovamente richiesta la sua approvazione.",
    selectedOf: "{a} di {b} selezionato/i",
    selAll: "Tutti",
    selNone: "Nessuno",
    versionBinding: "Vincolo di versione: viene approvata esattamente la versione attualmente mostrata. Se un contenuto è stato modificato nel frattempo, viene saltato e deve essere verificato di nuovo.",
    resApproved: "approvati",
    resSkipped: "saltati",
    resFailed: "non riusciti",
    resApprovedItem: "Approvato",
    cancel: "Annulla",
    confirmOne: "Approva {n} contenuto in modo vincolante",
    confirmMany: "Approva {n} contenuti in modo vincolante",
    approving: "Approvazione in corso…",
    close: "Chiudi",
    tReportLoadFail: "Impossibile caricare il report.",
    tPdfCreated: "PDF creato",
    tPdfFail: "Creazione del PDF non riuscita",
    tCsvExported: "CSV esportato",
    tNoContact: "Nessun contatto cliente con e-mail registrato.",
    tReportSent: "Report inviato.",
    tSendFail: "Invio non riuscito",
    tAutoOn: "Invio mensile automatico attivato.",
    tAutoOff: "Invio automatico disattivato.",
    tSaveFail: "Impossibile salvare",
    tApprovedOne: "1 contenuto approvato",
    tApprovedMany: "{n} contenuti approvati",
    tApproveNone: "Nessun contenuto approvato — dettagli nella finestra.",
    tApproveFail: "Approvazione non riuscita.",
    csvHeaders: ["Titolo", "Canali", "Semaforo (la sua decisione)", "Stato", "Responsabile", "Pianificato", "Copertura", "Interazioni"],
    months: ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"],
    locale: "it-CH",
  },
};

const en = {
  common: {
    loading: "Loading…",
    retry: "Try again",
    error: "This section couldn't be loaded. Please try again.",
    close: "Close",
    cancel: "Cancel",
    all: "All",
    noTenant: "No client selected.",
  },
  ampel: {
    rot: { label: "Red", sub: "Change/Blocker", full: "Red · change/blocker" },
    blau: { label: "Blue", sub: "Open question", full: "Blue · open question" },
    orange: { label: "Orange", sub: "Awaiting approval", full: "Orange · awaiting approval" },
    gruen: { label: "Green", sub: "Approved", full: "Green · approved" },
    neutral: { label: "Neutral", sub: "No pending approval", full: "Neutral · no pending approval" },
    unknown: "—",
  },
  cvs: {
    in_vorbereitung: "In preparation",
    zur_pruefung: "For review",
    in_bearbeitung: "In progress",
    geplant: "Scheduled",
    freigegeben: "Approved",
    veroeffentlicht: "Published",
    kewag_pruefung: "KEWAG reviewing",
    abgeschlossen: "Completed",
    unknown: "—",
  },
  landing: {
    docTitle: "SocialCheck – Jury Demo",
    kicker: "SocialCheck – The Jury Demo",
    heroTitle: "Social media approvals for SMEs in Germany, Austria and Switzerland —",
    heroAccent: "as simple as a traffic light.",
    subtitle: "KEWAG creates, plans and manages the social media content. Clients review, comment, request changes or approve posts through a simple traffic-light cockpit.",
    benefit: "SocialCheck simplifies social media management for SMEs in Germany, Austria and Switzerland while giving clients clear control over every approval.",
    startBtn: "Start guided jury demo",
    startSubline: "Guided tour · no sign-up required · isolated demo tenant",
    startGuided: "Start guided jury demo",
    viewControlOS: "View KEWAG workspace",
    viewCustomer: "View customer view",
    starting: "Preparing session…",
    windowInfo: "Passwordless · ready instantly · ends automatically after 7 days",
    inviteRequired: "This access is secured. Please open the official KEWAG invitation link.",
    startedToast: "Isolated jury demo session started.",
    startFailed: "The demo could not be started.",
    endedNotice: "Your previous session was ended (2h inactivity). Simply start a new, isolated session.",
    heroBadges: { days: "Available for 7 days", isolated: "Isolated demo data", noPublish: "External publishing disabled", devices: "Desktop & mobile" },
    process: {
      title: "Explained in three steps",
      cards: [
        { n: "01", title: "KEWAG creates the post", desc: "Text, image, platform, customer and publishing date are managed centrally." },
        { n: "02", title: "The customer decides via the traffic light", desc: "Green = approved, Red = change request, Blue = question/comment, Orange = decision pending." },
        { n: "03", title: "Everything stays in sync", desc: "Approval status, calendar, comments, history and reports use the same verified data." },
      ],
    },
    works: {
      title: "What really works here",
      items: [
        "KEWAG Control OS & separate customer cockpit",
        "Real user roles & server-side permissions",
        "Protected tenant and customer separation",
        "Traffic-light approvals with comments & history",
        "Red change requests block further approval",
        "Posts, calendar, media & reports",
        "Support process & audit log",
        "Honest integration & system status displays",
        "Desktop & mobile workflows",
        "Only permitted customer data in the customer view",
      ],
    },
    portals: {
      title: "One system – three perfectly connected work worlds",
      subtitle: "KEWAG Control OS, customer cockpit and SocialCheck Pocket – the same verified data, three fitting views.",
      kewag: { badge: "Internal", title: "KEWAG Control OS", desc: "This is how KEWAG organises posts, approvals, calendar and reports.", cta: "View KEWAG workspace" },
      customer: { badge: "Customer", title: "Customer Cockpit", desc: "This is how customers review, comment and decide via the traffic light.", cta: "View customer view" },
      pocket: { badge: "Mobile", title: "SocialCheck Pocket", desc: "This is how customers securely send photos and information to KEWAG on the go.", cta: "View SocialCheck Pocket" },
    },
    why: {
      title: "Why SocialCheck was built",
      beforeTitle: "Before",
      beforeText: "Approvals scattered across emails, messages, files and follow-up questions – hard to trace.",
      afterTitle: "With SocialCheck",
      afterText: "One central state, clear responsibilities, simple customer decisions and a traceable history.",
    },
    done: {
      title: "Thank you – you have experienced SocialCheck in full.",
      subtitle: "You completed the guided jury walkthrough. Here is your summary.",
      checksTitle: "What the jury saw",
      checks: {
        start: "Secure, passwordless demo start",
        isolated: "Fully isolated jury session",
        uebersicht: "SocialCheck jury overview opened",
        beitraege: "Posts & preview reviewed",
        ampel: "Approvals / traffic light (green, red, blue) opened",
        kalender: "Calendar, monthly report & integration status viewed",
        pocket: "SocialCheck Pocket tested",
        upload: "Photo transmitted securely and in isolation",
        sync: "Synchronised, verified data foundation experienced",
        noPublish: "No external publishing (blocked server-side)",
      },
      doneLabel: "done",
      todoLabel: "not opened",
      message: "SocialCheck replaces scattered approvals via email, WhatsApp and individual files with one central, secure and traceable process.",
      restart: "Restart demo",
      viewKewag: "View KEWAG Control OS",
      viewCustomer: "View customer cockpit",
      viewPocket: "View SocialCheck Pocket",
      restartConfirmTitle: "Start a new demo session?",
      restartConfirmText: "A new isolated session will be created. Your current demo data (including sent photos) will be discarded.",
      restartConfirmOk: "Start new session",
      cancel: "Cancel",
      shareTitle: "Share & take away",
      qrHint: "QR code to the jury demo",
      copyLink: "Copy link",
      copiedToast: "Link copied.",
      downloadPdf: "Walkthrough as PDF",
      endDemo: "End demo securely",
      endingToast: "Demo session ended securely.",
      pdf: {
        title: "Jury demo · Summary",
        checksTitle: "What the jury saw",
        aboutTitle: "About SocialCheck",
        aboutText: "SocialCheck is the central, secure approval platform for SMEs in Germany, Austria and Switzerland: KEWAG creates and schedules the posts, customers review and decide simply via the traffic light — Green = approve, Red = change request, Blue = question/comment. It replaces scattered approvals via email, WhatsApp and individual files with a traceable, tenant-separated process. SocialCheck Pocket additionally lets customers securely send photos to KEWAG on the go.",
        linkLabel: "Open the demo:",
        generatedOn: "Generated on",
        fileName: "SocialCheck-Jury-Demo.pdf",
      },
    },
    securityTitle: "Security & transparency",
    footerBadges: [
      "No password", "Demo data only", "Available for 7 days", "Session ends after 2h inactivity",
      "New session anytime", "No external publishing", "No access to real customers",
    ],
    closing: "Enjoy testing – we're confident you'll be impressed!",
    unavailableTitle: "The SocialCheck Jury Demo is currently unavailable.",
    unavailableExpired: "The demo period has ended.",
    unavailableDisabled: "The demo has been temporarily disabled.",
    unavailableInvite: "We'll gladly reopen access for you.",
    demoPeriod: "Demo period",
    contactKewag: "Contact KEWAG",
    backToWebsite: "To the SocialCheck website",
    rd: {
      eyebrow: "SocialCheck · Social Media Made Simple",
      h1a: "Social media, handled.",
      h1b: "Approvals as simple as a traffic light.",
      heroSub: "KEWAG creates and manages your social media content. You review, comment and approve – in one simple cockpit for SMEs in Germany, Austria and Switzerland.",
      trust: "Real features · Isolated demo data · Desktop & mobile",
      ctaPrimary: "Start jury demo",
      ctaSecondary: "View customer view",
      shotFreigaben: "Traffic-light approvals · Customer cockpit",
      shotControlos: "KEWAG Control OS · Overview",
      shotCockpit: "Customer cockpit · Overview",
      shotPocket: "SocialCheck Pocket",
      ampel: {
        title: "One glance. One decision.",
        sub: "KEWAG prepares the post. The customer decides. Everyone sees the current status instantly.",
        green: { label: "Green", state: "Approved", desc: "The post is approved and ready to publish." },
        orange: { label: "Orange", state: "In review", desc: "Waiting for the customer's decision." },
        red: { label: "Red", state: "Change requested", desc: "The customer requests a change – KEWAG revises it." },
        blue: { label: "Blue", state: "Question / comment", desc: "An open question or a comment on the post." },
      },
      how: {
        title: "How SocialCheck works",
        sub: "From idea to publication – one clear, traceable workflow.",
        s1t: "KEWAG creates", s1d: "Content, copy, image, platform and publishing time are prepared.",
        s2t: "Customer reviews", s2d: "View, comment, request changes or approve directly via the traffic light.",
        s3t: "KEWAG publishes", s3d: "Approvals, comments, calendar and reports stay centrally traceable.",
      },
      showcase: {
        title: "One system. Three perfectly connected workspaces.",
        sub: "SocialCheck connects KEWAG, the customer and mobile use in one clear workflow.",
        controlosBadge: "KEWAG · Internal", controlosTitle: "KEWAG Control OS", controlosDesc: "KEWAG manages customers, posts, approvals, calendar and reports centrally.", controlosCta: "View KEWAG workspace",
        cockpitBadge: "Customer", cockpitTitle: "Customer cockpit", cockpitDesc: "The customer sees only what they really need: review, comment and decide.", cockpitCta: "View customer view",
        pocketBadge: "Mobile", pocketTitle: "SocialCheck Pocket", pocketDesc: "Approvals and information available on mobile at any time.", pocketCta: "View mobile view",
      },
      platform: {
        eyebrow: "Platform Control",
        title: "One control layer for your social ecosystem.",
        sub: "Connect platforms. Control permissions. Monitor integration health.",
        body: "SocialCheck centralizes platform connections, access rights and integration status — giving KEWAG one reliable place to manage the technical foundation behind every customer workflow.",
        shot: "KEWAG Control OS · Integrations",
        cards: [
          { n: "01", t: "Platform connections", d: "Central management of connected platforms and services." },
          { n: "02", t: "Permissions & access", d: "Clear control over who can access, manage and use each connection." },
          { n: "03", t: "Integration health", d: "See connection status and identify problems before they interrupt the workflow." },
        ],
        layersTitle: "One platform. Every operational layer connected.",
        layers: [
          "KEWAG manages the work",
          "Customers review and approve",
          "SocialCheck controls the workflow",
          "Integrations connect the operational infrastructure",
          "Permissions keep access under control",
          "Integration health keeps operations reliable",
        ],
      },
      why: {
        title: "Why SocialCheck was built",
        withoutTitle: "Without SocialCheck",
        withTitle: "With SocialCheck",
        without: ["Emails", "WhatsApp", "scattered files", "endless follow-ups", "unclear approvals", "scattered comments", "no overview"],
        with: ["One central status", "Clear responsibilities", "Traceable comments", "Traffic-light approvals", "Calendar", "Reports", "Mobile access"],
      },
      value: {
        title: "KEWAG does the work. The customer stays in control.",
        p1t: "Less effort", p1d: "The customer doesn't have to organise social media themselves.",
        p2t: "Clear approvals", p2d: "Every decision is visible and traceable.",
        p3t: "Scalable workflow", p3d: "A structured process for many SMEs, posts and platforms.",
        sub: "Built for SMEs in Germany, Austria and Switzerland. Designed to scale further.",
      },
      features: {
        title: "Everything that makes collaboration simple",
        items: [
          { t: "Separate KEWAG & customer areas", d: "Internal workspace and customer view cleanly separated." },
          { t: "Roles & permissions", d: "Server-side rights for every person and every tenant." },
          { t: "Traffic-light approvals", d: "Green, orange, red and blue – decisions at a glance." },
          { t: "Comments & change requests", d: "Feedback right on the post, fully traceable." },
          { t: "Calendar & reports", d: "Scheduled posts and monthly reports from one source of truth." },
          { t: "Desktop & mobile", d: "Full access at the desk and on the go." },
        ],
        disclaimer: "Demo data isolated · no real customer data",
      },
      final: {
        title: "See SocialCheck in action.",
        sub: "See how simple social media approvals can be.",
        cta1: "Start jury demo",
        cta2: "Open customer view",
        disclaimer: "No real customer data · secure demo environment",
      },
    },
  },
  banner: {
    title: "SocialCheck Jury Demo",
    isolated: "Isolated session",
    noPublish: "No external publishing",
    timeout: "Session ends after 2h of inactivity",
    until: "until",
    restart: "Start new demo",
    exit: "End demo",
  },
  ticker: {
    title: "Live demo activity",
    sessionOne: "session active",
    sessionMany: "sessions active",
    decisions: "decisions (48h)",
    caps: { gruen: "Approve", orange: "For review", rot: "Change request", blau: "Question / comment" },
    events: { approved: "Post approved", change_requested: "Change requested", question: "Question / comment posted", reviewed: "Post reviewed" },
    empty: "Be the first jury – every approval decision appears here live and anonymised.",
    footer: "Anonymised · no real customer data · jury demo activity only",
    now: "just now",
    minAgo: "{n} min ago",
    hrAgo: "{n} h ago",
  },
  nav: {
    section: "Jury Demo",
    dashboard: "Overview",
    freigaben: "Approvals / Traffic light",
    beitraege: "Posts",
    kalender: "Calendar",
    report: "Monthly report",
    integrationen: "Integrations",
    pocket: "SocialCheck Pocket",
  },
  tour: {
    progress: ["Overview", "Posts", "Traffic light", "Calendar", "Pocket"],
    stationWord: "Station",
    ofWord: "of",
    next: "Next",
    back: "Back",
    finish: "Finish jury demo",
    exit: "Leave demo",
    safeBadge: "Jury demo · isolated demo tenant · secure",
    stations: [
      { title: "SocialCheck jury overview", desc: "Your starting point: the status of all posts and the central traffic-light logic of this isolated demo session at a glance." },
      { title: "Posts and preview", desc: "Review the prepared posts with live preview, text, image, channels and scheduled date – exactly as the customer sees them." },
      { title: "Approvals / Traffic light – green, red and blue", desc: "Decide via the traffic light: Green = approve, Red = change request, Blue = question/comment. Feel free to test all three reactions." },
      { title: "Calendar, monthly report and integration status", desc: "See how calendar, monthly report and the honest integration status use the same verified data (reachable anytime via the menu)." },
      { title: "SocialCheck Pocket", desc: "Securely send a photo to KEWAG on the go – a real but fully isolated demo upload of this session." },
    ],
  },
  pocketDemo: {
    badge: "Jury demo · isolated demo tenant · secure",
    title: "SocialCheck Pocket",
    subtitle: "This is how customers securely send photos to KEWAG on the go.",
    securityNote: "Jury demo: this photo is stored exclusively in your isolated demo session and automatically deleted when it expires. It is not transmitted to real customers or external systems.",
    take: "Take a photo",
    choose: "Choose from gallery",
    dropTitle: "Add a photo",
    dropHint: "Take one or choose from the gallery",
    notePlaceholder: "Add a message (optional)…",
    send: "Send securely",
    uploading: "Transmitting securely",
    change: "Different photo",
    successToast: "Photo securely stored in your demo session.",
    errorType: "Please choose an image (JPG, PNG, WEBP or HEIC).",
    errorTooLarge: "The image is too large.",
    errorGeneric: "Upload failed. Please try again.",
    galleryTitle: "Sent in this demo session",
    galleryEmpty: "No photo sent yet.",
    isolatedBadge: "Visible only in this session",
    autoDelete: "Automatically deleted when the session expires.",
  },
  mobile: {
    stationOf: "Stage {n} of {t}",
    ofShort: "{n} of {t}",
    menuRestart: "Restart demo",
    menuEnd: "End demo securely",
    back: "Back",
    next: "Next",
    finish: "Finish demo",
    langSheetTitle: "Choose language",
    optionsAria: "More options",
    statusIsolated: "Isolated jury demo",
    pocketTitle: "Send a photo securely to KEWAG",
    pocketText: "Take or choose a photo – KEWAG receives it securely in this isolated demo.",
    securityToggle: "Security & privacy",
    securityShort: "The photo is stored only in this isolated demo session and automatically deleted when it expires.",
    pwaTitle: "Install SocialCheck as an app",
    pwaIos: "Tap « Share » then « Add to Home Screen ».",
    pwaAndroidCta: "Install to home screen",
    pwaGeneric: "Use the browser menu → « Add to Home screen ».",
    pwaDismiss: "Later",
  },
  controlOS: {
    docTitle: "KEWAG Control OS – Jury Demo",
    title: "KEWAG Control OS",
    subtitle: "Internal workspace – this is how KEWAG manages this tenant's posts.",
    badge: "Jury Demo · Isolated Demo Tenant · Read Only",
    readOnlyNote: "Read-only view: in the jury demo, editing, approving and publishing are deliberately disabled.",
    viewCustomerBtn: "What the customer sees",
    backBtn: "To the jury home page",
    empty: "No posts in the demo tenant.",
    colPost: "Post",
    colInternal: "Internal production status",
    colAmpel: "Traffic light (customer decision)",
    colCustomer: "Customer-visible status",
    colPlan: "Scheduled",
    colChannels: "Channels",
    ownerKewag: "KEWAG",
    ownerCustomer: "Customer",
    syncNote: "Internal status and customer view are based on the same verified data set.",
    psLabels: { entwurf: "Draft", in_arbeit: "In progress", intern_in_pruefung: "Internal review", zur_freigabe: "For approval", freigegeben: "Approved", geplant: "Scheduled", veroeffentlicht: "Published", fehlgeschlagen: "Failed", pausiert: "Paused", archiviert: "Archived" },
    ampLabels: { rot: "Red", blau: "Blue", orange: "Orange", gruen: "Green", neutral: "Neutral" },
    cvsLabels: { in_vorbereitung: "In preparation", zur_pruefung: "For review", in_bearbeitung: "In progress", geplant: "Scheduled", freigegeben: "Approved", veroeffentlicht: "Published", kewag_pruefung: "KEWAG reviewing", abgeschlossen: "Completed" },
  },
  integrations: {
    docTitle: "SocialCheck – KEWAG Social Gateway (Jury Demo)",
    title: "KEWAG Social Gateway",
    subtitle: "Live status of the central social connection – fully verified server-side, honest and without external publishing.",
    error: "Gateway status is not available here.",
    gatewayTitle: "KEWAG Social Gateway",
    gatewayLabel: "Central connection for all social platforms",
    statusBadge: { ready: "Operational", checking: "Checking", action_required: "Action required", inactive: "Inactive" },
    readiness: "{passed}/{total} system checks passed",
    lastChecked: "Last checked",
    refresh: "Refresh",
    autoRefresh: "Auto-refreshes every 30 s.",
    publishOff: "External publishing disabled on the server",
    checksTitle: "System checks (live, server-side)",
    checks: {
      approval_workflow: { title: "Approval workflow", desc: "Approval workflow active on the server." },
      comments_history: { title: "Comments & history", desc: "Comments and history available on the server." },
      calendar_sync: { title: "Calendar synchronisation", desc: "Calendar synchronisation working internally." },
      report_sync: { title: "Report synchronisation", desc: "Monthly report working internally." },
      tenant_isolation: { title: "Tenant isolation", desc: "Tenant isolation active on the server." },
      session_isolation: { title: "Session isolation", desc: "Session isolation active on the server." },
      external_publishing_off: { title: "External publishing", desc: "External publishing disabled on the server." },
      real_data_locked: { title: "Real data locked", desc: "Real data locked for the jury." },
    },
    states: { functional: "Functional", active: "Active", disabled: "Disabled", locked: "Locked", checking: "Checking", action_required: "Action required" },
    providersTitle: "Platform connections (honest status)",
    providerStates: {
      connected: "Connected",
      prepared: "Prepared – not connected yet",
      credentials_missing: "Credentials missing – not connected",
      adapter_prepared: "Adapter prepared",
    },
    actionsTitle: "Action required",
    noActions: "No open actions – all required checks passed.",
    actions: {
      enable_gateway: "Enable the gateway.",
      disable_publishing: "Disable external publishing (required in the jury demo).",
      fix_tenant_isolation: "Restore tenant isolation.",
      fix_session_isolation: "Restore session isolation.",
      fix_real_data_locked: "Restore the real-data lock.",
    },
    securityTitle: "Security & transparency",
    notes: {
      isolated_demo_only: "Only isolated demo data is shown.",
      tenant_isolation: "Tenant isolation active – no access to real customers.",
      no_external_publishing: "External publishing is hard-disabled on the server.",
      no_false_status: "No false “connected” status – maximum transparency.",
    },
  },
  kalender: {
    ampelOpts: { rot: "Red — change request", blau: "Blue — open question", orange: "Amber — awaiting approval", gruen: "Green — approved", neutral: "Neutral" },
    prodOpts: { entwurf: "Draft", in_arbeit: "In progress", intern_in_pruefung: "Internal review", zur_freigabe: "For approval", freigegeben: "Approved", geplant: "Scheduled", veroeffentlicht: "Published", fehlgeschlagen: "Failed", pausiert: "Paused", archiviert: "Archived" },
    kundeAll: "Customer: all", ampelAll: "Traffic light: all", prodAll: "Production status: all", verantwortlichAll: "Owner: all",
    ampelHeading: "Traffic light — customer decision", prodHeading: "Production status — internal", noActiveDecision: "No active customer decision", prodUnavailable: "Status unavailable",
    verValid: "Approval applies to this version", verStale: "Content changed – renewed customer approval required", verNone: "No approval for this version yet",
    customerViewTitle: "Customer's view", customerPrep: "In preparation", customerViewHint: "This display is used in the customer cockpit.", lastViewed: "Last viewed by customer:", notViewed: "Not yet viewed by customer",
    openCustomerPreview: "Open customer preview", previewLocked: "Not yet unlocked for the customer — preview available once the post is ready for approval.",
    internalNote: "Internal note (KEWAG only)", edit: "Edit", save: "Save", cancel: "Cancel", noInternalNote: "No internal note.", duplicate: "Duplicate", markOpen: "Mark as open", markDone: "Mark as done",
    title: "Social calendar",
    views: { monat: "Month", woche: "Week", liste: "List" },
    wochenplan: "Weekly plan",
    kpi: {
      zur_freigabe: { label: "For approval", sub: "Awaiting your approval" },
      freigegeben: { label: "Approved", sub: "Ready / scheduled" },
      diese_woche_geplant: { label: "Scheduled this week", sub: "Scheduled posts" },
      veroeffentlicht: { label: "Published", sub: "Already live" },
      alle: "All posts", inRange: "In this period",
    },
    kpiInternal: {
      zur_freigabe: { label: "For approval", sub: "Awaiting customer" },
      aenderungen: { label: "Open changes", sub: "Change request" },
      diese_woche_geplant: { label: "Scheduled this week", sub: "Scheduled posts" },
      fragen: { label: "Questions / comments", sub: "Open queries" },
    },
    probleme: "Issues",
    newPost: "New post",
    noProblems: "No open issues",
    resendForApproval: "Resend for approval",
    onlyBooked: "Only booked channels",
    notBooked: "not booked",
    notBookedTitle: "Unbooked platform(s): {labels}. Available as an add-on channel.",
    wp: {
      title: "Weekly plan · This week",
      desc: "{name} · Preview of scheduled publications (Mon–Sun). Shareable as PDF.",
      thisWeek: "This week",
      posts: "posts",
      approvedPlanned: "approved/scheduled",
      published: "published",
      awaitingApproval: "for approval",
      loading: "Loading…",
      today: "Today",
      noPosts: "— no posts —",
      liveNote: "Status matches the current approval state exactly — real live data.",
      creating: "Creating…",
      downloadPdf: "Download as PDF",
      postCountOne: "{n} post",
      postCountMany: "{n} posts",
      weekdaysFull: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
      locale: "en-GB",
    },
    search: "Search title, text…",
    chooseRange: "Choose period", thisWeek: "This week", nextWeek: "Next week",
    von: "From", bis: "To", reset: "Reset", apply: "Apply",
    overdueOnly: "Overdue only", statusAll: "Status: all", platformAll: "Platform: all", resetFilters: "Reset filters",
    today: "Today", loading: "Loading…", emptyFilter: "No posts in filter.", more: "more", paginationUnit: "posts",
    autoPublished: "Auto-published", lastUpdate: "Last update", refresh: "Refresh", weekFrom: "Week of",
    state: { entwurf: "Draft", zur_freigabe: "Awaiting your approval", freigegeben: "Approved", aenderungswunsch: "Change request", frage: "Question / comment", veroeffentlicht: "Published" },
    stateStaff: { entwurf: "Draft", zur_freigabe: "For approval", freigegeben: "Approved", aenderungswunsch: "Change request", frage: "Question / comment", veroeffentlicht: "Published" },
    weekdays: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    detailEmpty: "Select a post to see details.", plannedFor: "Scheduled for:",
    customerComment: "Customer comment", noCustomerComment: "No customer comment yet.", by: "by",
    decisionTitle: "Customer decision",
    dueOverdue: "Overdue since {d} — please approve soon.",
    dueHint: "Please approve by {d}, otherwise publishing will be postponed.",
    approve: "Mark as approved", requestRed: "Change request (red)", questionBlau: "Question / comment (blue)",
    noApproval: "No approval pending.", askAnytime: " — you can ask a question anytime.", question: "Question / comment",
    dlgRedTitle: "Enter change request", dlgRedDesc: "Please record the change request (required). The KEWAG team will take care of it.", phRed: "Your change request…", submitRed: "Send change request",
    dlgBlauTitle: "Question / comment", dlgBlauDesc: "Ask a question or leave a comment on this post.", phBlau: "Your question or comment…", submitBlau: "Send",
    historyTitle: "Traffic-light history", noEvents: "No events yet.", showLess: "Show less", showFull: "Show full history",
    noTenant: "No client selected.",
    staff: {
      decGreen: "Marked as approved.", decRed: "Change request recorded.", decBlau: "Question / comment recorded.", decAmber: "Sent back to the client.",
      reminderSent: "Reminder sent to the client.", noteSaved: "Note saved.", duplicated: "Post duplicated (as draft).", markedDone: "Marked as done.", markedOpen: "Marked as open.",
      noTenantForPreview: "No client found for the customer view.", titleRequired: "Title required", postCreated: "Post created (status: draft)",
      wpDownloaded: "Weekly plan downloaded as PDF.", wpFailed: "Could not generate the PDF.",
      fAvgOrange: "Avg. response time Orange", fAvgRed: "Avg. response time Red", fAvgBlau: "Avg. response time Blue", fAvgTotal: "Response time (total)",
      fApprovedToday: "Approved today", fPlanned: "Planned posts", fPublishedWeek: "Published this week", unitDays: "days", unitHours: "h",
      createTitle: "Create a new post", fTitle: "Title", fChannel: "Channel", fSchedule: "Scheduled on", fContent: "Content", saving: "Saving…", create: "Create",
    },
  },
  beitraege: {
    colAmpel: "Traffic light", colResponsible: "Owner", editAction: "Edit", submitReviewAction: "Send for approval",
    submitReviewShort: "For approval", markPublished: "Mark as published", archiveAction: "Archive", unarchiveAction: "Restore",
    newPost: "Create post", reminders: "Reminders", reminderConfigTitle: "Configure approval reminders", respAll: "All",
    internalNoteLabel: "Internal note (KEWAG only)", categoryLabel: "Category",
    ws: { zur_freigabe: "Awaiting your approval", freigegeben: "Approved", veroeffentlicht: "Published", aenderungswunsch: "Change request" },
    kpi: { alle: "All posts", zur_freigabe: "Awaiting approval", freigegeben: "Approved", veroeffentlicht: "Published", aenderungswunsch: "Change request" },
    noTenant: "No client assigned.",
    pageSubtitle: "All posts from {name} — review, approve and give feedback.",
    loadError: "Posts could not be loaded",
    ampelPrefix: "Traffic light: ",
    overdue: "Overdue", dueUntil: "Approve by",
    colTitle: "Title", colChannel: "Channel", colStatus: "Status", colPlanned: "Scheduled for", colActions: "Actions",
    untitled: "Untitled", notScheduled: "Not scheduled", emptyList: "No posts found.", previewAction: "Preview",
    allChannels: "All channels", search: "Search posts...", resetFilters: "Reset filters",
    countOne: "post", countMany: "posts",
    previewEmpty: "No post selected.", previewTitle: "Post preview",
    bodyLabel: "Post text", showMore: "Show more", showLess: "Show less",
    platforms: "Platforms", plannedTime: "Planned publishing time", customerNote: "Customer note",
    decTitle: "Your decision", decWaiting: "This post is awaiting your approval.",
    decNoAction: "No action pending.", decAskAnytime: "You can ask a question anytime.",
    decOverdue: "Overdue since {d} — please approve soon so publishing isn't delayed further.",
    decDueHint: "Please approve by {d}, otherwise publishing will be postponed.",
    decApprove: "Approve", decRequest: "Request change", decQuestion: "Question / comment",
    dlgRequestTitle: "Request change", dlgRequestDesc: "Please briefly describe what should be adjusted. The KEWAG team will take care of it.",
    phRequest: "Your change request…", submitRequest: "Send change request",
    dlgQuestionTitle: "Question / comment", dlgQuestionDesc: "Ask a question or leave a comment on this post.",
    phQuestion: "Your question or comment…", submitQuestion: "Send", actionFailed: "Action failed",
    historyTitle: "Status history", noEvents: "No events yet.", comments: "Comments", noComments: "No comments yet.",
    you: "You", kewagTeam: "KEWAG Team",
    toastApproved: "Approved — thank you!", toastRequested: "Change request sent", toastQuestion: "Your message has been sent",
    bulkWaitingOne: "post awaiting", bulkWaitingMany: "posts awaiting", bulkOnYou: "your approval",
    selected: "selected", selectBtn: "Select", approveAllN: "Approve all {n}", markAll: "Mark all",
    approveN: "Approve {n}", approveBtn: "Approve", requestChange: "Request change",
    bulkConfirmTitle: "Approve posts",
    bulkConfirmDesc: "Review the selection. You can deselect individual posts — only the checked posts will be approved for publishing by the KEWAG team.",
    bulkSelectedOf: "{a} of {b} {unit} selected", selectAll: "Select all", deselectAll: "Deselect all",
    noWaiting: "No waiting posts.", cancel: "Cancel",
    approvePostOne: "Approve 1 post", approvePostN: "Approve {n} posts",
    bulkResultTitle: "Bulk approval result", bulkResultDesc: "Not all posts could be approved. Below is the result per post.",
    rSelected: "Selected", rApproved: "Approved", rSkipped: "Skipped", rFailed: "Failed",
    requestSkipped: "Request revision for skipped", retry: "Try again", close: "Close",
    bulkRequestTitle: "Bulk change request",
    bulkRequestDesc: "Your note applies to all {n} selected posts. The KEWAG team will revise them accordingly.",
    phBulkRequest: "What should be adjusted on these posts?", sendChangeRequest: "Send change request",
    toastBulkApprovedOne: "1 post approved successfully.", toastBulkApprovedMany: "{n} posts approved successfully.",
    toastBulkNone: "No open post to revise – the posts are already completed.",
    toastBulkRequestedOne: "Change request sent for 1 post", toastBulkRequestedMany: "Change request sent for {n} posts",
    bulkApproveFailed: "Bulk approval failed", bulkRequestFailed: "Bulk change request failed",
    staff: {
      statusUpdated: "Status updated", statusChangeFailed: "Status change failed",
      archived: "Post archived", archiveFailed: "Archiving failed", unarchived: "Post restored", unarchiveFailed: "Restore failed",
      remindSentEmail: "Reminder sent for {posts} posts to {recipients} recipients", remindSentInApp: "In-app reminder sent for {posts} posts (email sending not configured)", remindFailed: "Reminder failed",
      settingsLoadFailed: "Settings could not be loaded", settingsSaved: "Reminder settings saved", saveFailed: "Saving failed",
      waitingOne: "post waiting", waitingMany: "posts waiting", onCustomerApproval: "for customer approval", remindCustomers: "Remind clients",
      reminderDialogTitle: "Approval reminders", reminderDialogDesc: "Control when and how often clients are automatically reminded of pending approvals.",
      autoRemindActive: "Automatic reminders active", daysToFirst: "Days until 1st reminder", intervalDays: "Interval (days)", maxCount: "Max. count",
      reminderExample: "Example: first reminder after {wait} day(s), then every {interval} day(s), at most {max}×.",
      dueLeadLabel: "Approval due: lead time before publication (days)", dueLeadHint: "Clients see “Please approve by DD.MM.” — {days} day(s) before the scheduled publication date.",
      cancel: "Cancel", save: "Save",
    },
  },
  freigaben: {
    title: "Traffic-light approvals",
    subtitle: "Your posts to approve – you decide, KEWAG delivers.",
    kpiWartet: "Awaiting approval",
    kpiAenderung: "Change requests",
    kpiHeute: "Due today",
    kpiMonat: "Approved this month",
    vsPrev: "vs prev. month",
    emptyTitle: "No posts to approve right now.",
    emptyDesc: "As soon as KEWAG prepares a post for you, it appears here.",
    allDoneTitle: "All done",
    allDoneDesc: "You've decided all open approvals. KEWAG will implement your decisions.",
    allDoneToast: "All done – no open approvals left.",
    progressLabel: "{done} of {total} done",
    inboxTitle: "Approval inbox",
    previewTitle: "Live preview",
    versionsMany: "Previous versions ({n})",
    versionsOne: "View approved version",
    selectPost: "Please select a post.",
    planned: "Scheduled",
    channels: "Channels",
    decisionTitle: "Decision & feedback",
    yourFeedback: "Your feedback",
    nextStep: "Next step",
    yourDecision: "Your decision",
    contactPerson: "Contact",
    appointment: "Due date",
    approve: "Approve",
    approveDesc: "Approve the content without changes.",
    conditions: "Approve with conditions",
    conditionsDesc: "Approve with a comment.",
    reject: "Don't approve",
    rejectDesc: "Send a change request.",
    readOnlyNote: "Read-only mode (customer view) – actions disabled.",
    cannotDecide: "Your role can't approve posts (view only).",
    doneApproved: "You have approved this post.",
    donePublished: "This post has been published.",
    doneChangeRequested: "Change request sent – KEWAG is revising the post.",
    historyTitle: "Approval history",
    noHistory: "No history yet.",
    trustTitle: "Checked by KEWAG",
    trustDesc: "Before your approval, every post is checked by KEWAG for image & video quality, text, branding, links and call-to-action.",
    detailsTitle: "Details",
    createdBy: "Created by",
    kewagTeam: "KEWAG Team",
    plannedOn: "Scheduled for",
    attachment: "Attachment",
    oneImage: "1 image",
    versionHistoryTitle: "Approval history",
    versionHistoryDesc: "The versions KEWAG has provided to you for approval. So you can always see what you received in each round.",
    noVersions: "No versions available.",
    version: "Version",
    current: "current",
    firstVersion: "First provided version",
    minorChanges: "Minor adjustments",
    adjusted: "{parts} adjusted",
    comparedTo: "Compared to version {n}:",
    provided: "Provided",
    scheduledShort: "Scheduled",
    note: "Note",
    changes: { text: "Text", image: "Image", appointment: "Due date", channels: "Channels", category: "Category", note: "Note" },
    dlgRejectTitle: "Send change request",
    dlgConditionsTitle: "Approve with conditions",
    dlgRejectDesc: "What should be changed? Your note goes directly to KEWAG (required).",
    dlgConditionsDesc: "Optional note / condition. The post is approved and your comment sent to KEWAG.",
    phReject: "Your change request…",
    phConditions: "Your condition / note…",
    submitReject: "Send change request",
    submitConditions: "Approve with conditions",
    toastConditions: "Approved with conditions – KEWAG has been informed.",
    toastRejected: "Change request sent.",
    toastApproved: "Post approved.",
    due: { none: "No due date", overdue: "Overdue", today: "Due today" },
    events: { provided_for_approval: "Provided for approval", approved: "Approved", published: "Published", change_requested: "Change request sent" },
  },
  medien: {
    docTitle: "SocialCheck – Media (Jury Demo)",
    title: "Media demo",
    subtitle: "Sample media library of the demo. Uploads and deletions are disabled in the jury demo.",
    badge: "View only · isolated demo data",
    empty: "No media available.",
    kindImage: "Image",
  },
  report: {
    empty: "No client selected.",
    loading: "Loading…",
    title: "Monthly report",
    month: "Month",
    downloadPdf: "Download PDF",
    creating: "Creating…",
    emailSend: "Send by email",
    sending: "Sending…",
    emailNotConnected: "By email (Brevo not connected)",
    emailSendTitle: "Send to {email}",
    noContactTitle: "No contact stored",
    brevoNotConnectedTitle: "Brevo (email) not connected yet",
    goalTitle: "Monthly goal",
    reached: "reached",
    goalPlanned: "posts planned",
    goalPublished: "published",
    goalChangeReqOpen: "change request open",
    goalQuestions: "questions",
    progress: "Progress",
    waitOne: "post awaiting",
    waitMany: "posts awaiting",
    waitSuffix: "your approval",
    reportMonthBar: "Reporting month {month} · only open (orange) posts of this month",
    approveAllBtn: "Approve all open posts of this month",
    kpiTotal: "Total posts",
    kpiChangeReq: "Change requests",
    kpiForApproval: "For approval",
    kpiApproved: "Approved",
    kpiPublished: "Published",
    vs: "vs.",
    tabs: { uebersicht: "Overview", beitraege: "Posts", kanaele: "Channels", engagement: "Engagement", performance: "Performance", bestzeiten: "Best times", ziele: "Goals", downloads: "Downloads" },
    allChannels: "All channels",
    allPlatforms: "All platforms",
    allAmpel: "All traffic lights",
    ampelFilter: { rot: "Red — change request / blocker", blau: "Blue — open question / clarification", orange: "Orange — awaiting approval", gruen: "Green — approved", neutral: "Neutral — no decision" },
    allStatus: "All statuses",
    allResponsible: "All responsibles",
    searchTitles: "Search titles…",
    resetFilters: "Reset filters",
    ampelStatusTitle: "Traffic light & status",
    shortOverview: "Quick overview:",
    ofPosts: "Of {total} posts —",
    yourDecisions: "Your decisions:",
    publication: "Publication:",
    ampelColTitle: "Traffic light — your decision",
    veroeffColTitle: "Publication status",
    noPostsMonth: "No posts this month.",
    ampelStatusNote: "The traffic light shows your decision, the status shows where your post is in the process — the two are independent. “Published” is a status, not a traffic light.",
    ampelMeaning: { rot: "Change request / blocker", blau: "Open question / clarification", orange: "Awaiting your approval", gruen: "Current version approved", neutral: "No active decision" },
    plainAmpel: { gruen: "approved by you", orangeOne: "awaiting your approval", orangeMany: "awaiting your approval", rot: "with change request", blau: "with open question", neutral: "without open decision", empty: "no open decisions" },
    plainStatus: { veroeffentlicht: "published", geplant: "scheduled", freigegeben: "approved (ready)", zur_pruefung: "for review", in_bearbeitung: "in progress", in_vorbereitung: "in preparation", kewag_pruefung: "in KEWAG review", abgeschlossen: "completed", empty: "no posts" },
    postsInPrefix: "Posts in",
    viewTable: "Table",
    viewCalendar: "Calendar",
    noPostsFound: "No posts found.",
    colTitlePreview: "Title / preview",
    colChannels: "Channels",
    colAmpelDecision: "Traffic light – your decision",
    colStatus: "Status",
    colResponsible: "Responsible",
    colPlanned: "Scheduled",
    colReach: "Reach",
    colActions: "Actions",
    detailsTitle: "Post details",
    detailsAria: "View details",
    detailsClose: "Close",
    goApprove: "Go to approval",
    openCalendar: "Open in calendar",
    detailExcerpt: "Preview",
    reachLabel: "Reach",
    interactionsLabel: "Interactions",
    paginationUnit: "posts",
    scheduledShort: "scheduled",
    untitled: "Untitled",
    postsCenter: "posts",
    reachTotal: "Total reach",
    interactionsTotal: "Total interactions",
    avgEngagement: "Avg. engagement rate",
    bestTimeLabel: "Best time of day",
    plannedNext7: "Scheduled next 7 days",
    openTasks: "Open tasks",
    openTasksLabel: "For approval / feedback",
    statNotCaptured: "Not captured yet — analytics not connected.",
    notConnectedNote: "Analytics (Meta/Instagram) not connected yet — values are shown live once connected.",
    planned: "Scheduled",
    published: "Published",
    changeReqOpen: "Change request open",
    questionsOpen: "Open questions",
    downloadsTitle: "Downloads & export",
    dlPdfBtn: "Download PDF report",
    dlCsvBtn: "Posts as CSV",
    downloadsNote: "The PDF report contains the metrics, the goal and the post list for {month}.",
    distTitle: "Post distribution by status",
    distLabels: { freigegeben: "Approved", frage_kommentar: "Question / comment", zur_freigabe: "For approval", aenderungswunsch: "Change request" },
    platformTitle: "Publications by platform",
    notBooked: "not booked",
    notBookedTitle: "Channel currently not booked — available as an add-on channel.",
    bookedChannels: "Booked channels:",
    topPostTitle: "Top post by reach",
    topPostEmpty: "Not captured yet — analytics (Meta/Instagram) not connected.",
    reach: "Reach",
    interactions: "Interactions",
    publishedOn: "Published on",
    hintsTitle: "Notes & recommendations",
    hints: { engagement: "Engagement rate: {pct} % in the period.", feedback_waiting: "{n} post(s) awaiting customer feedback.", best_time: "Best time: {time}.", analytics_off: "Reach/engagement are shown once Meta/Instagram is connected.", none: "No notable observations this month." },
    emailToCustomer: "Report by email to customer",
    recipient: "Recipient:",
    lastSent: "last sent",
    noContactEmail: "No customer contact with email stored.",
    brevoNotConnectedFull: "Brevo (email) not connected yet — sending becomes active once connected.",
    autoMonthly: "Automatic monthly send at month-end",
    lastUpdate: "Last update:",
    refresh: "Refresh",
    dlgDoneTitle: "Approval completed",
    dlgApproveTitleOne: "Approve {n} post of this month?",
    dlgApproveTitleMany: "Approve {n} posts of this month?",
    customerLabel: "Customer:",
    reportMonthLabel: "Reporting month:",
    dlgIntro: "You are approving the selected post versions for scheduling or publishing. If content is changed later, your approval will be required again.",
    selectedOf: "{a} of {b} selected",
    selAll: "All",
    selNone: "None",
    versionBinding: "Version binding: exactly the currently displayed version is approved. If a post was changed in the meantime, it is skipped and must be reviewed again.",
    resApproved: "approved",
    resSkipped: "skipped",
    resFailed: "failed",
    resApprovedItem: "Approved",
    cancel: "Cancel",
    confirmOne: "Approve {n} post bindingly",
    confirmMany: "Approve {n} posts bindingly",
    approving: "Approving…",
    close: "Close",
    tReportLoadFail: "The report could not be loaded.",
    tPdfCreated: "PDF created",
    tPdfFail: "PDF creation failed",
    tCsvExported: "CSV exported",
    tNoContact: "No customer contact with email stored.",
    tReportSent: "Report sent.",
    tSendFail: "Sending failed",
    tAutoOn: "Automatic monthly send activated.",
    tAutoOff: "Automatic send deactivated.",
    tSaveFail: "Could not save",
    tApprovedOne: "1 post approved",
    tApprovedMany: "{n} posts approved",
    tApproveNone: "No posts approved — see dialog for details.",
    tApproveFail: "Approval failed.",
    csvHeaders: ["Title", "Channels", "Traffic light (your decision)", "Status", "Responsible", "Scheduled", "Reach", "Interactions"],
    months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    locale: "en-GB",
  },
};

export const juryTranslations = { de, fr, it, en };
